import { country } from '@/data/datasources/mock/countries';

interface DepartmentProps {
  id: number;
  description: string;
  state: string;
  DESCR: string;
}

interface ProvinceProps extends DepartmentProps {
  departmentId: number;
  MBO_PROVINCIA: string;
}

interface DistrictProps extends DepartmentProps {
  provinceId: number;
  MBO_PROVINCIA: string;
  MBO_DISTRITO: string;
}

const DEPARTMENTS: DepartmentProps[] = [
  {
    id: 1,
    description: 'Amazonas',
    state: '01',
    DESCR: 'AMAZONAS'
  },
  {
    id: 2,
    description: 'Ancash',
    state: '02',
    DESCR: 'ANCASH'
  },
  {
    id: 3,
    description: 'Apurimac',
    state: '03',
    DESCR: 'APURIMAC'
  },
  {
    id: 4,
    description: 'Arequipa',
    state: '04',
    DESCR: 'AREQUIPA'
  },
  {
    id: 5,
    description: 'Ayacucho',
    state: '05',
    DESCR: 'AYACUCHO'
  },
  {
    id: 6,
    description: 'Cajamarca',
    state: '06',
    DESCR: 'CAJAMARCA'
  },
  {
    id: 7,
    description: 'Callao',
    state: '24',
    DESCR: 'CALLAO'
  },
  {
    id: 8,
    description: 'Cusco',
    state: '07',
    DESCR: 'CUSCO'
  },
  {
    id: 9,
    description: 'Huancavelica',
    state: '08',
    DESCR: 'HUANCAVELICA'
  },
  {
    id: 10,
    description: 'Huanuco',
    state: '09',
    DESCR: 'HUANUCO'
  },
  {
    id: 11,
    description: 'Ica',
    state: '10',
    DESCR: 'ICA'
  },
  {
    id: 12,
    description: 'Junin',
    state: '11',
    DESCR: 'JUNIN'
  },
  {
    id: 13,
    description: 'La Libertad',
    state: '12',
    DESCR: 'LA LIBERTAD'
  },
  {
    id: 14,
    description: 'Lambayeque',
    state: '13',
    DESCR: 'LAMBAYEQUE'
  },
  {
    id: 15,
    description: 'Lima',
    state: '14',
    DESCR: 'LIMA'
  },
  {
    id: 16,
    description: 'Loreto',
    state: '15',
    DESCR: 'LORETO'
  },
  {
    id: 17,
    description: 'Madre de Dios',
    state: '16',
    DESCR: 'MADRE DE DIOS'
  },
  {
    id: 18,
    description: 'Moquegua',
    state: '17',
    DESCR: 'MOQUEGUA'
  },
  {
    id: 19,
    description: 'Pasco',
    state: '18',
    DESCR: 'PASCO'
  },
  {
    id: 20,
    description: 'Piura',
    state: '19',
    DESCR: 'PIURA'
  },
  {
    id: 21,
    description: 'Puno',
    state: '20',
    DESCR: 'PUNO'
  },
  {
    id: 22,
    description: 'San Martín',
    state: '21',
    DESCR: 'SAN MARTIN'
  },
  {
    id: 23,
    description: 'Tacna',
    state: '22',
    DESCR: 'TACNA'
  },
  {
    id: 24,
    description: 'Tumbes',
    state: '23',
    DESCR: 'TUMBES'
  },
  {
    id: 25,
    description: 'Ucayali',
    state: '25',
    DESCR: 'UCAYALI'
  }
];

const PROVINCES: ProvinceProps[] = [
  {
    id: 1,
    departmentId: 1,
    description: 'Chachapoyas',
    state: '01',
    MBO_PROVINCIA: '01',
    DESCR: 'CHACHAPOYAS'
  },
  {
    id: 2,
    departmentId: 2,
    description: 'Huaraz',
    state: '02',
    MBO_PROVINCIA: '01',
    DESCR: 'HUARAZ'
  },
  {
    id: 3,
    departmentId: 3,
    description: 'Abancay',
    state: '03',
    MBO_PROVINCIA: '01',
    DESCR: 'ABANCAY'
  },
  {
    id: 4,
    departmentId: 4,
    description: 'Arequipa',
    state: '04',
    MBO_PROVINCIA: '01',
    DESCR: 'AREQUIPA'
  },
  {
    id: 5,
    departmentId: 5,
    description: 'Huamanga',
    state: '05',
    MBO_PROVINCIA: '01',
    DESCR: 'HUAMANGA'
  },
  {
    id: 6,
    departmentId: 6,
    description: 'Cajamarca',
    state: '06',
    MBO_PROVINCIA: '01',
    DESCR: 'CAJAMARCA'
  },
  {
    id: 7,
    departmentId: 7,
    description: 'Callao',
    state: '24',
    MBO_PROVINCIA: '01',
    DESCR: 'CALLAO'
  },
  {
    id: 8,
    departmentId: 8,
    description: 'Cusco',
    state: '07',
    MBO_PROVINCIA: '01',
    DESCR: 'CUSCO'
  },
  {
    id: 9,
    departmentId: 9,
    description: 'Huancavelica',
    state: '08',
    MBO_PROVINCIA: '01',
    DESCR: 'HUANCAVELICA'
  },
  {
    id: 10,
    departmentId: 10,
    description: 'Huanuco',
    state: '09',
    MBO_PROVINCIA: '01',
    DESCR: 'HUANUCO'
  },
  {
    id: 11,
    departmentId: 11,
    description: 'Ica',
    state: '10',
    MBO_PROVINCIA: '01',
    DESCR: 'ICA'
  },
  {
    id: 12,
    departmentId: 12,
    description: 'Huancayo',
    state: '11',
    MBO_PROVINCIA: '01',
    DESCR: 'HUANCAYO'
  },
  {
    id: 13,
    departmentId: 13,
    description: 'Trujillo',
    state: '12',
    MBO_PROVINCIA: '01',
    DESCR: 'TRUJILLO'
  },
  {
    id: 14,
    departmentId: 14,
    description: 'Chiclayo',
    state: '13',
    MBO_PROVINCIA: '01',
    DESCR: 'CHICLAYO'
  },
  {
    id: 15,
    departmentId: 15,
    description: 'Lima',
    state: '14',
    MBO_PROVINCIA: '01',
    DESCR: 'LIMA'
  },
  {
    id: 16,
    departmentId: 16,
    description: 'Maynas',
    state: '15',
    MBO_PROVINCIA: '01',
    DESCR: 'MAYNAS'
  },
  {
    id: 17,
    departmentId: 17,
    description: 'Tambopata',
    state: '16',
    MBO_PROVINCIA: '01',
    DESCR: 'TAMBOPATA'
  },
  {
    id: 18,
    departmentId: 18,
    description: 'Mariscal Nieto',
    state: '17',
    MBO_PROVINCIA: '01',
    DESCR: 'MARISCAL NIETO'
  },
  {
    id: 19,
    departmentId: 19,
    description: 'Pasco',
    state: '18',
    MBO_PROVINCIA: '01',
    DESCR: 'PASCO'
  },
  {
    id: 20,
    departmentId: 20,
    description: 'Piura',
    state: '19',
    MBO_PROVINCIA: '01',
    DESCR: 'PIURA'
  },
  {
    id: 21,
    departmentId: 21,
    description: 'Puno',
    state: '20',
    MBO_PROVINCIA: '01',
    DESCR: 'PUNO'
  },
  {
    id: 22,
    departmentId: 22,
    description: 'Moyobamba',
    state: '21',
    MBO_PROVINCIA: '01',
    DESCR: 'MOYOBAMBA'
  },
  {
    id: 23,
    departmentId: 23,
    description: 'Tacna',
    state: '22',
    MBO_PROVINCIA: '01',
    DESCR: 'TACNA'
  },
  {
    id: 24,
    departmentId: 24,
    description: 'Tumbes',
    state: '23',
    MBO_PROVINCIA: '01',
    DESCR: 'TUMBES'
  },
  {
    id: 25,
    departmentId: 25,
    description: 'Coronel Portillo',
    state: '25',
    MBO_PROVINCIA: '01',
    DESCR: 'CORONEL PORTILLO'
  },
  {
    id: 26,
    departmentId: 1,
    description: 'Bagua',
    state: '01',
    MBO_PROVINCIA: '02',
    DESCR: 'BAGUA'
  },
  {
    id: 27,
    departmentId: 2,
    description: 'Aija',
    state: '02',
    MBO_PROVINCIA: '02',
    DESCR: 'AIJA'
  },
  {
    id: 28,
    departmentId: 3,
    description: 'Andahuaylas',
    state: '03',
    MBO_PROVINCIA: '03',
    DESCR: 'ANDAHUAYLAS'
  },
  {
    id: 29,
    departmentId: 4,
    description: 'Camana',
    state: '04',
    MBO_PROVINCIA: '03',
    DESCR: 'CAMANA'
  },
  {
    id: 30,
    departmentId: 5,
    description: 'Cangallo',
    state: '05',
    MBO_PROVINCIA: '02',
    DESCR: 'CANGALLO'
  },
  {
    id: 31,
    departmentId: 6,
    description: 'Cajabamba',
    state: '06',
    MBO_PROVINCIA: '02',
    DESCR: 'CAJABAMBA'
  },
  {
    id: 32,
    departmentId: 8,
    description: 'Acomayo',
    state: '07',
    MBO_PROVINCIA: '02',
    DESCR: 'ACOMAYO'
  },
  {
    id: 33,
    departmentId: 9,
    description: 'Acobamba',
    state: '08',
    MBO_PROVINCIA: '02',
    DESCR: 'ACOBAMBA'
  },
  {
    id: 34,
    departmentId: 10,
    description: 'Ambo',
    state: '09',
    MBO_PROVINCIA: '02',
    DESCR: 'AMBO'
  },
  {
    id: 35,
    departmentId: 11,
    description: 'Chincha',
    state: '10',
    MBO_PROVINCIA: '02',
    DESCR: 'CHINCHA'
  },
  {
    id: 36,
    departmentId: 12,
    description: 'Concepcion',
    state: '11',
    MBO_PROVINCIA: '02',
    DESCR: 'CONCEPCION'
  },
  {
    id: 37,
    departmentId: 13,
    description: 'Ascope',
    state: '12',
    MBO_PROVINCIA: '08',
    DESCR: 'ASCOPE'
  },
  {
    id: 38,
    departmentId: 14,
    description: 'Ferreñafe',
    state: '13',
    MBO_PROVINCIA: '02',
    DESCR: 'FERRENAFE'
  },
  {
    id: 39,
    departmentId: 15,
    description: 'Barranca',
    state: '14',
    MBO_PROVINCIA: '09',
    DESCR: 'BARRANCA'
  },
  {
    id: 40,
    departmentId: 16,
    description: 'Alto Amazonas',
    state: '15',
    MBO_PROVINCIA: '02',
    DESCR: 'ALTO AMAZONAS'
  },
  {
    id: 41,
    departmentId: 17,
    description: 'Manu',
    state: '16',
    MBO_PROVINCIA: '02',
    DESCR: 'MANU'
  },
  {
    id: 42,
    departmentId: 18,
    description: 'General Sanchez Cerro',
    state: '17',
    MBO_PROVINCIA: '02',
    DESCR: 'GENERAL SANCHEZ CERRO'
  },
  {
    id: 43,
    departmentId: 19,
    description: 'Daniel Alcides Carrión',
    state: '18',
    MBO_PROVINCIA: '02',
    DESCR: 'DANIEL ALCIDES CARRION'
  },
  {
    id: 44,
    departmentId: 20,
    description: 'Ayabaca',
    state: '19',
    MBO_PROVINCIA: '02',
    DESCR: 'AYABACA'
  },
  {
    id: 45,
    departmentId: 21,
    description: 'Azangaro',
    state: '20',
    MBO_PROVINCIA: '02',
    DESCR: 'AZANGARO'
  },
  {
    id: 46,
    departmentId: 22,
    description: 'Bellavista',
    state: '21',
    MBO_PROVINCIA: '07',
    DESCR: 'BELLAVISTA'
  },
  {
    id: 47,
    departmentId: 23,
    description: 'Candarave',
    state: '22',
    MBO_PROVINCIA: '04',
    DESCR: 'CANDARAVE'
  },
  {
    id: 48,
    departmentId: 24,
    description: 'Contralmirante Villar',
    state: '23',
    MBO_PROVINCIA: '02',
    DESCR: 'CONTRALMIRANTE VILLAR'
  },
  {
    id: 49,
    departmentId: 25,
    description: 'Atalaya',
    state: '25',
    MBO_PROVINCIA: '03',
    DESCR: 'ATALAYA'
  },
  {
    id: 50,
    departmentId: 1,
    description: 'Bongara',
    state: '01',
    MBO_PROVINCIA: '03',
    DESCR: 'BONGARA'
  },
  {
    id: 51,
    departmentId: 2,
    description: 'Antonio Raymondi',
    state: '02',
    MBO_PROVINCIA: '16',
    DESCR: 'ANTONIO RAIMONDI'
  },
  {
    id: 52,
    departmentId: 3,
    description: 'Antabamba',
    state: '03',
    MBO_PROVINCIA: '04',
    DESCR: 'ANTABAMBA'
  },
  {
    id: 53,
    departmentId: 4,
    description: 'Caraveli',
    state: '04',
    MBO_PROVINCIA: '04',
    DESCR: 'CARAVELI'
  },
  {
    id: 54,
    departmentId: 5,
    description: 'Huanca Sancos',
    state: '05',
    MBO_PROVINCIA: '08',
    DESCR: 'HUANCA SANCOS'
  },
  {
    id: 55,
    departmentId: 6,
    description: 'Celendin',
    state: '06',
    MBO_PROVINCIA: '03',
    DESCR: 'CELENDIN'
  },
  {
    id: 56,
    departmentId: 8,
    description: 'Anta',
    state: '07',
    MBO_PROVINCIA: '03',
    DESCR: 'ANTA'
  },
  {
    id: 57,
    departmentId: 9,
    description: 'Angaraes',
    state: '08',
    MBO_PROVINCIA: '03',
    DESCR: 'ANGARAES'
  },
  {
    id: 58,
    departmentId: 10,
    description: 'Dos de Mayo',
    state: '09',
    MBO_PROVINCIA: '03',
    DESCR: 'DOS DE MAYO'
  },
  {
    id: 59,
    departmentId: 11,
    description: 'Nazca',
    state: '10',
    MBO_PROVINCIA: '03',
    DESCR: 'NAZCA'
  },
  {
    id: 60,
    departmentId: 12,
    description: 'Chanchamayo',
    state: '11',
    MBO_PROVINCIA: '08',
    DESCR: 'CHANCHAMAYO'
  },
  {
    id: 61,
    departmentId: 13,
    description: 'Bolivar',
    state: '12',
    MBO_PROVINCIA: '02',
    DESCR: 'BOLIVAR'
  },
  {
    id: 62,
    departmentId: 14,
    description: 'Lambayeque',
    state: '13',
    MBO_PROVINCIA: '03',
    DESCR: 'LAMBAYEQUE'
  },
  {
    id: 63,
    departmentId: 15,
    description: 'Cajatambo',
    state: '14',
    MBO_PROVINCIA: '02',
    DESCR: 'CAJATAMBO'
  },
  {
    id: 64,
    departmentId: 16,
    description: 'Loreto',
    state: '15',
    MBO_PROVINCIA: '03',
    DESCR: 'LORETO'
  },
  {
    id: 65,
    departmentId: 17,
    description: 'Tahuamanu',
    state: '16',
    MBO_PROVINCIA: '03',
    DESCR: 'TAHUAMANU'
  },
  {
    id: 66,
    departmentId: 18,
    description: 'Ilo',
    state: '17',
    MBO_PROVINCIA: '03',
    DESCR: 'ILO'
  },
  {
    id: 67,
    departmentId: 19,
    description: 'Oxapampa',
    state: '18',
    MBO_PROVINCIA: '03',
    DESCR: 'OXAPAMPA'
  },
  {
    id: 68,
    departmentId: 20,
    description: 'Huancabamba',
    state: '19',
    MBO_PROVINCIA: '03',
    DESCR: 'HUANCABAMBA'
  },
  {
    id: 69,
    departmentId: 21,
    description: 'Carabaya',
    state: '20',
    MBO_PROVINCIA: '03',
    DESCR: 'CARABAYA'
  },
  {
    id: 70,
    departmentId: 22,
    description: 'El Dorado',
    state: '21',
    MBO_PROVINCIA: '10',
    DESCR: 'EL DORADO'
  },
  {
    id: 71,
    departmentId: 23,
    description: 'Jorge Basadre',
    state: '22',
    MBO_PROVINCIA: '03',
    DESCR: 'JORGE BASADRE'
  },
  {
    id: 72,
    departmentId: 24,
    description: 'Zarumilla',
    state: '23',
    MBO_PROVINCIA: '03',
    DESCR: 'ZARUMILLA'
  },
  {
    id: 73,
    departmentId: 25,
    description: 'Padre Abad',
    state: '25',
    MBO_PROVINCIA: '02',
    DESCR: 'PADRE ABAD'
  },
  {
    id: 74,
    departmentId: 1,
    description: 'Condorcanqui',
    state: '01',
    MBO_PROVINCIA: '06',
    DESCR: 'CONDORCANQUI'
  },
  {
    id: 75,
    departmentId: 2,
    description: 'Asuncion',
    state: '02',
    MBO_PROVINCIA: '18',
    DESCR: 'ASUNCION'
  },
  {
    id: 76,
    departmentId: 3,
    description: 'Aymaraes',
    state: '03',
    MBO_PROVINCIA: '02',
    DESCR: 'AYMARAES'
  },
  {
    id: 77,
    departmentId: 4,
    description: 'Castilla',
    state: '04',
    MBO_PROVINCIA: '05',
    DESCR: 'CASTILLA'
  },
  {
    id: 78,
    departmentId: 5,
    description: 'Huanta',
    state: '05',
    MBO_PROVINCIA: '03',
    DESCR: 'HUANTA'
  },
  {
    id: 79,
    departmentId: 6,
    description: 'Chota',
    state: '06',
    MBO_PROVINCIA: '06',
    DESCR: 'CHOTA'
  },
  {
    id: 80,
    departmentId: 8,
    description: 'Calca',
    state: '07',
    MBO_PROVINCIA: '04',
    DESCR: 'CALCA'
  },
  {
    id: 81,
    departmentId: 9,
    description: 'Castrovirreyna',
    state: '08',
    MBO_PROVINCIA: '04',
    DESCR: 'CASTROVIRREYNA'
  },
  {
    id: 82,
    departmentId: 10,
    description: 'Huacaybamba',
    state: '09',
    MBO_PROVINCIA: '09',
    DESCR: 'HUACAYBAMBA'
  },
  {
    id: 83,
    departmentId: 11,
    description: 'Palpa',
    state: '10',
    MBO_PROVINCIA: '05',
    DESCR: 'PALPA'
  },
  {
    id: 84,
    departmentId: 12,
    description: 'Jauja',
    state: '11',
    MBO_PROVINCIA: '03',
    DESCR: 'JAUJA'
  },
  {
    id: 85,
    departmentId: 13,
    description: 'Chepen',
    state: '12',
    MBO_PROVINCIA: '09',
    DESCR: 'CHEPEN'
  },
  {
    id: 86,
    departmentId: 15,
    description: 'Canta',
    state: '14',
    MBO_PROVINCIA: '03',
    DESCR: 'CANTA'
  },
  {
    id: 87,
    departmentId: 16,
    description: 'Mariscal Ramon Castilla',
    state: '15',
    MBO_PROVINCIA: '06',
    DESCR: 'MARISCAL RAMON CASTILLA'
  },
  {
    id: 88,
    departmentId: 20,
    description: 'Morropon',
    state: '19',
    MBO_PROVINCIA: '04',
    DESCR: 'MORROPON'
  },
  {
    id: 89,
    departmentId: 21,
    description: 'Chucuito',
    state: '20',
    MBO_PROVINCIA: '04',
    DESCR: 'CHUCUITO'
  },
  {
    id: 90,
    departmentId: 22,
    description: 'Huallaga',
    state: '21',
    MBO_PROVINCIA: '02',
    DESCR: 'HUALLAGA'
  },
  {
    id: 91,
    departmentId: 23,
    description: 'Tarata',
    state: '22',
    MBO_PROVINCIA: '02',
    DESCR: 'TARATA'
  },
  {
    id: 92,
    departmentId: 25,
    description: 'Purus',
    state: '25',
    MBO_PROVINCIA: '04',
    DESCR: 'PURUS'
  },
  {
    id: 93,
    departmentId: 1,
    description: 'Luya',
    state: '01',
    MBO_PROVINCIA: '04',
    DESCR: 'LUYA'
  },
  {
    id: 94,
    departmentId: 2,
    description: 'Bolognesi',
    state: '02',
    MBO_PROVINCIA: '03',
    DESCR: 'BOLOGNESI'
  },
  {
    id: 95,
    departmentId: 3,
    description: 'Cotabambas',
    state: '03',
    MBO_PROVINCIA: '05',
    DESCR: 'COTABAMBAS'
  },
  {
    id: 96,
    departmentId: 4,
    description: 'Caylloma',
    state: '04',
    MBO_PROVINCIA: '02',
    DESCR: 'CAYLLOMA'
  },
  {
    id: 97,
    departmentId: 5,
    description: 'La mar',
    state: '05',
    MBO_PROVINCIA: '04',
    DESCR: 'LA MAR'
  },
  {
    id: 98,
    departmentId: 6,
    description: 'Contumaza',
    state: '06',
    MBO_PROVINCIA: '04',
    DESCR: 'CONTUMAZA'
  },
  {
    id: 99,
    departmentId: 8,
    description: 'Canas',
    state: '07',
    MBO_PROVINCIA: '05',
    DESCR: 'CANAS'
  },
  {
    id: 100,
    departmentId: 9,
    description: 'Churcampa',
    state: '08',
    MBO_PROVINCIA: '07',
    DESCR: 'CHURCAMPA'
  },
  {
    id: 101,
    departmentId: 10,
    description: 'Huamalies',
    state: '09',
    MBO_PROVINCIA: '04',
    DESCR: 'HUAMALIES'
  },
  {
    id: 102,
    departmentId: 11,
    description: 'Pisco',
    state: '10',
    MBO_PROVINCIA: '04',
    DESCR: 'PISCO'
  },
  {
    id: 103,
    departmentId: 12,
    description: 'Junin',
    state: '11',
    MBO_PROVINCIA: '04',
    DESCR: 'JUNIN'
  },
  {
    id: 104,
    departmentId: 13,
    description: 'Julcan',
    state: '12',
    MBO_PROVINCIA: '10',
    DESCR: 'JULCAN'
  },
  {
    id: 105,
    departmentId: 15,
    description: 'Cañete',
    state: '14',
    MBO_PROVINCIA: '04',
    DESCR: 'CANETE'
  },
  {
    id: 106,
    departmentId: 16,
    description: 'Requena',
    state: '15',
    MBO_PROVINCIA: '04',
    DESCR: 'REQUENA'
  },
  {
    id: 107,
    departmentId: 20,
    description: 'Paita',
    state: '19',
    MBO_PROVINCIA: '05',
    DESCR: 'PAITA'
  },
  {
    id: 108,
    departmentId: 21,
    description: 'El collao',
    state: '20',
    MBO_PROVINCIA: '12',
    DESCR: 'EL COLLAO'
  },
  {
    id: 109,
    departmentId: 22,
    description: 'Lamas',
    state: '21',
    MBO_PROVINCIA: '03',
    DESCR: 'LAMAS'
  },
  {
    id: 110,
    departmentId: 1,
    description: 'Rodriguez de Mendoza',
    state: '01',
    MBO_PROVINCIA: '05',
    DESCR: 'RODRIGUEZ DE MENDOZA'
  },
  {
    id: 111,
    departmentId: 2,
    description: 'Carhuaz',
    state: '02',
    MBO_PROVINCIA: '04',
    DESCR: 'CARHUAZ'
  },
  {
    id: 112,
    departmentId: 3,
    description: 'Chincheros',
    state: '03',
    MBO_PROVINCIA: '07',
    DESCR: 'CHINCHEROS'
  },
  {
    id: 113,
    departmentId: 4,
    description: 'Condesuyos',
    state: '04',
    MBO_PROVINCIA: '06',
    DESCR: 'CONDESUYOS'
  },
  {
    id: 114,
    departmentId: 5,
    description: 'Lucanas',
    state: '05',
    MBO_PROVINCIA: '05',
    DESCR: 'LUCANAS'
  },
  {
    id: 115,
    departmentId: 6,
    description: 'Cutervo',
    state: '06',
    MBO_PROVINCIA: '05',
    DESCR: 'CUTERVO'
  },
  {
    id: 116,
    departmentId: 8,
    description: 'Canchis',
    state: '07',
    MBO_PROVINCIA: '06',
    DESCR: 'CANCHIS'
  },
  {
    id: 117,
    departmentId: 9,
    description: 'Huaytara',
    state: '08',
    MBO_PROVINCIA: '06',
    DESCR: 'HUAYTARA'
  },
  {
    id: 118,
    departmentId: 10,
    description: 'Leoncio Prado',
    state: '09',
    MBO_PROVINCIA: '06',
    DESCR: 'LEONCIO PRADO'
  },
  {
    id: 119,
    departmentId: 12,
    description: 'Satipo',
    state: '11',
    MBO_PROVINCIA: '07',
    DESCR: 'SATIPO'
  },
  {
    id: 120,
    departmentId: 13,
    description: 'Otuzco',
    state: '12',
    MBO_PROVINCIA: '04',
    DESCR: 'OTUZCO'
  },
  {
    id: 121,
    departmentId: 15,
    description: 'Huaral',
    state: '14',
    MBO_PROVINCIA: '08',
    DESCR: 'HUARAL'
  },
  {
    id: 122,
    departmentId: 16,
    description: 'Ucayali',
    state: '15',
    MBO_PROVINCIA: '05',
    DESCR: 'UCAYALI'
  },
  {
    id: 123,
    departmentId: 20,
    description: 'Sullana',
    state: '19',
    MBO_PROVINCIA: '06',
    DESCR: 'SULLANA'
  },
  {
    id: 124,
    departmentId: 21,
    description: 'Huancane',
    state: '20',
    MBO_PROVINCIA: '05',
    DESCR: 'HUANCANE'
  },
  {
    id: 125,
    departmentId: 22,
    description: 'Mariscal Cáceres',
    state: '21',
    MBO_PROVINCIA: '04',
    DESCR: 'MARISCAL CACERES'
  },
  {
    id: 126,
    departmentId: 1,
    description: 'Utcubamba',
    state: '01',
    MBO_PROVINCIA: '07',
    DESCR: 'UTCUBAMBA'
  },
  {
    id: 127,
    departmentId: 2,
    description: 'Carlos F. Fitzcarrald',
    state: '02',
    MBO_PROVINCIA: '17',
    DESCR: 'CARLOS FERMIN FITZCARRALD'
  },
  {
    id: 128,
    departmentId: 3,
    description: 'Grau',
    state: '03',
    MBO_PROVINCIA: '06',
    DESCR: 'GRAU'
  },
  {
    id: 129,
    departmentId: 4,
    description: 'Islay',
    state: '04',
    MBO_PROVINCIA: '07',
    DESCR: 'ISLAY'
  },
  {
    id: 130,
    departmentId: 5,
    description: 'Parinacochas',
    state: '05',
    MBO_PROVINCIA: '06',
    DESCR: 'PARINACOCHAS'
  },
  {
    id: 131,
    departmentId: 6,
    description: 'Hualgayoc',
    state: '06',
    MBO_PROVINCIA: '07',
    DESCR: 'HUALGAYOC'
  },
  {
    id: 132,
    departmentId: 8,
    description: 'Chumbivilcas',
    state: '07',
    MBO_PROVINCIA: '07',
    DESCR: 'CHUMBIVILCAS'
  },
  {
    id: 133,
    departmentId: 9,
    description: 'Tayacaja',
    state: '08',
    MBO_PROVINCIA: '05',
    DESCR: 'TAYACAJA'
  },
  {
    id: 134,
    departmentId: 10,
    description: 'Marañon',
    state: '09',
    MBO_PROVINCIA: '05',
    DESCR: 'MARANON'
  },
  {
    id: 135,
    departmentId: 12,
    description: 'Tarma',
    state: '11',
    MBO_PROVINCIA: '05',
    DESCR: 'TARMA'
  },
  {
    id: 136,
    departmentId: 13,
    description: 'Pacasmayo',
    state: '12',
    MBO_PROVINCIA: '05',
    DESCR: 'PACASMAYO'
  },
  {
    id: 137,
    departmentId: 15,
    description: 'Huarochiri',
    state: '14',
    MBO_PROVINCIA: '06',
    DESCR: 'HUAROCHIRI'
  },
  {
    id: 138,
    departmentId: 16,
    description: 'Datem del Marañon',
    state: '15',
    MBO_PROVINCIA: '07',
    DESCR: 'DATEM DEL MARAÑON'
  },
  {
    id: 139,
    departmentId: 20,
    description: 'Talara',
    state: '19',
    MBO_PROVINCIA: '07',
    DESCR: 'TALARA'
  },
  {
    id: 140,
    departmentId: 21,
    description: 'Lampa',
    state: '20',
    MBO_PROVINCIA: '06',
    DESCR: 'LAMPA'
  },
  {
    id: 141,
    departmentId: 22,
    description: 'Picota',
    state: '21',
    MBO_PROVINCIA: '09',
    DESCR: 'PICOTA'
  },
  {
    id: 142,
    departmentId: 2,
    description: 'Casma',
    state: '02',
    MBO_PROVINCIA: '05',
    DESCR: 'CASMA'
  },
  {
    id: 143,
    departmentId: 4,
    description: 'La union',
    state: '04',
    MBO_PROVINCIA: '08',
    DESCR: 'LA UNION'
  },
  {
    id: 144,
    departmentId: 5,
    description: 'Paucar del Sara Sara',
    state: '05',
    MBO_PROVINCIA: '10',
    DESCR: 'PAUCAR DEL SARA SARA'
  },
  {
    id: 145,
    departmentId: 6,
    description: 'Jaen',
    state: '06',
    MBO_PROVINCIA: '08',
    DESCR: 'JAEN'
  },
  {
    id: 146,
    departmentId: 8,
    description: 'Espinar',
    state: '07',
    MBO_PROVINCIA: '08',
    DESCR: 'ESPINAR'
  },
  {
    id: 147,
    departmentId: 10,
    description: 'Pachitea',
    state: '09',
    MBO_PROVINCIA: '07',
    DESCR: 'PACHITEA'
  },
  {
    id: 148,
    departmentId: 12,
    description: 'Yauli',
    state: '11',
    MBO_PROVINCIA: '06',
    DESCR: 'YAULI'
  },
  {
    id: 149,
    departmentId: 13,
    description: 'Pataz',
    state: '12',
    MBO_PROVINCIA: '06',
    DESCR: 'PATAZ'
  },
  {
    id: 150,
    departmentId: 15,
    description: 'Huaura',
    state: '14',
    MBO_PROVINCIA: '05',
    DESCR: 'HUAURA'
  },
  {
    id: 151,
    departmentId: 20,
    description: 'Sechura',
    state: '19',
    MBO_PROVINCIA: '08',
    DESCR: 'SECHURA'
  },
  {
    id: 152,
    departmentId: 21,
    description: 'Melgar',
    state: '20',
    MBO_PROVINCIA: '07',
    DESCR: 'MELGAR'
  },
  {
    id: 153,
    departmentId: 22,
    description: 'Rioja',
    state: '21',
    MBO_PROVINCIA: '05',
    DESCR: 'RIOJA'
  },
  {
    id: 154,
    departmentId: 2,
    description: 'Corongo',
    state: '02',
    MBO_PROVINCIA: '06',
    DESCR: 'CORONGO'
  },
  {
    id: 155,
    departmentId: 5,
    description: 'Sucre',
    state: '05',
    MBO_PROVINCIA: '11',
    DESCR: 'SUCRE'
  },
  {
    id: 156,
    departmentId: 6,
    description: 'San Ignacio',
    state: '06',
    MBO_PROVINCIA: '11',
    DESCR: 'SAN IGNACIO'
  },
  {
    id: 157,
    departmentId: 8,
    description: 'La Convención',
    state: '07',
    MBO_PROVINCIA: '09',
    DESCR: 'LA CONVENCION'
  },
  {
    id: 158,
    departmentId: 10,
    description: 'Puerto Inca',
    state: '09',
    MBO_PROVINCIA: '08',
    DESCR: 'PUERTO INCA'
  },
  {
    id: 159,
    departmentId: 12,
    description: 'Chupaca',
    state: '11',
    MBO_PROVINCIA: '09',
    DESCR: 'CHUPACA'
  },
  {
    id: 160,
    departmentId: 13,
    description: 'Sanchez Carrión',
    state: '12',
    MBO_PROVINCIA: '03',
    DESCR: 'SANCHEZ CARRION'
  },
  {
    id: 161,
    departmentId: 15,
    description: 'Oyon',
    state: '14',
    MBO_PROVINCIA: '10',
    DESCR: 'OYON'
  },
  {
    id: 162,
    departmentId: 21,
    description: 'Moho',
    state: '20',
    MBO_PROVINCIA: '13',
    DESCR: 'MOHO'
  },
  {
    id: 163,
    departmentId: 22,
    description: 'San Martín',
    state: '21',
    MBO_PROVINCIA: '06',
    DESCR: 'SAN MARTIN'
  },
  {
    id: 164,
    departmentId: 2,
    description: 'Huari',
    state: '02',
    MBO_PROVINCIA: '08',
    DESCR: 'HUARI'
  },
  {
    id: 165,
    departmentId: 5,
    description: 'Victor Fajardo',
    state: '05',
    MBO_PROVINCIA: '07',
    DESCR: 'VICTOR FAJARDO'
  },
  {
    id: 166,
    departmentId: 6,
    description: 'San Marcos',
    state: '06',
    MBO_PROVINCIA: '12',
    DESCR: 'SAN MARCOS'
  },
  {
    id: 167,
    departmentId: 8,
    description: 'Paruro',
    state: '07',
    MBO_PROVINCIA: '10',
    DESCR: 'PARURO'
  },
  {
    id: 168,
    departmentId: 10,
    description: 'Lauricocha',
    state: '09',
    MBO_PROVINCIA: '10',
    DESCR: 'LAURICOCHA'
  },
  {
    id: 169,
    departmentId: 13,
    description: 'Santiago de Chuco',
    state: '12',
    MBO_PROVINCIA: '07',
    DESCR: 'SANTIAGO DE CHUCO'
  },
  {
    id: 170,
    departmentId: 15,
    description: 'Yauyos',
    state: '14',
    MBO_PROVINCIA: '07',
    DESCR: 'YAUYOS'
  },
  {
    id: 171,
    departmentId: 21,
    description: 'San Antonio de Putina',
    state: '20',
    MBO_PROVINCIA: '11',
    DESCR: 'SAN ANTONIO DE PUTINA'
  },
  {
    id: 172,
    departmentId: 22,
    description: 'Tocache',
    state: '21',
    MBO_PROVINCIA: '08',
    DESCR: 'TOCACHE'
  },
  {
    id: 173,
    departmentId: 2,
    description: 'Huarmey',
    state: '02',
    MBO_PROVINCIA: '19',
    DESCR: 'HUARMEY'
  },
  {
    id: 174,
    departmentId: 5,
    description: 'Vilcas Huaman',
    state: '05',
    MBO_PROVINCIA: '09',
    DESCR: 'VILCAS HUAMAN'
  },
  {
    id: 175,
    departmentId: 6,
    description: 'San Miguel',
    state: '06',
    MBO_PROVINCIA: '10',
    DESCR: 'SAN MIGUEL'
  },
  {
    id: 176,
    departmentId: 8,
    description: 'Paucartambo',
    state: '07',
    MBO_PROVINCIA: '11',
    DESCR: 'PAUCARTAMBO'
  },
  {
    id: 177,
    departmentId: 10,
    description: 'Yarowilca',
    state: '09',
    MBO_PROVINCIA: '11',
    DESCR: 'YAROWILCA'
  },
  {
    id: 178,
    departmentId: 13,
    description: 'Gran Chimu',
    state: '12',
    MBO_PROVINCIA: '11',
    DESCR: 'GRAN CHIMU'
  },
  {
    id: 179,
    departmentId: 15,
    description: 'Callao',
    state: '24',
    MBO_PROVINCIA: '01',
    DESCR: 'CALLAO'
  },
  {
    id: 180,
    departmentId: 21,
    description: 'San Roman',
    state: '20',
    MBO_PROVINCIA: '09',
    DESCR: 'SAN ROMAN'
  },
  {
    id: 181,
    departmentId: 2,
    description: 'Huaylas',
    state: '02',
    MBO_PROVINCIA: '07',
    DESCR: 'HUAYLAS'
  },
  {
    id: 182,
    departmentId: 6,
    description: 'San Pablo',
    state: '06',
    MBO_PROVINCIA: '13',
    DESCR: 'SAN PABLO'
  },
  {
    id: 183,
    departmentId: 8,
    description: 'Quispicanchi',
    state: '07',
    MBO_PROVINCIA: '12',
    DESCR: 'QUISPICANCHIS'
  },
  {
    id: 184,
    departmentId: 13,
    description: 'Viru',
    state: '12',
    MBO_PROVINCIA: '12',
    DESCR: 'VIRU'
  },
  {
    id: 185,
    departmentId: 21,
    description: 'Sandia',
    state: '20',
    MBO_PROVINCIA: '08',
    DESCR: 'SANDIA'
  },
  {
    id: 186,
    departmentId: 2,
    description: 'Mariscal Luzuriaga',
    state: '02',
    MBO_PROVINCIA: '09',
    DESCR: 'MARISCAL LUZURIAGA'
  },
  {
    id: 187,
    departmentId: 6,
    description: 'Santa Cruz',
    state: '06',
    MBO_PROVINCIA: '09',
    DESCR: 'SANTA CRUZ'
  },
  {
    id: 188,
    departmentId: 8,
    description: 'Urubamba',
    state: '07',
    MBO_PROVINCIA: '13',
    DESCR: 'URUBAMBA'
  },
  {
    id: 189,
    departmentId: 21,
    description: 'Yunguyo',
    state: '20',
    MBO_PROVINCIA: '10',
    DESCR: 'YUNGUYO'
  },
  {
    id: 190,
    departmentId: 2,
    description: 'Ocros',
    state: '02',
    MBO_PROVINCIA: '20',
    DESCR: 'OCROS'
  },
  {
    id: 191,
    departmentId: 2,
    description: 'Pallasca',
    state: '02',
    MBO_PROVINCIA: '10',
    DESCR: 'PALLASCA'
  },
  {
    id: 192,
    departmentId: 2,
    description: 'Pomabamba',
    state: '02',
    MBO_PROVINCIA: '11',
    DESCR: 'POMABAMBA'
  },
  {
    id: 193,
    departmentId: 2,
    description: 'Recuay',
    state: '02',
    MBO_PROVINCIA: '12',
    DESCR: 'RECUAY'
  },
  {
    id: 194,
    departmentId: 2,
    description: 'Santa',
    state: '02',
    MBO_PROVINCIA: '13',
    DESCR: 'SANTA'
  },
  {
    id: 195,
    departmentId: 2,
    description: 'Sihuas',
    state: '02',
    MBO_PROVINCIA: '14',
    DESCR: 'SIHUAS'
  },
  {
    id: 196,
    departmentId: 2,
    description: 'Yungay',
    state: '02',
    MBO_PROVINCIA: '15',
    DESCR: 'YUNGAY'
  }
];

const DISTRICTS: DistrictProps[] = [
  {
    id: 1,
    provinceId: 1,
    description: 'Chachapoyas',
    state: '01',
    DESCR: 'CHACHAPOYAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 2,
    provinceId: 2,
    description: 'Huaraz',
    state: '02',
    DESCR: 'HUARAZ',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 3,
    provinceId: 3,
    description: 'Abancay',
    state: '03',
    DESCR: 'ABANCAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 4,
    provinceId: 4,
    description: 'Arequipa',
    state: '04',
    DESCR: 'AREQUIPA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 5,
    provinceId: 5,
    description: 'Ayacucho',
    state: '05',
    DESCR: 'AYACUCHO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 6,
    provinceId: 6,
    description: 'Cajamarca',
    state: '06',
    DESCR: 'CAJAMARCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 7,
    provinceId: 7,
    description: 'Callao',
    state: '24',
    DESCR: 'CALLAO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 8,
    provinceId: 8,
    description: 'Cusco',
    state: '07',
    DESCR: 'CUSCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 9,
    provinceId: 9,
    description: 'Huancavelica',
    state: '08',
    DESCR: 'HUANCAVELICA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 10,
    provinceId: 10,
    description: 'Huanuco',
    state: '09',
    DESCR: 'HUANUCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 11,
    provinceId: 11,
    description: 'Ica',
    state: '10',
    DESCR: 'ICA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 12,
    provinceId: 12,
    description: 'Huancayo',
    state: '11',
    DESCR: 'HUANCAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 13,
    provinceId: 13,
    description: 'Trujillo',
    state: '12',
    DESCR: 'TRUJILLO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 14,
    provinceId: 14,
    description: 'Chiclayo',
    state: '13',
    DESCR: 'CHICLAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 15,
    provinceId: 15,
    description: 'Lima',
    state: '14',
    DESCR: 'LIMA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 16,
    provinceId: 16,
    description: 'Iquitos',
    state: '15',
    DESCR: 'IQUITOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 17,
    provinceId: 17,
    description: 'Tambopata',
    state: '16',
    DESCR: 'TAMBOPATA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 18,
    provinceId: 18,
    description: 'Moquegua',
    state: '17',
    DESCR: 'MOQUEGUA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 19,
    provinceId: 19,
    description: 'Chaupimarca',
    state: '18',
    DESCR: 'CHAUPIMARCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 20,
    provinceId: 20,
    description: 'Piura',
    state: '19',
    DESCR: 'PIURA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 21,
    provinceId: 21,
    description: 'Puno',
    state: '20',
    DESCR: 'PUNO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 22,
    provinceId: 22,
    description: 'Moyobamba',
    state: '21',
    DESCR: 'MOYOBAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 23,
    provinceId: 23,
    description: 'Tacna',
    state: '22',
    DESCR: 'TACNA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 24,
    provinceId: 24,
    description: 'Tumbes',
    state: '23',
    DESCR: 'TUMBES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 25,
    provinceId: 25,
    description: 'Callaria',
    state: '23',
    DESCR: 'CALLERIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 26,
    provinceId: 26,
    description: 'La peca',
    state: '01',
    DESCR: 'LA PECA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 27,
    provinceId: 27,
    description: 'Aija',
    state: '02',
    DESCR: 'AIJA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 28,
    provinceId: 28,
    description: 'Andahuaylas',
    state: '03',
    DESCR: 'ANDAHUAYLAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 29,
    provinceId: 29,
    description: 'Camana',
    state: '04',
    DESCR: 'CAMANA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 30,
    provinceId: 30,
    description: 'Cangallo',
    state: '05',
    DESCR: 'CANGALLO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 31,
    provinceId: 31,
    description: 'Cajabamba',
    state: '06',
    DESCR: 'CAJABAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 32,
    provinceId: 32,
    description: 'Acomayo',
    state: '07',
    DESCR: 'ACOMAYO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 33,
    provinceId: 33,
    description: 'Acobamba',
    state: '08',
    DESCR: 'ACOBAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 34,
    provinceId: 34,
    description: 'Ambo',
    state: '09',
    DESCR: 'AMBO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 35,
    provinceId: 35,
    description: 'Chincha alta',
    state: '10',
    DESCR: 'CHINCHA ALTA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 36,
    provinceId: 36,
    description: 'Concepcion',
    state: '05',
    DESCR: 'CONCEPCION',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 37,
    provinceId: 37,
    description: 'Ascope',
    state: '12',
    DESCR: 'ASCOPE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 38,
    provinceId: 38,
    description: 'Ferreñafe',
    state: '13',
    DESCR: 'FERRENAFE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 39,
    provinceId: 39,
    description: 'Barranca',
    state: '15',
    DESCR: 'BARRANCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 40,
    provinceId: 40,
    description: 'Yurimaguas',
    state: '15',
    DESCR: 'YURIMAGUAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 41,
    provinceId: 41,
    description: 'Manu',
    state: '16',
    DESCR: 'MANU',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 42,
    provinceId: 42,
    description: 'Omate',
    state: '17',
    DESCR: 'OMATE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 43,
    provinceId: 43,
    description: 'Yanahuanca',
    state: '18',
    DESCR: 'YANAHUANCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 44,
    provinceId: 44,
    description: 'Ayabaca',
    state: '19',
    DESCR: 'AYABACA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 45,
    provinceId: 45,
    description: 'Azangaro',
    state: '20',
    DESCR: 'AZANGARO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 46,
    provinceId: 46,
    description: 'Bellavista',
    state: '06',
    DESCR: 'BELLAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 47,
    provinceId: 47,
    description: 'Candarave',
    state: '22',
    DESCR: 'CANDARAVE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 48,
    provinceId: 48,
    description: 'Zorritos',
    state: '23',
    DESCR: 'ZORRITOS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 49,
    provinceId: 49,
    description: 'Raymondi',
    state: '02',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '21',
    DESCR: 'ANTONIO RAIMONDI'
  },
  {
    id: 50,
    provinceId: 50,
    description: 'Jumbilla',
    state: '01',
    DESCR: 'JUMBILLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 51,
    provinceId: 51,
    description: 'Llamellin',
    state: '02',
    DESCR: 'LLAMELLIN',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '01'
  },
  {
    id: 52,
    provinceId: 52,
    description: 'Antabamba',
    state: '03',
    DESCR: 'ANTABAMBA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 53,
    provinceId: 53,
    description: 'Caraveli',
    state: '04',
    DESCR: 'CARAVELI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 54,
    provinceId: 54,
    description: 'Sancos',
    state: '05',
    DESCR: 'SANCOS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '20'
  },
  {
    id: 55,
    provinceId: 55,
    description: 'Celendin',
    state: '06',
    DESCR: 'CELENDIN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 56,
    provinceId: 56,
    description: 'Anta',
    state: '02',
    DESCR: 'ANTA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 57,
    provinceId: 57,
    description: 'Lircay',
    state: '08',
    DESCR: 'LIRCAY',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 58,
    provinceId: 58,
    description: 'La union',
    state: '09',
    DESCR: 'LA UNION',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 59,
    provinceId: 59,
    description: 'Nazca',
    state: '10',
    DESCR: 'NAZCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 60,
    provinceId: 60,
    description: 'Chanchamayo',
    state: '11',
    DESCR: 'CHANCHAMAYO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 61,
    provinceId: 61,
    description: 'Bolivar',
    state: '12',
    DESCR: 'BOLIVAR',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 62,
    provinceId: 62,
    description: 'Lambayeque',
    state: '13',
    DESCR: 'LAMBAYEQUE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 63,
    provinceId: 63,
    description: 'Cajatambo',
    state: '14',
    DESCR: 'CAJATAMBO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 64,
    provinceId: 64,
    description: 'Nauta',
    state: '15',
    DESCR: 'NAUTA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 65,
    provinceId: 65,
    description: 'Iñapari',
    state: '16',
    DESCR: 'INAPARI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 66,
    provinceId: 66,
    description: 'Ilo',
    state: '17',
    DESCR: 'ILO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 67,
    provinceId: 67,
    description: 'Oxapampa',
    state: '18',
    DESCR: 'OXAPAMPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 68,
    provinceId: 68,
    description: 'Huancabamba',
    state: '18',
    DESCR: 'HUANCABAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 69,
    provinceId: 69,
    description: 'Macusani',
    state: '20',
    DESCR: 'MACUSANI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 70,
    provinceId: 70,
    description: 'San jose de sisa',
    state: '21',
    DESCR: 'SAN JOSE DE SISA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 71,
    provinceId: 71,
    description: 'Locumba',
    state: '22',
    DESCR: 'LOCUMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 72,
    provinceId: 72,
    description: 'Zarumilla',
    state: '23',
    DESCR: 'ZARUMILLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 73,
    provinceId: 73,
    description: 'Padre abad',
    state: '25',
    DESCR: 'PADRE ABAD',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 74,
    provinceId: 74,
    description: 'Nieva',
    state: '01',
    DESCR: 'NIEVA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 75,
    provinceId: 75,
    description: 'Chacas',
    state: '02',
    DESCR: 'CHACAS',
    MBO_PROVINCIA: '18',
    MBO_DISTRITO: '01'
  },
  {
    id: 76,
    provinceId: 76,
    description: 'Chalhuanca',
    state: '03',
    DESCR: 'CHALHUANCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 77,
    provinceId: 77,
    description: 'Aplao',
    state: '04',
    DESCR: 'APLAO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 78,
    provinceId: 78,
    description: 'Huanta',
    state: '05',
    DESCR: 'HUANTA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 79,
    provinceId: 79,
    description: 'Chota',
    state: '06',
    DESCR: 'CHOTA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 80,
    provinceId: 80,
    description: 'Calca',
    state: '07',
    DESCR: 'CALCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 81,
    provinceId: 81,
    description: 'Castrovirreyna',
    state: '08',
    DESCR: 'CASTROVIRREYNA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 82,
    provinceId: 82,
    description: 'Huacaybamba',
    state: '09',
    DESCR: 'HUACAYBAMBA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 83,
    provinceId: 83,
    description: 'Palpa',
    state: '10',
    DESCR: 'PALPA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 84,
    provinceId: 84,
    description: 'Jauja',
    state: '11',
    DESCR: 'JAUJA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 85,
    provinceId: 85,
    description: 'Chepen',
    state: '12',
    DESCR: 'CHEPEN',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 86,
    provinceId: 86,
    description: 'Canta',
    state: '14',
    DESCR: 'CANTA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 87,
    provinceId: 87,
    description: 'Ramon castilla',
    state: '15',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01',
    DESCR: 'MARISCAL RAMON CASTILLA'
  },
  {
    id: 88,
    provinceId: 88,
    description: 'Chulucanas',
    state: '19',
    DESCR: 'CHULUCANAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 89,
    provinceId: 89,
    description: 'Juli',
    state: '20',
    DESCR: 'JULI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 90,
    provinceId: 90,
    description: 'Saposoa',
    state: '21',
    DESCR: 'SAPOSOA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 91,
    provinceId: 91,
    description: 'Tarata',
    state: '22',
    DESCR: 'TARATA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 92,
    provinceId: 92,
    description: 'Purus',
    state: '25',
    DESCR: 'PURUS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 93,
    provinceId: 93,
    description: 'Lamud',
    state: '01',
    DESCR: 'LAMUD',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 94,
    provinceId: 94,
    description: 'Chiquian',
    state: '02',
    DESCR: 'CHIQUIAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 95,
    provinceId: 95,
    description: 'Tambobamba',
    state: '03',
    DESCR: 'TAMBOBAMBA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 96,
    provinceId: 96,
    description: 'Chivay',
    state: '04',
    DESCR: 'CHIVAY',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 97,
    provinceId: 97,
    description: 'San miguel',
    state: '05',
    DESCR: 'SAN MIGUEL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 98,
    provinceId: 98,
    description: 'Contumaza',
    state: '06',
    DESCR: 'CONTUMAZA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 99,
    provinceId: 99,
    description: 'Yanaoca',
    state: '07',
    DESCR: 'YANAOCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 100,
    provinceId: 100,
    description: 'Churcampa',
    state: '08',
    DESCR: 'CHURCAMPA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 101,
    provinceId: 101,
    description: 'Llata',
    state: '09',
    DESCR: 'LLATA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 102,
    provinceId: 102,
    description: 'Pisco',
    state: '10',
    DESCR: 'PISCO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 103,
    provinceId: 103,
    description: 'Carhuamayo',
    state: '11',
    DESCR: 'CARHUAMAYO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 104,
    provinceId: 104,
    description: 'Julcan',
    state: '11',
    DESCR: 'JULCAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 105,
    provinceId: 105,
    description: 'San vicente de cañete',
    state: '14',
    DESCR: 'SAN VICENTE DE CANETE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 106,
    provinceId: 106,
    description: 'Requena',
    state: '15',
    DESCR: 'REQUENA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 107,
    provinceId: 107,
    description: 'Paita',
    state: '19',
    DESCR: 'PAITA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 108,
    provinceId: 108,
    description: 'Ilave',
    state: '20',
    DESCR: 'ILAVE',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '01'
  },
  {
    id: 109,
    provinceId: 109,
    description: 'Lamas',
    state: '21',
    DESCR: 'LAMAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 110,
    provinceId: 110,
    description: 'San nicolas',
    state: '01',
    DESCR: 'SAN NICOLAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 111,
    provinceId: 111,
    description: 'Carhuaz',
    state: '02',
    DESCR: 'CARHUAZ',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 112,
    provinceId: 112,
    description: 'Chincheros',
    state: '03',
    DESCR: 'CHINCHEROS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 113,
    provinceId: 113,
    description: 'Chuquibamba',
    state: '04',
    DESCR: 'CHUQUIBAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 114,
    provinceId: 114,
    description: 'Puquio',
    state: '05',
    DESCR: 'PUQUIO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 115,
    provinceId: 115,
    description: 'Cutervo',
    state: '06',
    DESCR: 'CUTERVO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 116,
    provinceId: 116,
    description: 'Sicuani',
    state: '07',
    DESCR: 'SICUANI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 117,
    provinceId: 117,
    description: 'Huaytara',
    state: '08',
    DESCR: 'HUAYTARA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 118,
    provinceId: 118,
    description: 'Rupa-rupa',
    state: '09',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01',
    DESCR: 'RUPA RUPA'
  },
  {
    id: 119,
    provinceId: 119,
    description: 'Satipo',
    state: '11',
    DESCR: 'SATIPO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 120,
    provinceId: 120,
    description: 'Otuzco',
    state: '12',
    DESCR: 'OTUZCO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 121,
    provinceId: 121,
    description: 'Huaral',
    state: '14',
    DESCR: 'HUARAL',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 122,
    provinceId: 122,
    description: 'Contamana',
    state: '15',
    DESCR: 'CONTAMANA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 123,
    provinceId: 123,
    description: 'Sullana',
    state: '19',
    DESCR: 'SULLANA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 124,
    provinceId: 124,
    description: 'Huancane',
    state: '20',
    DESCR: 'HUANCANE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 125,
    provinceId: 125,
    description: 'Juanjui',
    state: '21',
    DESCR: 'JUANJUI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 126,
    provinceId: 126,
    description: 'Bagua grande',
    state: '01',
    DESCR: 'BAGUA GRANDE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 127,
    provinceId: 127,
    description: 'San luis',
    state: '02',
    DESCR: 'SAN LUIS',
    MBO_PROVINCIA: '17',
    MBO_DISTRITO: '01'
  },
  {
    id: 128,
    provinceId: 128,
    description: 'Chuquibambilla',
    state: '03',
    DESCR: 'CHUQUIBAMBILLA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 129,
    provinceId: 129,
    description: 'Mollendo',
    state: '04',
    DESCR: 'MOLLENDO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 130,
    provinceId: 130,
    description: 'Coracora',
    state: '05',
    DESCR: 'CORACORA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 131,
    provinceId: 131,
    description: 'Bambamarca',
    state: '06',
    DESCR: 'BAMBAMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 132,
    provinceId: 132,
    description: ' santo tomas',
    state: '07',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01',
    DESCR: 'SANTO TOMAS'
  },
  {
    id: 133,
    provinceId: 133,
    description: 'Pampas',
    state: '02',
    DESCR: 'PAMPAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 134,
    provinceId: 134,
    description: 'Huacrachuco',
    state: '09',
    DESCR: 'HUACRACHUCO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 135,
    provinceId: 135,
    description: 'Tarma',
    state: '11',
    DESCR: 'TARMA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 136,
    provinceId: 136,
    description: 'San pedro de lloc',
    state: '12',
    DESCR: 'SAN PEDRO DE LLOC',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 137,
    provinceId: 137,
    description: 'Matucana',
    state: '14',
    DESCR: 'MATUCANA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 138,
    provinceId: 138,
    description: 'Barranca',
    state: '15',
    DESCR: 'BARRANCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 139,
    provinceId: 139,
    description: 'Pariñas',
    state: '19',
    DESCR: 'PARINAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 140,
    provinceId: 140,
    description: 'Lampa',
    state: '05',
    DESCR: 'LAMPA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 141,
    provinceId: 141,
    description: 'Picota',
    state: '21',
    DESCR: 'PICOTA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 142,
    provinceId: 142,
    description: 'Casma',
    state: '02',
    DESCR: 'CASMA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 143,
    provinceId: 143,
    description: 'Cotahuasi',
    state: '04',
    DESCR: 'COTAHUASI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 144,
    provinceId: 144,
    description: 'Pausa',
    state: '05',
    DESCR: 'PAUSA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 145,
    provinceId: 145,
    description: 'Jaen',
    state: '06',
    DESCR: 'JAEN',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 146,
    provinceId: 146,
    description: 'Espinar',
    state: '07',
    DESCR: 'ESPINAR',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 147,
    provinceId: 147,
    description: 'Panao',
    state: '09',
    DESCR: 'PANAO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 148,
    provinceId: 148,
    description: 'La Oroya',
    state: '11',
    DESCR: 'LA OROYA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 149,
    provinceId: 149,
    description: 'Tayabamba',
    state: '12',
    DESCR: 'TAYABAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 150,
    provinceId: 150,
    description: 'Huacho',
    state: '14',
    DESCR: 'HUACHO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 151,
    provinceId: 151,
    description: 'Sechura',
    state: '19',
    DESCR: 'SECHURA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 152,
    provinceId: 152,
    description: 'Ayaviri',
    state: '20',
    DESCR: 'AYAVIRI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 153,
    provinceId: 153,
    description: 'Rioja',
    state: '21',
    DESCR: 'RIOJA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 154,
    provinceId: 154,
    description: 'Corongo',
    state: '02',
    DESCR: 'CORONGO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 155,
    provinceId: 155,
    description: 'Querobamba',
    state: '05',
    DESCR: 'QUEROBAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 156,
    provinceId: 156,
    description: 'San ignacio',
    state: '06',
    DESCR: 'SAN IGNACIO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 157,
    provinceId: 157,
    description: 'Santa ana',
    state: '07',
    DESCR: 'SANTA ANA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 158,
    provinceId: 158,
    description: 'Puerto inca',
    state: '09',
    DESCR: 'PUERTO INCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 159,
    provinceId: 159,
    description: 'Chupaca',
    state: '11',
    DESCR: 'CHUPACA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 160,
    provinceId: 160,
    description: 'Huamachuco',
    state: '12',
    DESCR: 'HUAMACHUCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 161,
    provinceId: 161,
    description: 'Oyon',
    state: '14',
    DESCR: 'OYON',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 162,
    provinceId: 162,
    description: 'Moho',
    state: '20',
    DESCR: 'MOHO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 163,
    provinceId: 163,
    description: 'Tarapoto',
    state: '21',
    DESCR: 'TARAPOTO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 164,
    provinceId: 164,
    description: 'Huari',
    state: '02',
    DESCR: 'HUARI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 165,
    provinceId: 165,
    description: 'Huancapi',
    state: '05',
    DESCR: 'HUANCAPI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 166,
    provinceId: 166,
    description: 'Pedro galvez',
    state: '06',
    DESCR: 'PEDRO GALVEZ',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '01'
  },
  {
    id: 167,
    provinceId: 167,
    description: 'Paruro',
    state: '07',
    DESCR: 'PARURO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 168,
    provinceId: 168,
    description: 'Jesus',
    state: '06',
    DESCR: 'JESUS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 169,
    provinceId: 169,
    description: 'Santiago de Chuco',
    state: '12',
    DESCR: 'SANTIAGO DE CHUCO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 170,
    provinceId: 170,
    description: 'Yauyos',
    state: '11',
    DESCR: 'YAUYOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '34'
  },
  {
    id: 171,
    provinceId: 171,
    description: 'Putina',
    state: '20',
    DESCR: 'PUTINA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 172,
    provinceId: 172,
    description: 'Tocache',
    state: '21',
    DESCR: 'TOCACHE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 173,
    provinceId: 173,
    description: 'Huarmey',
    state: '02',
    DESCR: 'HUARMEY',
    MBO_PROVINCIA: '19',
    MBO_DISTRITO: '01'
  },
  {
    id: 174,
    provinceId: 174,
    description: 'Vilcas huaman',
    state: '05',
    DESCR: 'VILCAS HUAMAN',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 175,
    provinceId: 175,
    description: 'San miguel',
    state: '05',
    DESCR: 'SAN MIGUEL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 176,
    provinceId: 176,
    description: 'Paucartambo',
    state: '18',
    DESCR: 'PAUCARTAMBO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 177,
    provinceId: 177,
    description: 'Chavinillo',
    state: '09',
    DESCR: 'CHAVINILLO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 178,
    provinceId: 178,
    description: 'Cascas',
    state: '12',
    DESCR: 'CASCAS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 179,
    provinceId: 179,
    description: 'Callao',
    state: '24',
    DESCR: 'CALLAO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '01'
  },
  {
    id: 180,
    provinceId: 180,
    description: 'Juliaca',
    state: '20',
    DESCR: 'JULIACA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 181,
    provinceId: 181,
    description: 'Caraz',
    state: '02',
    DESCR: 'CARAZ',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 182,
    provinceId: 182,
    description: 'San pablo',
    state: '06',
    DESCR: 'SAN PABLO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 183,
    provinceId: 183,
    description: 'Urcos',
    state: '07',
    DESCR: 'URCOS',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '01'
  },
  {
    id: 184,
    provinceId: 184,
    description: 'Viru',
    state: '12',
    DESCR: 'VIRU',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '01'
  },
  {
    id: 185,
    provinceId: 185,
    description: 'Sandia',
    state: '20',
    DESCR: 'SANDIA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 186,
    provinceId: 186,
    description: 'Piscobamba',
    state: '02',
    DESCR: 'PISCOBAMBA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 187,
    provinceId: 187,
    description: 'Santa cruz',
    state: '15',
    DESCR: 'SANTA CRUZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 188,
    provinceId: 188,
    description: 'Urubamba',
    state: '07',
    DESCR: 'URUBAMBA',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 189,
    provinceId: 189,
    description: 'Yunguyo',
    state: '20',
    DESCR: 'YUNGUYO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 190,
    provinceId: 190,
    description: 'Ocros',
    state: '02',
    DESCR: 'OCROS',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '07'
  },
  {
    id: 191,
    provinceId: 191,
    description: 'Cabana',
    state: '02',
    DESCR: 'CABANA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 192,
    provinceId: 192,
    description: 'Pomabamba',
    state: '02',
    DESCR: 'POMABAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '01'
  },
  {
    id: 193,
    provinceId: 193,
    description: 'Recuay',
    state: '02',
    DESCR: 'RECUAY',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '01'
  },
  {
    id: 194,
    provinceId: 194,
    description: 'Chimbote',
    state: '02',
    DESCR: 'CHIMBOTE',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 195,
    provinceId: 195,
    description: 'Sihuas',
    state: '02',
    DESCR: 'SIHUAS',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '01'
  },
  {
    id: 196,
    provinceId: 196,
    description: 'Yungay',
    state: '02',
    DESCR: 'YUNGAY',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '01'
  },
  {
    id: 197,
    provinceId: 1,
    description: 'Asuncion',
    state: '01',
    DESCR: 'ASUNCION',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 198,
    provinceId: 2,
    description: 'Cochabamba',
    state: '02',
    DESCR: 'COCHABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 199,
    provinceId: 3,
    description: 'Chacoche',
    state: '03',
    DESCR: 'CHACOCHE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 200,
    provinceId: 4,
    description: 'Alto selva alegre',
    state: '04',
    DESCR: 'ALTO SELVA ALEGRE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '28'
  },
  {
    id: 201,
    provinceId: 5,
    description: 'Acocro',
    state: '05',
    DESCR: 'ACOCRO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 202,
    provinceId: 6,
    description: 'Asuncion',
    state: '01',
    DESCR: 'ASUNCION',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 203,
    provinceId: 7,
    description: 'Bellavista',
    state: '06',
    DESCR: 'BELLAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 204,
    provinceId: 8,
    description: 'Ccorca',
    state: '07',
    DESCR: 'CCORCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 205,
    provinceId: 9,
    description: 'Acobambilla',
    state: '08',
    DESCR: 'ACOBAMBILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 206,
    provinceId: 10,
    description: 'Amarilis',
    state: '09',
    DESCR: 'AMARILIS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 207,
    provinceId: 11,
    description: 'La tinguiña',
    state: '10',
    DESCR: 'LA TINGUINA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 208,
    provinceId: 13,
    description: 'El Porvenir',
    state: '12',
    DESCR: 'EL PORVENIR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 209,
    provinceId: 14,
    description: 'Chongoyape',
    state: '13',
    DESCR: 'CHONGOYAPE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 210,
    provinceId: 15,
    description: 'Ancon',
    state: '14',
    DESCR: 'ANCON',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 211,
    provinceId: 16,
    description: 'Alto nanay',
    state: '15',
    DESCR: 'ALTO NANAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 212,
    provinceId: 17,
    description: 'Inambari',
    state: '16',
    DESCR: 'INAMBARI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 213,
    provinceId: 18,
    description: 'Carumas',
    state: '17',
    DESCR: 'CARUMAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 214,
    provinceId: 19,
    description: 'Huachon',
    state: '18',
    DESCR: 'HUACHON',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 215,
    provinceId: 21,
    description: 'Acora',
    state: '20',
    DESCR: 'ACORA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 216,
    provinceId: 22,
    description: 'Calzada',
    state: '21',
    DESCR: 'CALZADA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 217,
    provinceId: 23,
    description: 'Alto de la alianza',
    state: '22',
    DESCR: 'ALTO DE LA ALIANZA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 218,
    provinceId: 24,
    description: 'Corrales',
    state: '23',
    DESCR: 'CORRALES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 219,
    provinceId: 25,
    description: 'Campoverde',
    state: '25',
    DESCR: 'CAMPOVERDE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 220,
    provinceId: 26,
    description: 'Aramango',
    state: '01',
    DESCR: 'ARAMANGO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 221,
    provinceId: 27,
    description: 'Coris',
    state: '02',
    DESCR: 'CORIS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 222,
    provinceId: 28,
    description: 'Andarapa',
    state: '03',
    DESCR: 'ANDARAPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 223,
    provinceId: 29,
    description: 'Jose maria quimper',
    state: '04',
    DESCR: 'JOSE MARIA QUIMPER',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 224,
    provinceId: 30,
    description: 'Chuschi',
    state: '05',
    DESCR: 'CHUSCHI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 225,
    provinceId: 31,
    description: 'Cachachi',
    state: '06',
    DESCR: 'CACHACHI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 226,
    provinceId: 32,
    description: 'Acopia',
    state: '07',
    DESCR: 'ACOPIA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 227,
    provinceId: 33,
    description: 'Andabamba',
    state: '08',
    DESCR: 'ANDABAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 228,
    provinceId: 34,
    description: 'Cayna',
    state: '09',
    DESCR: 'CAYNA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 229,
    provinceId: 35,
    description: 'Alto laran',
    state: '10',
    DESCR: 'ALTO LARAN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '09'
  },
  {
    id: 230,
    provinceId: 36,
    description: 'Aco',
    state: '11',
    DESCR: 'ACO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 231,
    provinceId: 37,
    description: 'Chicama',
    state: '12',
    DESCR: 'CHICAMA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 232,
    provinceId: 38,
    description: 'Cañaris',
    state: '13',
    DESCR: 'CANARIS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 233,
    provinceId: 39,
    description: 'Paramonga',
    state: '14',
    DESCR: 'PARAMONGA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 234,
    provinceId: 40,
    description: 'Balsapuerto',
    state: '15',
    DESCR: 'BALSAPUERTO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 235,
    provinceId: 41,
    description: 'Fitzcarrald',
    state: '16',
    DESCR: 'FITZCARRALD',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 236,
    provinceId: 42,
    description: 'Chojata',
    state: '17',
    DESCR: 'CHOJATA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 237,
    provinceId: 43,
    description: 'Chacayan',
    state: '18',
    DESCR: 'CHACAYAN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 238,
    provinceId: 44,
    description: 'Frias',
    state: '19',
    DESCR: 'FRIAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 239,
    provinceId: 45,
    description: 'Achaya',
    state: '20',
    DESCR: 'ACHAYA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 240,
    provinceId: 46,
    description: 'Alto biavo',
    state: '21',
    DESCR: 'ALTO BIAVO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 241,
    provinceId: 47,
    description: 'Cairani',
    state: '22',
    DESCR: 'CAIRANI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 242,
    provinceId: 48,
    description: 'Casitas',
    state: '23',
    DESCR: 'CASITAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 243,
    provinceId: 49,
    description: 'Sepahua',
    state: '25',
    DESCR: 'SEPAHUA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 244,
    provinceId: 50,
    description: 'Chisquilla',
    state: '01',
    DESCR: 'CHISQUILLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 245,
    provinceId: 51,
    description: 'Aczo',
    state: '02',
    DESCR: 'ACZO',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '02'
  },
  {
    id: 246,
    provinceId: 52,
    description: 'El oro',
    state: '03',
    DESCR: 'EL ORO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 247,
    provinceId: 53,
    description: 'Acari',
    state: '04',
    DESCR: 'ACARI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 248,
    provinceId: 54,
    description: 'Carapo',
    state: '05',
    DESCR: 'CARAPO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 249,
    provinceId: 55,
    description: 'Chumuch',
    state: '06',
    DESCR: 'CHUMUCH',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 250,
    provinceId: 56,
    description: 'Ancahuasi',
    state: '07',
    DESCR: 'ANCAHUASI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 251,
    provinceId: 57,
    description: 'Anchonga',
    state: '08',
    DESCR: 'ANCHONGA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 252,
    provinceId: 59,
    description: 'Changuillo',
    state: '10',
    DESCR: 'CHANGUILLO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 253,
    provinceId: 60,
    description: 'Perene',
    state: '11',
    DESCR: 'PERENE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 254,
    provinceId: 61,
    description: 'Bambamarca',
    state: '06',
    DESCR: 'BAMBAMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 255,
    provinceId: 62,
    description: 'Chochope',
    state: '13',
    DESCR: 'CHOCHOPE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 256,
    provinceId: 63,
    description: 'Copa',
    state: '14',
    DESCR: 'COPA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 257,
    provinceId: 64,
    description: 'Parinari',
    state: '15',
    DESCR: 'PARINARI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 258,
    provinceId: 65,
    description: 'Iberia',
    state: '16',
    DESCR: 'IBERIA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 259,
    provinceId: 66,
    description: 'El algarrobal',
    state: '17',
    DESCR: 'EL ALGARROBAL',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 260,
    provinceId: 67,
    description: 'Chontabamba',
    state: '18',
    DESCR: 'CHONTABAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 261,
    provinceId: 68,
    description: 'Canchaque',
    state: '19',
    DESCR: 'CANCHAQUE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 262,
    provinceId: 69,
    description: 'Ajoyani',
    state: '20',
    DESCR: 'AJOYANI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 263,
    provinceId: 70,
    description: 'Agua blanca',
    state: '21',
    DESCR: 'AGUA BLANCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 264,
    provinceId: 71,
    description: 'Ilabaya',
    state: '22',
    DESCR: 'ILABAYA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 265,
    provinceId: 72,
    description: 'Aguas Verdes',
    state: '23',
    DESCR: 'AGUAS VERDES',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 266,
    provinceId: 73,
    description: 'Irazola',
    state: '25',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02',
    DESCR: 'YRAZOLA'
  },
  {
    id: 267,
    provinceId: 74,
    description: 'El cenepa',
    state: '01',
    DESCR: 'EL CENEPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 268,
    provinceId: 75,
    description: 'Acochaca',
    state: '02',
    DESCR: 'ACOCHACA',
    MBO_PROVINCIA: '18',
    MBO_DISTRITO: '02'
  },
  {
    id: 269,
    provinceId: 76,
    description: 'Capaya',
    state: '03',
    DESCR: 'CAPAYA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 270,
    provinceId: 77,
    description: 'Andagua',
    state: '04',
    DESCR: 'ANDAGUA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 271,
    provinceId: 78,
    description: 'Ayahuanco',
    state: '05',
    DESCR: 'AYAHUANCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 272,
    provinceId: 79,
    description: 'Anguia',
    state: '06',
    DESCR: 'ANGUIA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 273,
    provinceId: 80,
    description: 'Coya',
    state: '07',
    DESCR: 'COYA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 274,
    provinceId: 81,
    description: 'Arma',
    state: '08',
    DESCR: 'ARMA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 275,
    provinceId: 82,
    description: 'Canchabamba',
    state: '09',
    DESCR: 'CANCHABAMBA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 276,
    provinceId: 83,
    description: 'Llipata',
    state: '10',
    DESCR: 'LLIPATA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 277,
    provinceId: 84,
    description: 'Acolla',
    state: '11',
    DESCR: 'ACOLLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 278,
    provinceId: 85,
    description: 'Pacanga',
    state: '12',
    DESCR: 'PACANGA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 279,
    provinceId: 86,
    description: 'Arahuay',
    state: '14',
    DESCR: 'ARAHUAY',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 280,
    provinceId: 87,
    description: 'Pebas',
    state: '15',
    DESCR: 'PEBAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 281,
    provinceId: 88,
    description: 'Buenos Aires',
    state: '19',
    DESCR: 'BUENOS AIRES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 282,
    provinceId: 89,
    description: 'Desaguadero',
    state: '20',
    DESCR: 'DESAGUADERO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 283,
    provinceId: 90,
    description: 'Alto saposoa',
    state: '21',
    DESCR: 'ALTO SAPOSOA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 284,
    provinceId: 91,
    description: 'Chucatamani',
    state: '22',
    DESCR: 'CHUCATAMANI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 285,
    provinceId: 93,
    description: 'Camporredondo',
    state: '01',
    DESCR: 'CAMPORREDONDO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 286,
    provinceId: 94,
    description: 'Abelardo pardo lezameta',
    state: '02',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02',
    DESCR: 'A PARDO LEZAMETA'
  },
  {
    id: 287,
    provinceId: 95,
    description: 'Cotabambas',
    state: '03',
    DESCR: 'COTABAMBAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 288,
    provinceId: 96,
    description: 'Achoma',
    state: '04',
    DESCR: 'ACHOMA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 289,
    provinceId: 97,
    description: 'Anco',
    state: '05',
    DESCR: 'ANCO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 290,
    provinceId: 98,
    description: 'Chilete',
    state: '06',
    DESCR: 'CHILETE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 291,
    provinceId: 99,
    description: 'Checca',
    state: '07',
    DESCR: 'CHECCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 292,
    provinceId: 100,
    description: 'Anco',
    state: '05',
    DESCR: 'ANCO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 293,
    provinceId: 101,
    description: 'Arancay',
    state: '09',
    DESCR: 'ARANCAY',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 294,
    provinceId: 102,
    description: 'Huancano',
    state: '10',
    DESCR: 'HUANCANO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 295,
    provinceId: 103,
    description: 'Junín',
    state: '11',
    DESCR: 'JUNIN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 296,
    provinceId: 104,
    description: 'Calamarca',
    state: '12',
    DESCR: 'CALAMARCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 297,
    provinceId: 105,
    description: 'Asia',
    state: '14',
    DESCR: 'ASIA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '16'
  },
  {
    id: 298,
    provinceId: 106,
    description: 'Alto tapiche',
    state: '15',
    DESCR: 'ALTO TAPICHE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 299,
    provinceId: 107,
    description: 'Amotape',
    state: '19',
    DESCR: 'AMOTAPE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 300,
    provinceId: 108,
    description: 'Capaso',
    state: '20',
    DESCR: 'CAPASO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '04'
  },
  {
    id: 301,
    provinceId: 109,
    description: 'Alonso de alvarado',
    state: '21',
    DESCR: 'ALONSO DE ALVARADO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '15'
  },
  {
    id: 302,
    provinceId: 110,
    description: 'Chirimoto',
    state: '01',
    DESCR: 'CHIRIMOTO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 303,
    provinceId: 111,
    description: 'Acopampa',
    state: '02',
    DESCR: 'ACOPAMPA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 304,
    provinceId: 112,
    description: 'Anco-huallo',
    state: '03',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05',
    DESCR: 'ANCO HUALLO'
  },
  {
    id: 305,
    provinceId: 113,
    description: 'Andaray',
    state: '04',
    DESCR: 'ANDARAY',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 306,
    provinceId: 114,
    description: 'Aucara',
    state: '05',
    DESCR: 'AUCARA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 307,
    provinceId: 115,
    description: 'Callayuc',
    state: '06',
    DESCR: 'CALLAYUC',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 308,
    provinceId: 116,
    description: 'Checacupe',
    state: '07',
    DESCR: 'CHECACUPE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 309,
    provinceId: 117,
    description: 'Ayavi',
    state: '08',
    DESCR: 'AYAVI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 310,
    provinceId: 118,
    description: 'Daniel alomias robles',
    state: '09',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02',
    DESCR: 'DANIEL ALOMIA ROBLES'
  },
  {
    id: 311,
    provinceId: 119,
    description: 'Rio Negro',
    state: '11',
    DESCR: 'RIO NEGRO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 312,
    provinceId: 120,
    description: 'Agallpampa',
    state: '12',
    DESCR: 'AGALLPAMPA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 313,
    provinceId: 121,
    description: 'Atavillos alto',
    state: '14',
    DESCR: 'ATAVILLOS ALTO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 314,
    provinceId: 122,
    description: 'Inahuaya',
    state: '15',
    DESCR: 'INAHUAYA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 315,
    provinceId: 123,
    description: 'Bellavista',
    state: '06',
    DESCR: 'BELLAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 316,
    provinceId: 124,
    description: 'Cojata',
    state: '20',
    DESCR: 'COJATA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 317,
    provinceId: 125,
    description: 'Campanilla',
    state: '21',
    DESCR: 'CAMPANILLA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 318,
    provinceId: 126,
    description: 'Cajaruro',
    state: '01',
    DESCR: 'CAJARURO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 319,
    provinceId: 127,
    description: 'San nicolas',
    state: '01',
    DESCR: 'SAN NICOLAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '01'
  },
  {
    id: 320,
    provinceId: 128,
    description: 'Curpahuasi',
    state: '03',
    DESCR: 'CURPAHUASI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 321,
    provinceId: 129,
    description: 'Cocachacra',
    state: '04',
    DESCR: 'COCACHACRA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 322,
    provinceId: 130,
    description: 'Chumpi',
    state: '05',
    DESCR: 'CHUMPI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 323,
    provinceId: 131,
    description: 'Chugur',
    state: '06',
    DESCR: 'CHUGUR',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 324,
    provinceId: 132,
    description: 'Capacmarca',
    state: '07',
    DESCR: 'CAPACMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 325,
    provinceId: 133,
    description: 'Acostambo',
    state: '08',
    DESCR: 'ACOSTAMBO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 326,
    provinceId: 134,
    description: 'Cholon',
    state: '09',
    DESCR: 'CHOLON',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 327,
    provinceId: 135,
    description: 'Acobamba',
    state: '08',
    DESCR: 'ACOBAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 328,
    provinceId: 136,
    description: 'Guadalupe',
    state: '12',
    DESCR: 'GUADALUPE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 329,
    provinceId: 137,
    description: 'Antioquia',
    state: '14',
    DESCR: 'ANTIOQUIA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 330,
    provinceId: 138,
    description: 'Cahuapanas',
    state: '15',
    DESCR: 'CAHUAPANAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 331,
    provinceId: 139,
    description: 'El Alto',
    state: '19',
    DESCR: 'EL ALTO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 332,
    provinceId: 140,
    description: 'Cabanilla',
    state: '20',
    DESCR: 'CABANILLA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 333,
    provinceId: 141,
    description: 'Buenos aires',
    state: '19',
    DESCR: 'BUENOS AIRES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 334,
    provinceId: 142,
    description: 'Buena vista alta',
    state: '02',
    DESCR: 'BUENA VISTA ALTA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 335,
    provinceId: 143,
    description: 'Alca',
    state: '04',
    DESCR: 'ALCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 336,
    provinceId: 144,
    description: 'Colta',
    state: '05',
    DESCR: 'COLTA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 337,
    provinceId: 145,
    description: 'Bellavista',
    state: '06',
    DESCR: 'BELLAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 338,
    provinceId: 146,
    description: 'Condoroma',
    state: '07',
    DESCR: 'CONDOROMA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 339,
    provinceId: 147,
    description: 'Chaglla',
    state: '09',
    DESCR: 'CHAGLLA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 340,
    provinceId: 148,
    description: 'Chacapalpa',
    state: '11',
    DESCR: 'CHACAPALPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 341,
    provinceId: 149,
    description: 'Buldibuyo',
    state: '12',
    DESCR: 'BULDIBUYO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 342,
    provinceId: 150,
    description: 'Ambar',
    state: '14',
    DESCR: 'AMBAR',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 343,
    provinceId: 151,
    description: 'Bellavista de la Unión',
    state: '19',
    DESCR: 'BELLAVISTA DE LA UNION',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 344,
    provinceId: 152,
    description: 'Antauta',
    state: '20',
    DESCR: 'ANTAUTA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 345,
    provinceId: 153,
    description: 'Awajun',
    state: '21',
    DESCR: 'AWAJUN',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 346,
    provinceId: 154,
    description: 'Aco',
    state: '11',
    DESCR: 'ACO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 347,
    provinceId: 155,
    description: 'Belen',
    state: '05',
    DESCR: 'BELEN',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 348,
    provinceId: 156,
    description: 'Chirinos',
    state: '06',
    DESCR: 'CHIRINOS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 349,
    provinceId: 157,
    description: 'Echarate',
    state: '07',
    DESCR: 'ECHARATE',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 350,
    provinceId: 158,
    description: 'Codo del pozuzo',
    state: '09',
    DESCR: 'CODO DEL POZUZO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 351,
    provinceId: 159,
    description: 'Ahuac',
    state: '11',
    DESCR: 'AHUAC',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 352,
    provinceId: 160,
    description: 'Chugay',
    state: '12',
    DESCR: 'CHUGAY',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 353,
    provinceId: 161,
    description: 'Andajes',
    state: '14',
    DESCR: 'ANDAJES',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 354,
    provinceId: 162,
    description: 'Conima',
    state: '20',
    DESCR: 'CONIMA',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '02'
  },
  {
    id: 355,
    provinceId: 163,
    description: 'Alberto leveau',
    state: '21',
    DESCR: 'ALBERTO LEVEAU',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 356,
    provinceId: 164,
    description: 'Anra',
    state: '02',
    DESCR: 'ANRA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '16'
  },
  {
    id: 357,
    provinceId: 165,
    description: 'Alcamenca',
    state: '05',
    DESCR: 'ALCAMENCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 358,
    provinceId: 166,
    description: 'Chancay',
    state: '14',
    DESCR: 'CHANCAY',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 359,
    provinceId: 167,
    description: 'Accha',
    state: '07',
    DESCR: 'ACCHA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 360,
    provinceId: 168,
    description: 'Baños',
    state: '09',
    DESCR: 'BANOS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 361,
    provinceId: 169,
    description: 'Angasmarca',
    state: '12',
    DESCR: 'ANGASMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 362,
    provinceId: 170,
    description: 'Alis',
    state: '14',
    DESCR: 'ALIS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 363,
    provinceId: 171,
    description: 'Ananea',
    state: '20',
    DESCR: 'ANANEA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 364,
    provinceId: 172,
    description: 'Nuevo progreso',
    state: '21',
    DESCR: 'NUEVO PROGRESO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 365,
    provinceId: 173,
    description: 'Cochapeti',
    state: '02',
    DESCR: 'COCHAPETI',
    MBO_PROVINCIA: '19',
    MBO_DISTRITO: '02'
  },
  {
    id: 366,
    provinceId: 174,
    description: 'Accomarca',
    state: '05',
    DESCR: 'ACCOMARCA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 367,
    provinceId: 175,
    description: 'Bolivar',
    state: '12',
    DESCR: 'BOLIVAR',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 368,
    provinceId: 176,
    description: 'Caicay',
    state: '07',
    DESCR: 'CAICAY',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 369,
    provinceId: 177,
    description: 'Cahuac',
    state: '09',
    DESCR: 'CAHUAC',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 370,
    provinceId: 178,
    description: 'Lucma',
    state: '02',
    DESCR: 'LUCMA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 371,
    provinceId: 179,
    description: 'Bellavista',
    state: '06',
    DESCR: 'BELLAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 372,
    provinceId: 180,
    description: 'Cabana',
    state: '02',
    DESCR: 'CABANA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 373,
    provinceId: 181,
    description: 'Huallanca',
    state: '02',
    DESCR: 'HUALLANCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '25'
  },
  {
    id: 374,
    provinceId: 182,
    description: 'San bernardino',
    state: '06',
    DESCR: 'SAN BERNARDINO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '02'
  },
  {
    id: 375,
    provinceId: 183,
    description: 'Andahuaylillas',
    state: '07',
    DESCR: 'ANDAHUAYLILLAS',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '02'
  },
  {
    id: 376,
    provinceId: 184,
    description: 'Chao',
    state: '12',
    DESCR: 'CHAO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '02'
  },
  {
    id: 377,
    provinceId: 185,
    description: 'Cuyocuyo',
    state: '20',
    DESCR: 'CUYOCUYO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 378,
    provinceId: 186,
    description: 'Casca',
    state: '02',
    DESCR: 'CASCA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 379,
    provinceId: 187,
    description: 'Andabamba',
    state: '08',
    DESCR: 'ANDABAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 380,
    provinceId: 188,
    description: 'Chinchero',
    state: '07',
    DESCR: 'CHINCHERO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '02'
  },
  {
    id: 381,
    provinceId: 189,
    description: 'Anapia',
    state: '20',
    DESCR: 'ANAPIA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 382,
    provinceId: 190,
    description: 'Acas',
    state: '02',
    DESCR: 'ACAS',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '01'
  },
  {
    id: 383,
    provinceId: 191,
    description: 'Bolognesi',
    state: '02',
    DESCR: 'BOLOGNESI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 384,
    provinceId: 192,
    description: 'Huayllan',
    state: '02',
    DESCR: 'HUAYLLAN',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 385,
    provinceId: 193,
    description: 'Catac',
    state: '02',
    DESCR: 'CATAC',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '10'
  },
  {
    id: 386,
    provinceId: 194,
    description: 'Caceres del peru',
    state: '02',
    DESCR: 'CACERES DEL PERU',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '02'
  },
  {
    id: 387,
    provinceId: 195,
    description: 'Acobamba',
    state: '08',
    DESCR: 'ACOBAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 388,
    provinceId: 196,
    description: 'Cascapara',
    state: '02',
    DESCR: 'CASCAPARA',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '02'
  },
  {
    id: 389,
    provinceId: 1,
    description: 'Balsas',
    state: '01',
    DESCR: 'BALSAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 390,
    provinceId: 2,
    description: 'Colcabamba',
    state: '02',
    DESCR: 'COLCABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 391,
    provinceId: 3,
    description: 'Circa',
    state: '03',
    DESCR: 'CIRCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 392,
    provinceId: 4,
    description: 'Cayma',
    state: '04',
    DESCR: 'CAYMA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 393,
    provinceId: 5,
    description: 'Acos vinchos',
    state: '05',
    DESCR: 'ACOS VINCHOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 394,
    provinceId: 6,
    description: 'Chetilla',
    state: '06',
    DESCR: 'CHETILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 395,
    provinceId: 7,
    description: 'Carmen De La Lengua Reyno',
    state: '24',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04',
    DESCR: 'CARMEN DE LA LEGUA-REYNOSO'
  },
  {
    id: 396,
    provinceId: 8,
    description: 'Poroy',
    state: '07',
    DESCR: 'POROY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 397,
    provinceId: 9,
    description: 'Acoria',
    state: '08',
    DESCR: 'ACORIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 398,
    provinceId: 10,
    description: 'Chinchao',
    state: '09',
    DESCR: 'CHINCHAO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 399,
    provinceId: 11,
    description: 'Los aquijes',
    state: '10',
    DESCR: 'LOS AQUIJES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 400,
    provinceId: 13,
    description: 'Florencia de Mora',
    state: '12',
    DESCR: 'FLORENCIA DE MORA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 401,
    provinceId: 14,
    description: 'Eten',
    state: '13',
    DESCR: 'ETEN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 402,
    provinceId: 15,
    description: 'Ate',
    state: '14',
    DESCR: 'ATE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 403,
    provinceId: 16,
    description: 'Fernando lores',
    state: '15',
    DESCR: 'FERNANDO LORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 404,
    provinceId: 17,
    description: 'Las piedras',
    state: '16',
    DESCR: 'LAS PIEDRAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 405,
    provinceId: 18,
    description: 'Cuchumbaya',
    state: '17',
    DESCR: 'CUCHUMBAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 406,
    provinceId: 19,
    description: 'Huariaca',
    state: '18',
    DESCR: 'HUARIACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 407,
    provinceId: 21,
    description: 'Amantani',
    state: '20',
    DESCR: 'AMANTANI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 408,
    provinceId: 22,
    description: 'Habana',
    state: '21',
    DESCR: 'HABANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 409,
    provinceId: 23,
    description: 'Calana',
    state: '22',
    DESCR: 'CALANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 410,
    provinceId: 24,
    description: 'La Cruz',
    state: '23',
    DESCR: 'LA CRUZ',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 411,
    provinceId: 25,
    description: 'Iparia',
    state: '25',
    DESCR: 'IPARIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 412,
    provinceId: 26,
    description: 'Copallin',
    state: '01',
    DESCR: 'COPALLIN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 413,
    provinceId: 27,
    description: 'Huacllan',
    state: '02',
    DESCR: 'HUACLLAN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 414,
    provinceId: 28,
    description: 'Chiara',
    state: '03',
    DESCR: 'CHIARA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 415,
    provinceId: 29,
    description: 'Mariano nicolas valcarcel',
    state: '04',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03',
    DESCR: 'MARIANO N VALCARCEL'
  },
  {
    id: 416,
    provinceId: 30,
    description: 'Los morochucos',
    state: '05',
    DESCR: 'LOS MOROCHUCOS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 417,
    provinceId: 31,
    description: 'Condebamba',
    state: '06',
    DESCR: 'CONDEBAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 418,
    provinceId: 32,
    description: 'Acos',
    state: '07',
    DESCR: 'ACOS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 419,
    provinceId: 33,
    description: 'Anta',
    state: '02',
    DESCR: 'ANTA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 420,
    provinceId: 34,
    description: 'Colpas',
    state: '09',
    DESCR: 'COLPAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 421,
    provinceId: 35,
    description: 'Chavin',
    state: '10',
    DESCR: 'CHAVIN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 422,
    provinceId: 36,
    description: 'Andamarca',
    state: '11',
    DESCR: 'ANDAMARCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 423,
    provinceId: 37,
    description: 'Chocope',
    state: '12',
    DESCR: 'CHOCOPE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 424,
    provinceId: 38,
    description: 'Incahuasi',
    state: '13',
    DESCR: 'INCAHUASI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 425,
    provinceId: 39,
    description: 'Pativilca',
    state: '14',
    DESCR: 'PATIVILCA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 426,
    provinceId: 40,
    description: 'Barranca',
    state: '15',
    DESCR: 'BARRANCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 427,
    provinceId: 41,
    description: 'Madre de dios',
    state: '16',
    DESCR: 'MADRE DE DIOS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 428,
    provinceId: 42,
    description: 'Coalaque',
    state: '17',
    DESCR: 'COALAQUE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 429,
    provinceId: 43,
    description: 'Goyllarisquizga',
    state: '18',
    DESCR: 'GOYLLARISQUIZGA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 430,
    provinceId: 44,
    description: 'Jililí',
    state: '19',
    DESCR: 'JILILI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '09'
  },
  {
    id: 431,
    provinceId: 45,
    description: 'Arapa',
    state: '20',
    DESCR: 'ARAPA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 432,
    provinceId: 46,
    description: 'Bajo biavo',
    state: '21',
    DESCR: 'BAJO BIAVO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 433,
    provinceId: 47,
    description: 'Camilaca',
    state: '22',
    DESCR: 'CAMILACA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 434,
    provinceId: 49,
    description: 'Tahuania',
    state: '25',
    DESCR: 'TAHUANIA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 435,
    provinceId: 50,
    description: 'Churuja',
    state: '01',
    DESCR: 'CHURUJA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 436,
    provinceId: 51,
    description: 'Chaccho',
    state: '02',
    DESCR: 'CHACCHO',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '03'
  },
  {
    id: 437,
    provinceId: 52,
    description: 'Huaquirca',
    state: '03',
    DESCR: 'HUAQUIRCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 438,
    provinceId: 53,
    description: 'Atico',
    state: '04',
    DESCR: 'ATICO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 439,
    provinceId: 54,
    description: 'Sacsamarca',
    state: '05',
    DESCR: 'SACSAMARCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 440,
    provinceId: 55,
    description: 'Cortegana',
    state: '06',
    DESCR: 'CORTEGANA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 441,
    provinceId: 56,
    description: 'Cachimayo',
    state: '07',
    DESCR: 'CACHIMAYO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 442,
    provinceId: 57,
    description: 'Callanmarca',
    state: '08',
    DESCR: 'CALLANMARCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 443,
    provinceId: 59,
    description: 'El ingenio',
    state: '10',
    DESCR: 'EL INGENIO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 444,
    provinceId: 60,
    description: 'Pichanaqui',
    state: '11',
    DESCR: 'PICHANAQUI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 445,
    provinceId: 61,
    description: 'Condormarca',
    state: '12',
    DESCR: 'CONDORMARCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 446,
    provinceId: 62,
    description: 'Illimo',
    state: '13',
    DESCR: 'ILLIMO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 447,
    provinceId: 63,
    description: 'Gorgor',
    state: '14',
    DESCR: 'GORGOR',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 448,
    provinceId: 64,
    description: 'Tigre',
    state: '15',
    DESCR: 'TIGRE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 449,
    provinceId: 65,
    description: 'Tahuamanu',
    state: '16',
    DESCR: 'TAHUAMANU',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 450,
    provinceId: 66,
    description: 'Pacocha',
    state: '17',
    DESCR: 'PACOCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 451,
    provinceId: 67,
    description: 'Huancabamba',
    state: '18',
    DESCR: 'HUANCABAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 452,
    provinceId: 68,
    description: 'El Carmen de la Frontera',
    state: '19',
    DESCR: 'EL CARMEN DE LA FRONTERA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 453,
    provinceId: 69,
    description: 'Ayapata',
    state: '20',
    DESCR: 'AYAPATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 454,
    provinceId: 70,
    description: 'San martin',
    state: '21',
    DESCR: 'SAN MARTIN',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 455,
    provinceId: 71,
    description: 'Ite',
    state: '22',
    DESCR: 'ITE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 456,
    provinceId: 72,
    description: 'Matapalo',
    state: '23',
    DESCR: 'MATAPALO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 457,
    provinceId: 73,
    description: 'Curimana',
    state: '25',
    DESCR: 'CURIMANA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 458,
    provinceId: 74,
    description: 'Rio santiago',
    state: '01',
    DESCR: 'RIO SANTIAGO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 459,
    provinceId: 76,
    description: 'Caraybamba',
    state: '03',
    DESCR: 'CARAYBAMBA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 460,
    provinceId: 77,
    description: 'Ayo',
    state: '04',
    DESCR: 'AYO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 461,
    provinceId: 78,
    description: 'Huamanguilla',
    state: '05',
    DESCR: 'HUAMANGUILLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 462,
    provinceId: 79,
    description: 'Chadin',
    state: '06',
    DESCR: 'CHADIN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 463,
    provinceId: 80,
    description: 'Lamay',
    state: '07',
    DESCR: 'LAMAY',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 464,
    provinceId: 81,
    description: 'Aurahua',
    state: '08',
    DESCR: 'AURAHUA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 465,
    provinceId: 82,
    description: 'Cochabamba',
    state: '02',
    DESCR: 'COCHABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 466,
    provinceId: 83,
    description: 'Rio grande',
    state: '04',
    DESCR: 'RIO GRANDE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 467,
    provinceId: 84,
    description: 'Apata',
    state: '11',
    DESCR: 'APATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 468,
    provinceId: 85,
    description: 'Pueblo nuevo',
    state: '12',
    DESCR: 'PUEBLO NUEVO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 469,
    provinceId: 86,
    description: 'Huamantanga',
    state: '14',
    DESCR: 'HUAMANTANGA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 470,
    provinceId: 87,
    description: 'Yavari',
    state: '15',
    DESCR: 'YAVARI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 471,
    provinceId: 88,
    description: 'Chalaco',
    state: '19',
    DESCR: 'CHALACO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 472,
    provinceId: 89,
    description: 'Huacullani',
    state: '20',
    DESCR: 'HUACULLANI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 473,
    provinceId: 90,
    description: 'El eslabon',
    state: '21',
    DESCR: 'EL ESLABON',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 474,
    provinceId: 91,
    description: 'Estique',
    state: '22',
    DESCR: 'ESTIQUE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 475,
    provinceId: 93,
    description: 'Cocabamba',
    state: '01',
    DESCR: 'COCABAMBA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 476,
    provinceId: 94,
    description: 'Antonio raymondi',
    state: '02',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '21',
    DESCR: 'ANTONIO RAIMONDI'
  },
  {
    id: 477,
    provinceId: 95,
    description: 'Coyllurqui',
    state: '03',
    DESCR: 'COYLLURQUI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 478,
    provinceId: 96,
    description: 'Cabanaconde',
    state: '04',
    DESCR: 'CABANACONDE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 479,
    provinceId: 97,
    description: 'Ayna',
    state: '05',
    DESCR: 'AYNA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 480,
    provinceId: 98,
    description: 'Cupisnique',
    state: '06',
    DESCR: 'CUPISNIQUE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 481,
    provinceId: 99,
    description: 'Kunturkanki',
    state: '07',
    DESCR: 'KUNTURKANKI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 482,
    provinceId: 100,
    description: 'Chinchihuasi',
    state: '08',
    DESCR: 'CHINCHIHUASI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 483,
    provinceId: 101,
    description: 'Chavin de pariarca',
    state: '09',
    DESCR: 'CHAVIN DE PARIARCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 484,
    provinceId: 102,
    description: 'Humay',
    state: '10',
    DESCR: 'HUMAY',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 485,
    provinceId: 103,
    description: 'Ondores',
    state: '11',
    DESCR: 'ONDORES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 486,
    provinceId: 104,
    description: 'Carabamba',
    state: '12',
    DESCR: 'CARABAMBA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 487,
    provinceId: 105,
    description: 'Calango',
    state: '14',
    DESCR: 'CALANGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '02'
  },
  {
    id: 488,
    provinceId: 106,
    description: 'Capelo',
    state: '15',
    DESCR: 'CAPELO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 489,
    provinceId: 107,
    description: 'Arenal',
    state: '19',
    DESCR: 'ARENAL',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 490,
    provinceId: 108,
    description: 'Pilcuyo',
    state: '20',
    DESCR: 'PILCUYO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '02'
  },
  {
    id: 491,
    provinceId: 109,
    description: 'Barranquita',
    state: '21',
    DESCR: 'BARRANQUITA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 492,
    provinceId: 110,
    description: 'Cochamal',
    state: '01',
    DESCR: 'COCHAMAL',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 493,
    provinceId: 111,
    description: 'Amashca',
    state: '02',
    DESCR: 'AMASHCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 494,
    provinceId: 112,
    description: 'Cocharcas',
    state: '03',
    DESCR: 'COCHARCAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 495,
    provinceId: 113,
    description: 'Cayarani',
    state: '04',
    DESCR: 'CAYARANI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 496,
    provinceId: 114,
    description: 'Cabana',
    state: '02',
    DESCR: 'CABANA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '01'
  },
  {
    id: 497,
    provinceId: 115,
    description: 'Choros',
    state: '06',
    DESCR: 'CHOROS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 498,
    provinceId: 116,
    description: 'Combapata',
    state: '07',
    DESCR: 'COMBAPATA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 499,
    provinceId: 117,
    description: 'Cordova',
    state: '08',
    DESCR: 'CORDOVA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '02'
  },
  {
    id: 500,
    provinceId: 118,
    description: 'Hermilio valdizan',
    state: '09',
    DESCR: 'HERMILIO VALDIZAN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 501,
    provinceId: 119,
    description: 'Coviriali',
    state: '11',
    DESCR: 'COVIRIALI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 502,
    provinceId: 121,
    description: 'Atavillos bajo',
    state: '14',
    DESCR: 'ATAVILLOS BAJO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 503,
    provinceId: 122,
    description: 'Padre marquez',
    state: '15',
    DESCR: 'PADRE MARQUEZ',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 504,
    provinceId: 123,
    description: 'Ignacio Escudero',
    state: '19',
    DESCR: 'IGNACIO ESCUDERO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 505,
    provinceId: 124,
    description: 'Huatasani',
    state: '20',
    DESCR: 'HUATASANI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '11'
  },
  {
    id: 506,
    provinceId: 125,
    description: 'Huicungo',
    state: '21',
    DESCR: 'HUICUNGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 507,
    provinceId: 126,
    description: 'Cumba',
    state: '01',
    DESCR: 'CUMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 508,
    provinceId: 127,
    description: 'Yauya',
    state: '02',
    DESCR: 'YAUYA',
    MBO_PROVINCIA: '17',
    MBO_DISTRITO: '02'
  },
  {
    id: 509,
    provinceId: 128,
    description: 'Gamarra',
    state: '03',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05',
    DESCR: 'MARISCAL GAMARRA'
  },
  {
    id: 510,
    provinceId: 129,
    description: 'Dean valdivia',
    state: '04',
    DESCR: 'DEAN VALDIVIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 511,
    provinceId: 130,
    description: 'Coronel castañeda',
    state: '05',
    DESCR: 'CORONEL CASTANEDA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 512,
    provinceId: 131,
    description: 'Hualgayoc',
    state: '06',
    DESCR: 'HUALGAYOC',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 513,
    provinceId: 132,
    description: 'Chamaca',
    state: '07',
    DESCR: 'CHAMACA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 514,
    provinceId: 133,
    description: 'Acraquia',
    state: '08',
    DESCR: 'ACRAQUIA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 515,
    provinceId: 134,
    description: 'San buenaventura',
    state: '09',
    DESCR: 'SAN BUENAVENTURA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 516,
    provinceId: 135,
    description: 'Huaricolca',
    state: '11',
    DESCR: 'HUARICOLCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 517,
    provinceId: 136,
    description: 'Jequetepeque',
    state: '12',
    DESCR: 'JEQUETEPEQUE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 518,
    provinceId: 137,
    description: 'Callahuanca',
    state: '14',
    DESCR: 'CALLAHUANCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 519,
    provinceId: 138,
    description: 'Manseriche',
    state: '15',
    DESCR: 'MANSERICHE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 520,
    provinceId: 139,
    description: 'La Brea',
    state: '19',
    DESCR: 'LA BREA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 521,
    provinceId: 140,
    description: 'Calapuja',
    state: '20',
    DESCR: 'CALAPUJA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 522,
    provinceId: 141,
    description: 'Caspisapa',
    state: '21',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03',
    DESCR: 'CASPIZAPA'
  },
  {
    id: 523,
    provinceId: 142,
    description: 'Comandante noel',
    state: '02',
    DESCR: 'COMANDANTE NOEL',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 524,
    provinceId: 143,
    description: 'Charcana',
    state: '04',
    DESCR: 'CHARCANA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 525,
    provinceId: 144,
    description: 'Corculla',
    state: '05',
    DESCR: 'CORCULLA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 526,
    provinceId: 145,
    description: 'Chontali',
    state: '06',
    DESCR: 'CHONTALI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 527,
    provinceId: 146,
    description: 'Coporaque',
    state: '07',
    DESCR: 'COPORAQUE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 528,
    provinceId: 147,
    description: 'Molino',
    state: '09',
    DESCR: 'MOLINO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 529,
    provinceId: 148,
    description: 'Paccha',
    state: '06',
    DESCR: 'PACCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 530,
    provinceId: 149,
    description: 'Chillia',
    state: '12',
    DESCR: 'CHILLIA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 531,
    provinceId: 150,
    description: 'Caleta de carquin',
    state: '14',
    DESCR: 'CALETA DE CARQUIN',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 532,
    provinceId: 151,
    description: 'Bernal',
    state: '19',
    DESCR: 'BERNAL',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 533,
    provinceId: 152,
    description: 'Cupi',
    state: '20',
    DESCR: 'CUPI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 534,
    provinceId: 153,
    description: 'Elias soplin vargas',
    state: '21',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06',
    DESCR: 'ELIAS SOPLIN'
  },
  {
    id: 535,
    provinceId: 154,
    description: 'Bambas',
    state: '02',
    DESCR: 'BAMBAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 536,
    provinceId: 155,
    description: 'Chalcos',
    state: '05',
    DESCR: 'CHALCOS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 537,
    provinceId: 156,
    description: 'Huarango',
    state: '06',
    DESCR: 'HUARANGO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 538,
    provinceId: 157,
    description: 'Huayopata',
    state: '07',
    DESCR: 'HUAYOPATA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 539,
    provinceId: 158,
    description: 'Honoria',
    state: '09',
    DESCR: 'HONORIA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '01'
  },
  {
    id: 540,
    provinceId: 159,
    description: 'Huachac',
    state: '11',
    DESCR: 'HUACHAC',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 541,
    provinceId: 160,
    description: 'Cochorco',
    state: '12',
    DESCR: 'COCHORCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 542,
    provinceId: 161,
    description: 'Caujul',
    state: '14',
    DESCR: 'CAUJUL',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 543,
    provinceId: 162,
    description: 'Huayrapata',
    state: '20',
    DESCR: 'HUAYRAPATA',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '04'
  },
  {
    id: 544,
    provinceId: 163,
    description: 'Cacatachi',
    state: '21',
    DESCR: 'CACATACHI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 545,
    provinceId: 164,
    description: 'Cajay',
    state: '02',
    DESCR: 'CAJAY',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 546,
    provinceId: 165,
    description: 'Apongo',
    state: '05',
    DESCR: 'APONGO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 547,
    provinceId: 166,
    description: 'Eduardo villanueva',
    state: '06',
    DESCR: 'EDUARDO VILLANUEVA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '05'
  },
  {
    id: 548,
    provinceId: 167,
    description: 'Ccapi',
    state: '07',
    DESCR: 'CCAPI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 549,
    provinceId: 168,
    description: 'Jivia',
    state: '09',
    DESCR: 'JIVIA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 550,
    provinceId: 169,
    description: 'Cachicadan',
    state: '12',
    DESCR: 'CACHICADAN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 551,
    provinceId: 170,
    description: 'Ayauca',
    state: '14',
    DESCR: 'AYAUCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 552,
    provinceId: 171,
    description: 'Pedro vilca apaza',
    state: '20',
    DESCR: 'PEDRO VILCA APAZA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 553,
    provinceId: 172,
    description: 'Polvora',
    state: '21',
    DESCR: 'POLVORA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 554,
    provinceId: 173,
    description: 'Culebras',
    state: '02',
    DESCR: 'CULEBRAS',
    MBO_PROVINCIA: '19',
    MBO_DISTRITO: '05'
  },
  {
    id: 555,
    provinceId: 174,
    description: 'Carhuanca',
    state: '05',
    DESCR: 'CARHUANCA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 556,
    provinceId: 175,
    description: 'Calquis',
    state: '06',
    DESCR: 'CALQUIS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 557,
    provinceId: 176,
    description: 'Challabamba',
    state: '07',
    DESCR: 'CHALLABAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 558,
    provinceId: 177,
    description: 'Chacabamba',
    state: '09',
    DESCR: 'CHACABAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 559,
    provinceId: 178,
    description: 'Marmot',
    state: '12',
    DESCR: 'MARMOT',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 560,
    provinceId: 179,
    description: 'Carmen de la legua reynos',
    state: '24',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04',
    DESCR: 'CARMEN DE LA LEGUA-REYNOSO'
  },
  {
    id: 561,
    provinceId: 180,
    description: 'Cabanillas',
    state: '20',
    DESCR: 'CABANILLAS',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 562,
    provinceId: 181,
    description: 'Huata',
    state: '02',
    DESCR: 'HUATA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 563,
    provinceId: 182,
    description: 'San luis',
    state: '02',
    DESCR: 'SAN LUIS',
    MBO_PROVINCIA: '17',
    MBO_DISTRITO: '01'
  },
  {
    id: 564,
    provinceId: 183,
    description: 'Camanti',
    state: '07',
    DESCR: 'CAMANTI',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '03'
  },
  {
    id: 565,
    provinceId: 184,
    description: 'Guadalupito',
    state: '12',
    DESCR: 'GUADALUPITO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '03'
  },
  {
    id: 566,
    provinceId: 185,
    description: 'Limbani',
    state: '20',
    DESCR: 'LIMBANI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 567,
    provinceId: 186,
    description: 'Eleazar guzman barron',
    state: '02',
    DESCR: 'ELEAZAR GUZMAN BARRON',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 568,
    provinceId: 187,
    description: 'Catache',
    state: '06',
    DESCR: 'CATACHE',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 569,
    provinceId: 188,
    description: 'Huayllabamba',
    state: '02',
    DESCR: 'HUAYLLABAMBA',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '04'
  },
  {
    id: 570,
    provinceId: 189,
    description: 'Copani',
    state: '20',
    DESCR: 'COPANI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 571,
    provinceId: 190,
    description: 'Cajamarquilla',
    state: '02',
    DESCR: 'CAJAMARQUILLA',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '02'
  },
  {
    id: 572,
    provinceId: 191,
    description: 'Conchucos',
    state: '02',
    DESCR: 'CONCHUCOS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 573,
    provinceId: 192,
    description: 'Parobamba',
    state: '02',
    DESCR: 'PAROBAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 574,
    provinceId: 193,
    description: 'Cotaparaco',
    state: '02',
    DESCR: 'COTAPARACO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '02'
  },
  {
    id: 575,
    provinceId: 194,
    description: 'Coishco',
    state: '02',
    DESCR: 'COISHCO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '08'
  },
  {
    id: 576,
    provinceId: 195,
    description: 'Alfonso ugarte',
    state: '02',
    DESCR: 'ALFONSO UGARTE',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '02'
  },
  {
    id: 577,
    provinceId: 196,
    description: 'Mancos',
    state: '02',
    DESCR: 'MANCOS',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '03'
  },
  {
    id: 578,
    provinceId: 1,
    description: 'Cheto',
    state: '01',
    DESCR: 'CHETO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 579,
    provinceId: 2,
    description: 'Huanchay',
    state: '02',
    DESCR: 'HUANCHAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 580,
    provinceId: 3,
    description: 'Curahuasi',
    state: '03',
    DESCR: 'CURAHUASI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 581,
    provinceId: 4,
    description: 'Cerro colorado',
    state: '04',
    DESCR: 'CERRO COLORADO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 582,
    provinceId: 5,
    description: 'Carmen alto',
    state: '05',
    DESCR: 'CARMEN ALTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 583,
    provinceId: 6,
    description: 'Cospan',
    state: '06',
    DESCR: 'COSPAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 584,
    provinceId: 7,
    description: 'La Perla',
    state: '24',
    DESCR: 'LA PERLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 585,
    provinceId: 8,
    description: 'San jeronimo',
    state: '01',
    DESCR: 'SAN JERONIMO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '17'
  },
  {
    id: 586,
    provinceId: 9,
    description: 'Conayca',
    state: '08',
    DESCR: 'CONAYCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 587,
    provinceId: 10,
    description: 'Churubamba',
    state: '09',
    DESCR: 'CHURUBAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 588,
    provinceId: 11,
    description: 'Ocucaje',
    state: '10',
    DESCR: 'OCUCAJE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 589,
    provinceId: 12,
    description: 'Carhuacallanga',
    state: '11',
    DESCR: 'CARHUACALLANGA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 590,
    provinceId: 13,
    description: 'Huanchaco',
    state: '12',
    DESCR: 'HUANCHACO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 591,
    provinceId: 14,
    description: 'Eten puerto',
    state: '13',
    DESCR: 'ETEN PUERTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 592,
    provinceId: 15,
    description: 'Barranco',
    state: '14',
    DESCR: 'BARRANCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '25'
  },
  {
    id: 593,
    provinceId: 16,
    description: 'Indiana',
    state: '15',
    DESCR: 'INDIANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 594,
    provinceId: 17,
    description: 'Laberinto',
    state: '16',
    DESCR: 'LABERINTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 595,
    provinceId: 18,
    description: 'Samegua',
    state: '17',
    DESCR: 'SAMEGUA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 596,
    provinceId: 19,
    description: 'Huayllay',
    state: '18',
    DESCR: 'HUAYLLAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 597,
    provinceId: 20,
    description: 'Castilla',
    state: '19',
    DESCR: 'CASTILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 598,
    provinceId: 21,
    description: 'Atuncolla',
    state: '20',
    DESCR: 'ATUNCOLLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 599,
    provinceId: 22,
    description: 'Jepelacio',
    state: '21',
    DESCR: 'JEPELACIO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 600,
    provinceId: 23,
    description: 'Ciudad nueva',
    state: '22',
    DESCR: 'CIUDAD NUEVA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 601,
    provinceId: 24,
    description: 'Pampas de Hospital',
    state: '23',
    DESCR: 'PAMPAS DE HOSPITAL',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 602,
    provinceId: 25,
    description: 'Masisea',
    state: '25',
    DESCR: 'MASISEA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 603,
    provinceId: 26,
    description: 'El parco',
    state: '01',
    DESCR: 'EL PARCO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 604,
    provinceId: 27,
    description: 'La merced',
    state: '02',
    DESCR: 'LA MERCED',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 605,
    provinceId: 28,
    description: 'Huancarama',
    state: '03',
    DESCR: 'HUANCARAMA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 606,
    provinceId: 29,
    description: 'Mariscal caceres',
    state: '04',
    DESCR: 'MARISCAL CACERES',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 607,
    provinceId: 30,
    description: 'Maria parado de bellido',
    state: '05',
    DESCR: 'MARIA PARADO DE BELLIDO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 608,
    provinceId: 31,
    description: 'Sitacocha',
    state: '06',
    DESCR: 'SITACOCHA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 609,
    provinceId: 32,
    description: 'Mosoc llacta',
    state: '07',
    DESCR: 'MOSOC LLACTA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 610,
    provinceId: 33,
    description: 'Caja',
    state: '08',
    DESCR: 'CAJA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 611,
    provinceId: 34,
    description: 'Conchamarca',
    state: '09',
    DESCR: 'CONCHAMARCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 612,
    provinceId: 35,
    description: 'Chincha baja',
    state: '10',
    DESCR: 'CHINCHA BAJA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 613,
    provinceId: 36,
    description: 'Chambara',
    state: '11',
    DESCR: 'CHAMBARA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 614,
    provinceId: 37,
    description: 'Magdalena de Cao',
    state: '12',
    DESCR: 'MAGDALENA DE CAO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 615,
    provinceId: 38,
    description: 'Manuel Antonio Mesones Mu',
    state: '13',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06',
    DESCR: 'MANUEL ANTONIO MESONES MURO'
  },
  {
    id: 616,
    provinceId: 39,
    description: 'Supe',
    state: '14',
    DESCR: 'SUPE',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 617,
    provinceId: 40,
    description: 'Cahuapanas',
    state: '15',
    DESCR: 'CAHUAPANAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 618,
    provinceId: 41,
    description: 'Huepetuche',
    state: '16',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04',
    DESCR: 'HUEPETUHE'
  },
  {
    id: 619,
    provinceId: 42,
    description: 'Ichuña',
    state: '17',
    DESCR: 'ICHUNA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 620,
    provinceId: 43,
    description: 'Paucar',
    state: '18',
    DESCR: 'PAUCAR',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 621,
    provinceId: 44,
    description: 'Lagunas',
    state: '15',
    DESCR: 'LAGUNAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 622,
    provinceId: 45,
    description: 'Asillo',
    state: '20',
    DESCR: 'ASILLO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 623,
    provinceId: 46,
    description: 'Huallaga',
    state: '21',
    DESCR: 'HUALLAGA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 624,
    provinceId: 47,
    description: 'Curibaya',
    state: '22',
    DESCR: 'CURIBAYA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 625,
    provinceId: 49,
    description: 'Yurua',
    state: '25',
    DESCR: 'YURUA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 626,
    provinceId: 50,
    description: 'Corosha',
    state: '01',
    DESCR: 'COROSHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 627,
    provinceId: 51,
    description: 'Chingas',
    state: '02',
    DESCR: 'CHINGAS',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '04'
  },
  {
    id: 628,
    provinceId: 52,
    description: 'Juan espinoza medrano',
    state: '03',
    DESCR: 'JUAN ESPINOZA MEDRANO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 629,
    provinceId: 53,
    description: 'Atiquipa',
    state: '04',
    DESCR: 'ATIQUIPA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 630,
    provinceId: 54,
    description: 'Santiago de lucanamarca',
    state: '05',
    DESCR: 'SANTIAGO DE LUCANAMARCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 631,
    provinceId: 55,
    description: 'Huasmin',
    state: '06',
    DESCR: 'HUASMIN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 632,
    provinceId: 56,
    description: 'Chinchaypujio',
    state: '07',
    DESCR: 'CHINCHAYPUJIO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '02'
  },
  {
    id: 633,
    provinceId: 57,
    description: 'Ccochaccasa',
    state: '08',
    DESCR: 'CCOCHACCASA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 634,
    provinceId: 59,
    description: 'Marcona',
    state: '10',
    DESCR: 'MARCONA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 635,
    provinceId: 60,
    description: 'San luis de shuaro',
    state: '11',
    DESCR: 'SAN LUIS DE SHUARO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 636,
    provinceId: 61,
    description: 'Longotea',
    state: '12',
    DESCR: 'LONGOTEA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 637,
    provinceId: 62,
    description: 'Jayanca',
    state: '13',
    DESCR: 'JAYANCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 638,
    provinceId: 63,
    description: 'Huancapon',
    state: '14',
    DESCR: 'HUANCAPON',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 639,
    provinceId: 64,
    description: 'Trompeteros',
    state: '15',
    DESCR: 'TROMPETEROS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 640,
    provinceId: 67,
    description: 'Palcazu',
    state: '18',
    DESCR: 'PALCAZU',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 641,
    provinceId: 68,
    description: 'Huarmaca',
    state: '19',
    DESCR: 'HUARMACA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 642,
    provinceId: 69,
    description: 'Coasa',
    state: '20',
    DESCR: 'COASA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 643,
    provinceId: 70,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 644,
    provinceId: 72,
    description: 'Papayal',
    state: '23',
    DESCR: 'PAPAYAL',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 645,
    provinceId: 76,
    description: 'Chapimarca',
    state: '03',
    DESCR: 'CHAPIMARCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 646,
    provinceId: 77,
    description: 'Chachas',
    state: '04',
    DESCR: 'CHACHAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 647,
    provinceId: 78,
    description: 'Iguain',
    state: '05',
    DESCR: 'IGUAIN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 648,
    provinceId: 79,
    description: 'Chiguirip',
    state: '06',
    DESCR: 'CHIGUIRIP',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 649,
    provinceId: 80,
    description: 'Lares',
    state: '07',
    DESCR: 'LARES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 650,
    provinceId: 81,
    description: 'Capillas',
    state: '08',
    DESCR: 'CAPILLAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 651,
    provinceId: 82,
    description: 'Pinra',
    state: '09',
    DESCR: 'PINRA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 652,
    provinceId: 83,
    description: 'Santa cruz',
    state: '15',
    DESCR: 'SANTA CRUZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 653,
    provinceId: 84,
    description: 'Ataura',
    state: '11',
    DESCR: 'ATAURA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 654,
    provinceId: 85,
    description: 'Santa  Rosa',
    state: '14',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29',
    DESCR: 'SANTA ROSA'
  },
  {
    id: 655,
    provinceId: 86,
    description: 'Huaros',
    state: '14',
    DESCR: 'HUAROS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 656,
    provinceId: 87,
    description: 'San pablo',
    state: '06',
    DESCR: 'SAN PABLO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 657,
    provinceId: 88,
    description: 'La Matanza',
    state: '19',
    DESCR: 'LA MATANZA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 658,
    provinceId: 89,
    description: 'Kelluyo',
    state: '20',
    DESCR: 'KELLUYO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 659,
    provinceId: 90,
    description: 'Piscoyacu',
    state: '21',
    DESCR: 'PISCOYACU',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '02'
  },
  {
    id: 660,
    provinceId: 91,
    description: 'Estique - pampa',
    state: '22',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07',
    DESCR: 'ESTIQUE PAMPA'
  },
  {
    id: 661,
    provinceId: 93,
    description: 'Colcamar',
    state: '01',
    DESCR: 'COLCAMAR',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 662,
    provinceId: 94,
    description: 'Aquia',
    state: '02',
    DESCR: 'AQUIA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 663,
    provinceId: 95,
    description: 'Haquira',
    state: '03',
    DESCR: 'HAQUIRA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 664,
    provinceId: 96,
    description: 'Callalli',
    state: '04',
    DESCR: 'CALLALLI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 665,
    provinceId: 97,
    description: 'Chilcas',
    state: '05',
    DESCR: 'CHILCAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 666,
    provinceId: 98,
    description: 'Guzmango',
    state: '06',
    DESCR: 'GUZMANGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 667,
    provinceId: 99,
    description: 'Langui',
    state: '07',
    DESCR: 'LANGUI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 668,
    provinceId: 100,
    description: 'El carmen',
    state: '08',
    DESCR: 'EL CARMEN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 669,
    provinceId: 101,
    description: 'Jacas grande',
    state: '09',
    DESCR: 'JACAS GRANDE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 670,
    provinceId: 102,
    description: 'Independencia',
    state: '05',
    DESCR: 'INDEPENDENCIA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 671,
    provinceId: 103,
    description: 'Ulcumayo',
    state: '11',
    DESCR: 'ULCUMAYO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 672,
    provinceId: 104,
    description: 'Huaso',
    state: '12',
    DESCR: 'HUASO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 673,
    provinceId: 105,
    description: 'Cerro azul',
    state: '14',
    DESCR: 'CERRO AZUL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 674,
    provinceId: 106,
    description: 'Emilio san martin',
    state: '15',
    DESCR: 'EMILIO SAN MARTIN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 675,
    provinceId: 107,
    description: 'Colán',
    state: '19',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05',
    DESCR: 'PUEBLO NUEVO DE COLAN'
  },
  {
    id: 676,
    provinceId: 108,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 677,
    provinceId: 109,
    description: 'Caynarachi',
    state: '21',
    DESCR: 'CAYNARACHI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 678,
    provinceId: 110,
    description: 'Huambo',
    state: '01',
    DESCR: 'HUAMBO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 679,
    provinceId: 111,
    description: 'Anta',
    state: '02',
    DESCR: 'ANTA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 680,
    provinceId: 112,
    description: 'Huaccana',
    state: '03',
    DESCR: 'HUACCANA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 681,
    provinceId: 113,
    description: 'Chichas',
    state: '04',
    DESCR: 'CHICHAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 682,
    provinceId: 114,
    description: 'Carmen salcedo',
    state: '05',
    DESCR: 'CARMEN SALCEDO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 683,
    provinceId: 115,
    description: 'Cujillo',
    state: '06',
    DESCR: 'CUJILLO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 684,
    provinceId: 116,
    description: 'Marangani',
    state: '07',
    DESCR: 'MARANGANI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 685,
    provinceId: 117,
    description: 'Huayacundo arma',
    state: '08',
    DESCR: 'HUAYACUNDO ARMA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 686,
    provinceId: 118,
    description: 'Jose crespo y castillo',
    state: '09',
    DESCR: 'JOSE CRESPO Y CASTILLO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 687,
    provinceId: 119,
    description: 'Mazamari',
    state: '11',
    DESCR: 'MAZAMARI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 688,
    provinceId: 120,
    description: 'Charat',
    state: '12',
    DESCR: 'CHARAT',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '03'
  },
  {
    id: 689,
    provinceId: 121,
    description: 'Aucallama',
    state: '14',
    DESCR: 'AUCALLAMA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 690,
    provinceId: 122,
    description: 'Pampa hermosa',
    state: '11',
    DESCR: 'PAMPA HERMOSA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 691,
    provinceId: 123,
    description: 'Lancones',
    state: '19',
    DESCR: 'LANCONES',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03'
  },
  {
    id: 692,
    provinceId: 124,
    description: 'Inchupalla',
    state: '20',
    DESCR: 'INCHUPALLA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 693,
    provinceId: 125,
    description: 'Pachiza',
    state: '21',
    DESCR: 'PACHIZA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 694,
    provinceId: 126,
    description: 'El milagro',
    state: '01',
    DESCR: 'EL MILAGRO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 695,
    provinceId: 128,
    description: 'Huayllati',
    state: '03',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03',
    DESCR: 'HUAILLATI'
  },
  {
    id: 696,
    provinceId: 129,
    description: 'Islay',
    state: '04',
    DESCR: 'ISLAY',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 697,
    provinceId: 130,
    description: 'Pacapausa',
    state: '05',
    DESCR: 'PACAPAUSA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 698,
    provinceId: 132,
    description: 'Colquemarca',
    state: '07',
    DESCR: 'COLQUEMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 699,
    provinceId: 133,
    description: 'Ahuaycha',
    state: '08',
    DESCR: 'AHUAYCHA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 700,
    provinceId: 135,
    description: 'Huasahuasi',
    state: '11',
    DESCR: 'HUASAHUASI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 701,
    provinceId: 136,
    description: 'Pacasmayo',
    state: '12',
    DESCR: 'PACASMAYO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 702,
    provinceId: 137,
    description: 'Carampoma',
    state: '14',
    DESCR: 'CARAMPOMA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 703,
    provinceId: 138,
    description: 'Morona',
    state: '15',
    DESCR: 'MORONA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 704,
    provinceId: 139,
    description: 'Lobitos',
    state: '19',
    DESCR: 'LOBITOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 705,
    provinceId: 140,
    description: 'Nicasio',
    state: '20',
    DESCR: 'NICASIO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 706,
    provinceId: 141,
    description: 'Pilluana',
    state: '21',
    DESCR: 'PILLUANA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 707,
    provinceId: 142,
    description: 'Yautan',
    state: '02',
    DESCR: 'YAUTAN',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 708,
    provinceId: 143,
    description: 'Huaynacotas',
    state: '04',
    DESCR: 'HUAYNACOTAS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 709,
    provinceId: 144,
    description: 'Lampa',
    state: '05',
    DESCR: 'LAMPA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 710,
    provinceId: 145,
    description: 'Colasay',
    state: '06',
    DESCR: 'COLASAY',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 711,
    provinceId: 146,
    description: 'Ocoruro',
    state: '07',
    DESCR: 'OCORURO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 712,
    provinceId: 147,
    description: 'Umari',
    state: '09',
    DESCR: 'UMARI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 713,
    provinceId: 148,
    description: 'Santa Rosa de Sacco',
    state: '11',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10',
    DESCR: 'STA ROSA DE SACCO'
  },
  {
    id: 714,
    provinceId: 149,
    description: 'Huancaspata',
    state: '12',
    DESCR: 'HUANCASPATA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 715,
    provinceId: 150,
    description: 'Checras',
    state: '14',
    DESCR: 'CHECRAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 716,
    provinceId: 151,
    description: 'Cristo Nos Valga',
    state: '19',
    DESCR: 'CRISTO NOS VALGA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 717,
    provinceId: 152,
    description: 'Llalli',
    state: '20',
    DESCR: 'LLALLI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 718,
    provinceId: 153,
    description: 'Nueva cajamarca',
    state: '21',
    DESCR: 'NUEVA CAJAMARCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 719,
    provinceId: 154,
    description: 'Cusca',
    state: '02',
    DESCR: 'CUSCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 720,
    provinceId: 155,
    description: 'Chilcayoc',
    state: '05',
    DESCR: 'CHILCAYOC',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '10'
  },
  {
    id: 721,
    provinceId: 156,
    description: 'La coipa',
    state: '06',
    DESCR: 'LA COIPA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05'
  },
  {
    id: 722,
    provinceId: 157,
    description: 'Maranura',
    state: '07',
    DESCR: 'MARANURA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 723,
    provinceId: 158,
    description: 'Tournavista',
    state: '09',
    DESCR: 'TOURNAVISTA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 724,
    provinceId: 159,
    description: 'Huamancaca Chico',
    state: '11',
    DESCR: 'HUAMANCACA CHICO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 725,
    provinceId: 160,
    description: 'Curgos',
    state: '12',
    DESCR: 'CURGOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 726,
    provinceId: 161,
    description: 'Cochamarca',
    state: '14',
    DESCR: 'COCHAMARCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 727,
    provinceId: 162,
    description: 'Tilali',
    state: '20',
    DESCR: 'TILALI',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '03'
  },
  {
    id: 728,
    provinceId: 163,
    description: 'Chazuta',
    state: '21',
    DESCR: 'CHAZUTA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 729,
    provinceId: 164,
    description: 'Chavin de huantar',
    state: '02',
    DESCR: 'CHAVIN DE HUANTAR',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 730,
    provinceId: 165,
    description: 'Asquipata',
    state: '05',
    DESCR: 'ASQUIPATA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '15'
  },
  {
    id: 731,
    provinceId: 166,
    description: 'Gregorio pita',
    state: '06',
    DESCR: 'GREGORIO PITA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '03'
  },
  {
    id: 732,
    provinceId: 167,
    description: 'Colcha',
    state: '07',
    DESCR: 'COLCHA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 733,
    provinceId: 168,
    description: 'Queropalca',
    state: '09',
    DESCR: 'QUEROPALCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 734,
    provinceId: 169,
    description: 'Mollebamba',
    state: '12',
    DESCR: 'MOLLEBAMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 735,
    provinceId: 170,
    description: 'Ayaviri',
    state: '20',
    DESCR: 'AYAVIRI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '01'
  },
  {
    id: 736,
    provinceId: 171,
    description: 'Quilcapuncu',
    state: '20',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03',
    DESCR: 'QUILCA PUNCU'
  },
  {
    id: 737,
    provinceId: 172,
    description: 'Shunte',
    state: '21',
    DESCR: 'SHUNTE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 738,
    provinceId: 173,
    description: 'Huayan',
    state: '02',
    DESCR: 'HUAYAN',
    MBO_PROVINCIA: '19',
    MBO_DISTRITO: '03'
  },
  {
    id: 739,
    provinceId: 174,
    description: 'Concepcion',
    state: '05',
    DESCR: 'CONCEPCION',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 740,
    provinceId: 175,
    description: 'Catilluc',
    state: '06',
    DESCR: 'CATILLUC',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '12'
  },
  {
    id: 741,
    provinceId: 176,
    description: 'Colquepata',
    state: '07',
    DESCR: 'COLQUEPATA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '03'
  },
  {
    id: 742,
    provinceId: 177,
    description: 'Chupan',
    state: '09',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02',
    DESCR: 'APARICIO POMARES (CHUPAN)'
  },
  {
    id: 743,
    provinceId: 178,
    description: 'Sayapullo',
    state: '12',
    DESCR: 'SAYAPULLO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 744,
    provinceId: 179,
    description: 'La perla',
    state: '24',
    DESCR: 'LA PERLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 745,
    provinceId: 180,
    description: 'Caracoto',
    state: '20',
    DESCR: 'CARACOTO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 746,
    provinceId: 181,
    description: 'Huaylas',
    state: '02',
    DESCR: 'HUAYLAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 747,
    provinceId: 182,
    description: 'Tumbaden',
    state: '06',
    DESCR: 'TUMBADEN',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '04'
  },
  {
    id: 748,
    provinceId: 183,
    description: 'Ccarhuayo',
    state: '07',
    DESCR: 'CCARHUAYO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '04'
  },
  {
    id: 749,
    provinceId: 185,
    description: 'Patambuco',
    state: '20',
    DESCR: 'PATAMBUCO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 750,
    provinceId: 186,
    description: 'Fidel olivas escudero',
    state: '02',
    DESCR: 'FIDEL OLIVAS ESCUDERO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 751,
    provinceId: 187,
    description: 'Chancaybaños',
    state: '06',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03',
    DESCR: 'CHANCAIBANOS'
  },
  {
    id: 752,
    provinceId: 188,
    description: 'Machupicchu',
    state: '07',
    DESCR: 'MACHUPICCHU',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '04'
  },
  {
    id: 753,
    provinceId: 189,
    description: 'Cuturapi',
    state: '20',
    DESCR: 'CUTURAPI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 754,
    provinceId: 190,
    description: 'Carhuapampa',
    state: '02',
    DESCR: 'CARHUAPAMPA',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '03'
  },
  {
    id: 755,
    provinceId: 191,
    description: 'Huacaschuque',
    state: '02',
    DESCR: 'HUACASCHUQUE',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 756,
    provinceId: 192,
    description: 'Quinuabamba',
    state: '02',
    DESCR: 'QUINUABAMBA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 757,
    provinceId: 193,
    description: 'Huayllapampa',
    state: '02',
    DESCR: 'HUAYLLAPAMPA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '03'
  },
  {
    id: 758,
    provinceId: 194,
    description: 'Macate',
    state: '02',
    DESCR: 'MACATE',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '03'
  },
  {
    id: 759,
    provinceId: 195,
    description: 'Cashapampa',
    state: '02',
    DESCR: 'CASHAPAMPA',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '08'
  },
  {
    id: 760,
    provinceId: 196,
    description: 'Matacoto',
    state: '02',
    DESCR: 'MATACOTO',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '04'
  },
  {
    id: 761,
    provinceId: 1,
    description: 'Chiliquin',
    state: '01',
    DESCR: 'CHILIQUIN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 762,
    provinceId: 2,
    description: 'Independencia',
    state: '05',
    DESCR: 'INDEPENDENCIA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 763,
    provinceId: 3,
    description: 'Huanipaca',
    state: '03',
    DESCR: 'HUANIPACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 764,
    provinceId: 4,
    description: 'Characato',
    state: '04',
    DESCR: 'CHARACATO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 765,
    provinceId: 5,
    description: 'Chiara',
    state: '03',
    DESCR: 'CHIARA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 766,
    provinceId: 6,
    description: 'Encañada',
    state: '06',
    DESCR: 'ENCANADA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 767,
    provinceId: 7,
    description: 'La Punta',
    state: '24',
    DESCR: 'LA PUNTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 768,
    provinceId: 8,
    description: 'San sebastian',
    state: '07',
    DESCR: 'SAN SEBASTIAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 769,
    provinceId: 9,
    description: 'Cuenca',
    state: '08',
    DESCR: 'CUENCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 770,
    provinceId: 10,
    description: 'Margos',
    state: '09',
    DESCR: 'MARGOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 771,
    provinceId: 11,
    description: 'Pachacutec',
    state: '10',
    DESCR: 'PACHACUTEC',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 772,
    provinceId: 12,
    description: 'Chacapampa',
    state: '11',
    DESCR: 'CHACAPAMPA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 773,
    provinceId: 13,
    description: 'La Esperanza',
    state: '06',
    DESCR: 'LA ESPERANZA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 774,
    provinceId: 14,
    description: 'José leonardo ortíz',
    state: '13',
    DESCR: 'JOSE LEONARDO ORTIZ',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 775,
    provinceId: 15,
    description: 'Breña',
    state: '14',
    DESCR: 'BRENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 776,
    provinceId: 16,
    description: 'Las amazonas',
    state: '15',
    DESCR: 'LAS AMAZONAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 777,
    provinceId: 18,
    description: 'San cristobal',
    state: '01',
    DESCR: 'SAN CRISTOBAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '15'
  },
  {
    id: 778,
    provinceId: 19,
    description: 'Ninacaca',
    state: '18',
    DESCR: 'NINACACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 779,
    provinceId: 20,
    description: 'Catacaos',
    state: '19',
    DESCR: 'CATACAOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 780,
    provinceId: 21,
    description: 'Capachica',
    state: '20',
    DESCR: 'CAPACHICA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 781,
    provinceId: 22,
    description: 'Soritor',
    state: '21',
    DESCR: 'SORITOR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 782,
    provinceId: 23,
    description: 'Inclan',
    state: '22',
    DESCR: 'INCLAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 783,
    provinceId: 24,
    description: 'San Jacinto',
    state: '23',
    DESCR: 'SAN JACINTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 784,
    provinceId: 25,
    description: 'Yarinacocha',
    state: '25',
    DESCR: 'YARINACOCHA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '02'
  },
  {
    id: 785,
    provinceId: 26,
    description: 'Imaza',
    state: '01',
    DESCR: 'IMAZA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 786,
    provinceId: 27,
    description: 'Succha',
    state: '02',
    DESCR: 'SUCCHA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 787,
    provinceId: 28,
    description: 'Huancaray',
    state: '03',
    DESCR: 'HUANCARAY',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 788,
    provinceId: 29,
    description: 'Nicolas de pierola',
    state: '04',
    DESCR: 'NICOLAS DE PIEROLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 789,
    provinceId: 30,
    description: 'Paras',
    state: '05',
    DESCR: 'PARAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 790,
    provinceId: 32,
    description: 'Pomacanchi',
    state: '07',
    DESCR: 'POMACANCHI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 791,
    provinceId: 33,
    description: 'Marcas',
    state: '08',
    DESCR: 'MARCAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 792,
    provinceId: 34,
    description: 'Huacar',
    state: '09',
    DESCR: 'HUACAR',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 793,
    provinceId: 35,
    description: 'El carmen',
    state: '08',
    DESCR: 'EL CARMEN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 794,
    provinceId: 36,
    description: 'Cochas',
    state: '14',
    DESCR: 'COCHAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 795,
    provinceId: 37,
    description: 'Paijan',
    state: '12',
    DESCR: 'PAIJAN',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 796,
    provinceId: 38,
    description: 'Pitipo',
    state: '13',
    DESCR: 'PITIPO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 797,
    provinceId: 39,
    description: 'Supe puerto',
    state: '14',
    DESCR: 'SUPE PUERTO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 798,
    provinceId: 40,
    description: 'Jeberos',
    state: '15',
    DESCR: 'JEBEROS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 799,
    provinceId: 42,
    description: 'La capilla',
    state: '17',
    DESCR: 'LA CAPILLA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 800,
    provinceId: 43,
    description: 'San pedro de pillao',
    state: '18',
    DESCR: 'SAN PEDRO DE PILLAO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 801,
    provinceId: 44,
    description: 'Montero',
    state: '19',
    DESCR: 'MONTERO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 802,
    provinceId: 45,
    description: 'Caminaca',
    state: '20',
    DESCR: 'CAMINACA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 803,
    provinceId: 46,
    description: 'San pablo',
    state: '06',
    DESCR: 'SAN PABLO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 804,
    provinceId: 47,
    description: 'Huanuara',
    state: '22',
    DESCR: 'HUANUARA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 805,
    provinceId: 50,
    description: 'Cuispes',
    state: '01',
    DESCR: 'CUISPES',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 806,
    provinceId: 51,
    description: 'Mirgas',
    state: '02',
    DESCR: 'MIRGAS',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '05'
  },
  {
    id: 807,
    provinceId: 52,
    description: 'Oropesa',
    state: '03',
    DESCR: 'OROPESA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 808,
    provinceId: 53,
    description: 'Bella union',
    state: '04',
    DESCR: 'BELLA UNION',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 809,
    provinceId: 55,
    description: 'Jorge chavez',
    state: '06',
    DESCR: 'JORGE CHAVEZ',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 810,
    provinceId: 56,
    description: 'Huarocondo',
    state: '07',
    DESCR: 'HUAROCONDO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '03'
  },
  {
    id: 811,
    provinceId: 57,
    description: 'Chincho',
    state: '08',
    DESCR: 'CHINCHO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 812,
    provinceId: 59,
    description: 'Vista alegre',
    state: '01',
    DESCR: 'VISTA ALEGRE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '12'
  },
  {
    id: 813,
    provinceId: 60,
    description: 'San Ramon',
    state: '11',
    DESCR: 'SAN RAMON',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 814,
    provinceId: 61,
    description: 'Uchumarca',
    state: '12',
    DESCR: 'UCHUMARCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 815,
    provinceId: 62,
    description: 'Mochumi',
    state: '13',
    DESCR: 'MOCHUMI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 816,
    provinceId: 63,
    description: 'Manas',
    state: '14',
    DESCR: 'MANAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 817,
    provinceId: 64,
    description: 'Urarinas',
    state: '15',
    DESCR: 'URARINAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 818,
    provinceId: 67,
    description: 'Pozuzo',
    state: '18',
    DESCR: 'POZUZO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 819,
    provinceId: 68,
    description: 'Lalaquiz',
    state: '19',
    DESCR: 'LALAQUIZ',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 820,
    provinceId: 69,
    description: 'Corani',
    state: '20',
    DESCR: 'CORANI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 821,
    provinceId: 70,
    description: 'Shatoja',
    state: '21',
    DESCR: 'SHATOJA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 822,
    provinceId: 76,
    description: 'Colcabamba',
    state: '02',
    DESCR: 'COLCABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 823,
    provinceId: 77,
    description: 'Chilcaymarca',
    state: '04',
    DESCR: 'CHILCAYMARCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 824,
    provinceId: 78,
    description: 'Luricocha',
    state: '05',
    DESCR: 'LURICOCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 825,
    provinceId: 79,
    description: 'Chimban',
    state: '06',
    DESCR: 'CHIMBAN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 826,
    provinceId: 80,
    description: 'Pisac',
    state: '07',
    DESCR: 'PISAC',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 827,
    provinceId: 81,
    description: 'Chupamarca',
    state: '08',
    DESCR: 'CHUPAMARCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 828,
    provinceId: 83,
    description: 'Tibillo',
    state: '10',
    DESCR: 'TIBILLO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 829,
    provinceId: 84,
    description: 'Canchayllo',
    state: '11',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05',
    DESCR: 'CANCHAILLO'
  },
  {
    id: 830,
    provinceId: 86,
    description: 'Lachaqui',
    state: '14',
    DESCR: 'LACHAQUI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 831,
    provinceId: 88,
    description: 'Morropón',
    state: '19',
    DESCR: 'MORROPON',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 832,
    provinceId: 89,
    description: 'Pisacoma',
    state: '20',
    DESCR: 'PISACOMA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 833,
    provinceId: 90,
    description: 'Sacanche',
    state: '21',
    DESCR: 'SACANCHE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 834,
    provinceId: 91,
    description: 'Sitajara',
    state: '22',
    DESCR: 'SITAJARA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 835,
    provinceId: 93,
    description: 'Conila',
    state: '01',
    DESCR: 'CONILA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 836,
    provinceId: 94,
    description: 'Cajacay',
    state: '02',
    DESCR: 'CAJACAY',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 837,
    provinceId: 95,
    description: 'Mara',
    state: '03',
    DESCR: 'MARA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 838,
    provinceId: 96,
    description: 'Caylloma',
    state: '04',
    DESCR: 'CAYLLOMA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 839,
    provinceId: 97,
    description: 'Chungui',
    state: '05',
    DESCR: 'CHUNGUI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 840,
    provinceId: 98,
    description: 'San benito',
    state: '06',
    DESCR: 'SAN BENITO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 841,
    provinceId: 99,
    description: 'Layo',
    state: '07',
    DESCR: 'LAYO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 842,
    provinceId: 100,
    description: 'La merced',
    state: '02',
    DESCR: 'LA MERCED',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 843,
    provinceId: 101,
    description: 'Jircan',
    state: '09',
    DESCR: 'JIRCAN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 844,
    provinceId: 102,
    description: 'Paracas',
    state: '10',
    DESCR: 'PARACAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 845,
    provinceId: 105,
    description: 'Chilca',
    state: '11',
    DESCR: 'CHILCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 846,
    provinceId: 106,
    description: 'Maquia',
    state: '15',
    DESCR: 'MAQUIA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 847,
    provinceId: 107,
    description: 'La Huaca',
    state: '19',
    DESCR: 'LA HUACA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 848,
    provinceId: 108,
    description: 'Conduriri',
    state: '20',
    DESCR: 'CONDURIRI',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '05'
  },
  {
    id: 849,
    provinceId: 109,
    description: 'Cuñumbuqui',
    state: '21',
    DESCR: 'CUNUMBUQUI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 850,
    provinceId: 110,
    description: 'Limabamba',
    state: '01',
    DESCR: 'LIMABAMBA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 851,
    provinceId: 111,
    description: 'Ataquero',
    state: '02',
    DESCR: 'ATAQUERO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 852,
    provinceId: 112,
    description: 'Ocobamba',
    state: '03',
    DESCR: 'OCOBAMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 853,
    provinceId: 113,
    description: 'Iray',
    state: '04',
    DESCR: 'IRAY',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 854,
    provinceId: 114,
    description: 'Chaviña',
    state: '05',
    DESCR: 'CHAVINA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 855,
    provinceId: 115,
    description: 'La ramada',
    state: '06',
    DESCR: 'LA RAMADA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 856,
    provinceId: 116,
    description: 'Pitumarca',
    state: '07',
    DESCR: 'PITUMARCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 857,
    provinceId: 117,
    description: 'Laramarca',
    state: '08',
    DESCR: 'LARAMARCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 858,
    provinceId: 118,
    description: 'Luyando',
    state: '09',
    DESCR: 'LUYANDO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 859,
    provinceId: 119,
    description: 'Pangoa',
    state: '11',
    DESCR: 'PANGOA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 860,
    provinceId: 120,
    description: 'Huaranchal',
    state: '12',
    DESCR: 'HUARANCHAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 861,
    provinceId: 121,
    description: 'Chancay',
    state: '14',
    DESCR: 'CHANCAY',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 862,
    provinceId: 122,
    description: 'Sarayacu',
    state: '15',
    DESCR: 'SARAYACU',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 863,
    provinceId: 123,
    description: 'Marcavelica',
    state: '19',
    DESCR: 'MARCAVELICA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 864,
    provinceId: 124,
    description: 'Pusi',
    state: '20',
    DESCR: 'PUSI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 865,
    provinceId: 125,
    description: 'Pajarillo',
    state: '21',
    DESCR: 'PAJARILLO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 866,
    provinceId: 126,
    description: 'Jamalca',
    state: '01',
    DESCR: 'JAMALCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 867,
    provinceId: 128,
    description: 'Mamara',
    state: '03',
    DESCR: 'MAMARA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 868,
    provinceId: 129,
    description: 'Mejia',
    state: '04',
    DESCR: 'MEJIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 869,
    provinceId: 130,
    description: 'Pullo',
    state: '05',
    DESCR: 'PULLO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 870,
    provinceId: 132,
    description: 'Livitaca',
    state: '07',
    DESCR: 'LIVITACA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 871,
    provinceId: 133,
    description: 'Colcabamba',
    state: '02',
    DESCR: 'COLCABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 872,
    provinceId: 135,
    description: 'La Unión Leticia',
    state: '11',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05',
    DESCR: 'LA UNION'
  },
  {
    id: 873,
    provinceId: 136,
    description: 'San jose',
    state: '12',
    DESCR: 'SAN JOSE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 874,
    provinceId: 137,
    description: 'Chicla',
    state: '14',
    DESCR: 'CHICLA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 875,
    provinceId: 138,
    description: 'Pastaza',
    state: '15',
    DESCR: 'PASTAZA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 876,
    provinceId: 139,
    description: 'Los Organos',
    state: '19',
    DESCR: 'LOS ORGANOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 877,
    provinceId: 140,
    description: 'Ocuviri',
    state: '20',
    DESCR: 'OCUVIRI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 878,
    provinceId: 141,
    description: 'Pucacaca',
    state: '21',
    DESCR: 'PUCACACA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 879,
    provinceId: 143,
    description: 'Pampamarca',
    state: '04',
    DESCR: 'PAMPAMARCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 880,
    provinceId: 144,
    description: 'Marcabamba',
    state: '05',
    DESCR: 'MARCABAMBA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 881,
    provinceId: 145,
    description: 'Huabal',
    state: '06',
    DESCR: 'HUABAL',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '12'
  },
  {
    id: 882,
    provinceId: 146,
    description: 'Pallpata',
    state: '07',
    DESCR: 'PALLPATA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 883,
    provinceId: 148,
    description: 'Suitucancha',
    state: '11',
    DESCR: 'SUITUCANCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 884,
    provinceId: 149,
    description: 'Huaylillas',
    state: '12',
    DESCR: 'HUAYLILLAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 885,
    provinceId: 150,
    description: 'Hualmay',
    state: '14',
    DESCR: 'HUALMAY',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 886,
    provinceId: 151,
    description: 'Vice',
    state: '19',
    DESCR: 'VICE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '02'
  },
  {
    id: 887,
    provinceId: 152,
    description: 'Macari',
    state: '20',
    DESCR: 'MACARI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 888,
    provinceId: 153,
    description: 'Pardo miguel',
    state: '21',
    DESCR: 'PARDO MIGUEL',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 889,
    provinceId: 154,
    description: 'La pampa',
    state: '02',
    DESCR: 'LA PAMPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 890,
    provinceId: 155,
    description: 'Huacaña',
    state: '05',
    DESCR: 'HUACANA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '09'
  },
  {
    id: 891,
    provinceId: 156,
    description: 'Namballe',
    state: '06',
    DESCR: 'NAMBALLE',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 892,
    provinceId: 157,
    description: 'Ocobamba',
    state: '03',
    DESCR: 'OCOBAMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 893,
    provinceId: 158,
    description: 'Yuyapichis',
    state: '09',
    DESCR: 'YUYAPICHIS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 894,
    provinceId: 159,
    description: 'Tres de diciembre',
    state: '11',
    DESCR: 'TRES DE DICIEMBRE',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 895,
    provinceId: 160,
    description: 'Marcabal',
    state: '12',
    DESCR: 'MARCABAL',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 896,
    provinceId: 161,
    description: 'Navan',
    state: '14',
    DESCR: 'NAVAN',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 897,
    provinceId: 163,
    description: 'Chipurana',
    state: '21',
    DESCR: 'CHIPURANA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 898,
    provinceId: 164,
    description: 'Huacachi',
    state: '02',
    DESCR: 'HUACACHI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 899,
    provinceId: 165,
    description: 'Canaria',
    state: '05',
    DESCR: 'CANARIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 900,
    provinceId: 166,
    description: 'Ichocan',
    state: '06',
    DESCR: 'ICHOCAN',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '02'
  },
  {
    id: 901,
    provinceId: 167,
    description: 'Huanoquite',
    state: '07',
    DESCR: 'HUANOQUITE',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 902,
    provinceId: 168,
    description: 'Rondos',
    state: '09',
    DESCR: 'RONDOS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 903,
    provinceId: 169,
    description: 'Mollepata',
    state: '07',
    DESCR: 'MOLLEPATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 904,
    provinceId: 170,
    description: 'Azangaro',
    state: '20',
    DESCR: 'AZANGARO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '01'
  },
  {
    id: 905,
    provinceId: 171,
    description: 'Sina',
    state: '20',
    DESCR: 'SINA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05'
  },
  {
    id: 906,
    provinceId: 172,
    description: 'Uchiza',
    state: '21',
    DESCR: 'UCHIZA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 907,
    provinceId: 173,
    description: 'Malvas',
    state: '02',
    DESCR: 'MALVAS',
    MBO_PROVINCIA: '19',
    MBO_DISTRITO: '04'
  },
  {
    id: 908,
    provinceId: 174,
    description: 'Huambalpa',
    state: '05',
    DESCR: 'HUAMBALPA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '06'
  },
  {
    id: 909,
    provinceId: 175,
    description: 'El prado',
    state: '06',
    DESCR: 'EL PRADO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '09'
  },
  {
    id: 910,
    provinceId: 176,
    description: 'Huancarani',
    state: '07',
    DESCR: 'HUANCARANI',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '06'
  },
  {
    id: 911,
    provinceId: 177,
    description: 'Jacas chico',
    state: '09',
    DESCR: 'JACAS CHICO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05'
  },
  {
    id: 912,
    provinceId: 179,
    description: 'La punta',
    state: '24',
    DESCR: 'LA PUNTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 913,
    provinceId: 181,
    description: 'Mato',
    state: '02',
    DESCR: 'MATO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 914,
    provinceId: 183,
    description: 'Ccatca',
    state: '07',
    DESCR: 'CCATCA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '05'
  },
  {
    id: 915,
    provinceId: 185,
    description: 'Phara',
    state: '20',
    DESCR: 'PHARA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 916,
    provinceId: 186,
    description: 'Llama',
    state: '02',
    DESCR: 'LLAMA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 917,
    provinceId: 187,
    description: 'La esperanza',
    state: '06',
    DESCR: 'LA ESPERANZA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '04'
  },
  {
    id: 918,
    provinceId: 188,
    description: 'Maras',
    state: '07',
    DESCR: 'MARAS',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '05'
  },
  {
    id: 919,
    provinceId: 189,
    description: 'Ollaraya',
    state: '20',
    DESCR: 'OLLARAYA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 920,
    provinceId: 190,
    description: 'Cochas',
    state: '14',
    DESCR: 'COCHAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 921,
    provinceId: 191,
    description: 'Huandoval',
    state: '02',
    DESCR: 'HUANDOVAL',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 922,
    provinceId: 193,
    description: 'Llacllin',
    state: '02',
    DESCR: 'LLACLLIN',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '09'
  },
  {
    id: 923,
    provinceId: 194,
    description: 'Moro',
    state: '02',
    DESCR: 'MORO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '04'
  },
  {
    id: 924,
    provinceId: 195,
    description: 'Chingalpo',
    state: '02',
    DESCR: 'CHINGALPO',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '03'
  },
  {
    id: 925,
    provinceId: 196,
    description: 'Quillo',
    state: '02',
    DESCR: 'QUILLO',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '05'
  },
  {
    id: 926,
    provinceId: 1,
    description: 'Chuquibamba',
    state: '04',
    DESCR: 'CHUQUIBAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '01'
  },
  {
    id: 927,
    provinceId: 2,
    description: 'Jangas',
    state: '02',
    DESCR: 'JANGAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 928,
    provinceId: 3,
    description: 'Lambrama',
    state: '03',
    DESCR: 'LAMBRAMA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 929,
    provinceId: 4,
    description: 'Chiguata',
    state: '04',
    DESCR: 'CHIGUATA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 930,
    provinceId: 5,
    description: 'Ocros',
    state: '02',
    DESCR: 'OCROS',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '07'
  },
  {
    id: 931,
    provinceId: 6,
    description: 'Jesus',
    state: '06',
    DESCR: 'JESUS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 932,
    provinceId: 7,
    description: 'Ventanilla',
    state: '24',
    DESCR: 'VENTANILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 933,
    provinceId: 8,
    description: 'Santiago',
    state: '07',
    DESCR: 'SANTIAGO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 934,
    provinceId: 9,
    description: 'Huachocolpa',
    state: '08',
    DESCR: 'HUACHOCOLPA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 935,
    provinceId: 10,
    description: 'Quisqui',
    state: '09',
    DESCR: 'QUISQUI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 936,
    provinceId: 11,
    description: 'Parcona',
    state: '10',
    DESCR: 'PARCONA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 937,
    provinceId: 12,
    description: 'Chicche',
    state: '11',
    DESCR: 'CHICCHE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 938,
    provinceId: 13,
    description: 'Laredo',
    state: '12',
    DESCR: 'LAREDO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 939,
    provinceId: 14,
    description: 'La victoria',
    state: '13',
    DESCR: 'LA VICTORIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 940,
    provinceId: 15,
    description: 'Carabayllo',
    state: '14',
    DESCR: 'CARABAYLLO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 941,
    provinceId: 16,
    description: 'Mazan',
    state: '15',
    DESCR: 'MAZAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 942,
    provinceId: 18,
    description: 'Torata',
    state: '17',
    DESCR: 'TORATA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 943,
    provinceId: 19,
    description: 'Pallanchacra',
    state: '18',
    DESCR: 'PALLANCHACRA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 944,
    provinceId: 21,
    description: 'Chucuito',
    state: '20',
    DESCR: 'CHUCUITO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 945,
    provinceId: 22,
    description: 'Yantalo',
    state: '21',
    DESCR: 'YANTALO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 946,
    provinceId: 23,
    description: 'Pachia',
    state: '22',
    DESCR: 'PACHIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 947,
    provinceId: 24,
    description: 'San Juan de la Virgen',
    state: '23',
    DESCR: 'SAN JUAN DE LA VIRGEN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 948,
    provinceId: 25,
    description: 'Nueva requena',
    state: '25',
    DESCR: 'NUEVA REQUENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 949,
    provinceId: 28,
    description: 'Huayana',
    state: '03',
    DESCR: 'HUAYANA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '17'
  },
  {
    id: 950,
    provinceId: 29,
    description: 'Ocoña',
    state: '04',
    DESCR: 'OCONA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 951,
    provinceId: 30,
    description: 'Totos',
    state: '05',
    DESCR: 'TOTOS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 952,
    provinceId: 32,
    description: 'Rondocan',
    state: '07',
    DESCR: 'RONDOCAN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 953,
    provinceId: 33,
    description: 'Paucara',
    state: '08',
    DESCR: 'PAUCARA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 954,
    provinceId: 34,
    description: 'San francisco',
    state: '09',
    DESCR: 'SAN FRANCISCO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 955,
    provinceId: 35,
    description: 'Grocio prado',
    state: '10',
    DESCR: 'GROCIO PRADO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 956,
    provinceId: 36,
    description: 'Comas',
    state: '11',
    DESCR: 'COMAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 957,
    provinceId: 37,
    description: 'Razuri',
    state: '12',
    DESCR: 'RAZURI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 958,
    provinceId: 38,
    description: 'Pueblo nuevo',
    state: '12',
    DESCR: 'PUEBLO NUEVO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 959,
    provinceId: 40,
    description: 'Lagunas',
    state: '15',
    DESCR: 'LAGUNAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 960,
    provinceId: 42,
    description: 'Lloque',
    state: '17',
    DESCR: 'LLOQUE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 961,
    provinceId: 43,
    description: 'Santa ana de tusi',
    state: '18',
    DESCR: 'SANTA ANA DE TUSI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 962,
    provinceId: 44,
    description: 'Pacaipampa',
    state: '19',
    DESCR: 'PACAIPAMPA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 963,
    provinceId: 45,
    description: 'Chupa',
    state: '20',
    DESCR: 'CHUPA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 964,
    provinceId: 46,
    description: 'San rafael',
    state: '09',
    DESCR: 'SAN RAFAEL',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 965,
    provinceId: 47,
    description: 'Quilahuani',
    state: '22',
    DESCR: 'QUILAHUANI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 966,
    provinceId: 50,
    description: 'Florida',
    state: '01',
    DESCR: 'FLORIDA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 967,
    provinceId: 51,
    description: 'San juan de rontoy',
    state: '02',
    DESCR: 'SAN JUAN DE RONTOY',
    MBO_PROVINCIA: '16',
    MBO_DISTRITO: '06'
  },
  {
    id: 968,
    provinceId: 52,
    description: 'Pachaconas',
    state: '03',
    DESCR: 'PACHACONAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 969,
    provinceId: 53,
    description: 'Cahuacho',
    state: '04',
    DESCR: 'CAHUACHO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 970,
    provinceId: 55,
    description: 'Jose galvez',
    state: '06',
    DESCR: 'JOSE GALVEZ',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 971,
    provinceId: 56,
    description: 'Limatambo',
    state: '07',
    DESCR: 'LIMATAMBO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 972,
    provinceId: 57,
    description: 'Congalla',
    state: '08',
    DESCR: 'CONGALLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 973,
    provinceId: 60,
    description: 'Vitoc',
    state: '11',
    DESCR: 'VITOC',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 974,
    provinceId: 61,
    description: 'Ucuncha',
    state: '12',
    DESCR: 'UCUNCHA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 975,
    provinceId: 62,
    description: 'Morrope',
    state: '13',
    DESCR: 'MORROPE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 976,
    provinceId: 67,
    description: 'Puerto bermudez',
    state: '18',
    DESCR: 'PUERTO BERMUDEZ',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 977,
    provinceId: 68,
    description: 'San Miguel de El Faique',
    state: '19',
    DESCR: 'SAN MIGUEL DE EL FAIQUE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 978,
    provinceId: 69,
    description: 'Crucero',
    state: '20',
    DESCR: 'CRUCERO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 979,
    provinceId: 76,
    description: 'Cotaruse',
    state: '03',
    DESCR: 'COTARUSE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '05'
  },
  {
    id: 980,
    provinceId: 77,
    description: 'Choco',
    state: '04',
    DESCR: 'CHOCO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 981,
    provinceId: 78,
    description: 'Santillana',
    state: '05',
    DESCR: 'SANTILLANA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 982,
    provinceId: 79,
    description: 'Choropampa',
    state: '06',
    DESCR: 'CHOROPAMPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '18'
  },
  {
    id: 983,
    provinceId: 80,
    description: 'San salvador',
    state: '07',
    DESCR: 'SAN SALVADOR',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 984,
    provinceId: 81,
    description: 'Cocas',
    state: '08',
    DESCR: 'COCAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 985,
    provinceId: 84,
    description: 'Curicaca',
    state: '11',
    DESCR: 'CURICACA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '31'
  },
  {
    id: 986,
    provinceId: 86,
    description: 'San buenaventura',
    state: '09',
    DESCR: 'SAN BUENAVENTURA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '05'
  },
  {
    id: 987,
    provinceId: 88,
    description: 'Salitral',
    state: '19',
    DESCR: 'SALITRAL',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 988,
    provinceId: 89,
    description: 'Pomata',
    state: '20',
    DESCR: 'POMATA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 989,
    provinceId: 90,
    description: 'Tingo de saposoa',
    state: '21',
    DESCR: 'TINGO DE SAPOSOA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 990,
    provinceId: 91,
    description: 'Susapaya',
    state: '22',
    DESCR: 'SUSAPAYA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 991,
    provinceId: 93,
    description: 'Inguilpata',
    state: '01',
    DESCR: 'INGUILPATA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 992,
    provinceId: 94,
    description: 'Canis',
    state: '02',
    DESCR: 'CANIS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '22'
  },
  {
    id: 993,
    provinceId: 95,
    description: 'Challhuahuacho',
    state: '03',
    DESCR: 'CHALLHUAHUACHO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 994,
    provinceId: 96,
    description: 'Coporaque',
    state: '07',
    DESCR: 'COPORAQUE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '03'
  },
  {
    id: 995,
    provinceId: 97,
    description: 'Luis carranza',
    state: '05',
    DESCR: 'LUIS CARRANZA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 996,
    provinceId: 98,
    description: 'Santa cruz de toled',
    state: '06',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09',
    DESCR: 'STA CRUZ DE TOLEDO'
  },
  {
    id: 997,
    provinceId: 99,
    description: 'Pampamarca',
    state: '04',
    DESCR: 'PAMPAMARCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 998,
    provinceId: 100,
    description: 'Locroja',
    state: '08',
    DESCR: 'LOCROJA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 999,
    provinceId: 101,
    description: 'Miraflores',
    state: '04',
    DESCR: 'MIRAFLORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1000,
    provinceId: 102,
    description: 'San andres',
    state: '10',
    DESCR: 'SAN ANDRES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 1001,
    provinceId: 105,
    description: 'Coayllo',
    state: '14',
    DESCR: 'COAYLLO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '04'
  },
  {
    id: 1002,
    provinceId: 106,
    description: 'Puinahua',
    state: '15',
    DESCR: 'PUINAHUA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 1003,
    provinceId: 107,
    description: 'Tamarindo',
    state: '19',
    DESCR: 'TAMARINDO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 1004,
    provinceId: 109,
    description: 'Pinto recodo',
    state: '21',
    DESCR: 'PINTO RECODO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1005,
    provinceId: 110,
    description: 'Longar',
    state: '01',
    DESCR: 'LONGAR',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 1006,
    provinceId: 111,
    description: 'Marcara',
    state: '02',
    DESCR: 'MARCARA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 1007,
    provinceId: 112,
    description: 'Ongoy',
    state: '03',
    DESCR: 'ONGOY',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 1008,
    provinceId: 113,
    description: 'Rio grande',
    state: '04',
    DESCR: 'RIO GRANDE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1009,
    provinceId: 114,
    description: 'Chipao',
    state: '05',
    DESCR: 'CHIPAO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1010,
    provinceId: 115,
    description: 'Pimpingos',
    state: '06',
    DESCR: 'PIMPINGOS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '06'
  },
  {
    id: 1011,
    provinceId: 116,
    description: 'San pablo',
    state: '06',
    DESCR: 'SAN PABLO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '01'
  },
  {
    id: 1012,
    provinceId: 117,
    description: 'Ocoyo',
    state: '08',
    DESCR: 'OCOYO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1013,
    provinceId: 118,
    description: 'Mariano damaso beraun',
    state: '09',
    DESCR: 'MARIANO DAMASO BERAUN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 1014,
    provinceId: 119,
    description: 'Llaylla',
    state: '11',
    DESCR: 'LLAYLLA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 1015,
    provinceId: 120,
    description: 'La cuesta',
    state: '12',
    DESCR: 'LA CUESTA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 1016,
    provinceId: 121,
    description: 'Ihuari',
    state: '14',
    DESCR: 'IHUARI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1017,
    provinceId: 122,
    description: 'Vargas guerra',
    state: '15',
    DESCR: 'VARGAS GUERRA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 1018,
    provinceId: 123,
    description: 'Miguel Checa',
    state: '19',
    DESCR: 'MIGUEL CHECA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 1019,
    provinceId: 124,
    description: 'Rosaspata',
    state: '20',
    DESCR: 'ROSASPATA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1020,
    provinceId: 126,
    description: 'Lonya grande',
    state: '01',
    DESCR: 'LONYA GRANDE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1021,
    provinceId: 128,
    description: 'Micaela bastidas',
    state: '03',
    DESCR: 'MICAELA BASTIDAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1022,
    provinceId: 129,
    description: 'Punta de bombon',
    state: '04',
    DESCR: 'PUNTA DE BOMBON',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1023,
    provinceId: 130,
    description: 'Puyusca',
    state: '05',
    DESCR: 'PUYUSCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1024,
    provinceId: 132,
    description: 'Llusco',
    state: '07',
    DESCR: 'LLUSCO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1025,
    provinceId: 133,
    description: 'Daniel hernandez',
    state: '08',
    DESCR: 'DANIEL HERNANDEZ',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1026,
    provinceId: 135,
    description: 'Palca',
    state: '08',
    DESCR: 'PALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1027,
    provinceId: 137,
    description: 'Cuenca',
    state: '08',
    DESCR: 'CUENCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1028,
    provinceId: 138,
    description: 'Andoas',
    state: '15',
    DESCR: 'ANDOAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '02'
  },
  {
    id: 1029,
    provinceId: 139,
    description: 'Máncora',
    state: '19',
    DESCR: 'MANCORA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 1030,
    provinceId: 140,
    description: 'Palca',
    state: '08',
    DESCR: 'PALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1031,
    provinceId: 141,
    description: 'San cristobal',
    state: '01',
    DESCR: 'SAN CRISTOBAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '15'
  },
  {
    id: 1032,
    provinceId: 143,
    description: 'Puyca',
    state: '04',
    DESCR: 'PUYCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1033,
    provinceId: 144,
    description: 'Oyolo',
    state: '05',
    DESCR: 'OYOLO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 1034,
    provinceId: 145,
    description: 'Las pirias',
    state: '06',
    DESCR: 'LAS PIRIAS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '11'
  },
  {
    id: 1035,
    provinceId: 146,
    description: 'Pichigua',
    state: '07',
    DESCR: 'PICHIGUA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1036,
    provinceId: 148,
    description: 'Yauli',
    state: '08',
    DESCR: 'YAULI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1037,
    provinceId: 149,
    description: 'Huayo',
    state: '12',
    DESCR: 'HUAYO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1038,
    provinceId: 150,
    description: 'Huaura',
    state: '14',
    DESCR: 'HUAURA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1039,
    provinceId: 151,
    description: 'Rinconada Llicuar',
    state: '19',
    DESCR: 'RINCONADA LLICUAR',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1040,
    provinceId: 152,
    description: 'Nuñoa',
    state: '20',
    DESCR: 'NUNOA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1041,
    provinceId: 153,
    description: 'Posic',
    state: '21',
    DESCR: 'POSIC',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '02'
  },
  {
    id: 1042,
    provinceId: 154,
    description: 'Yanac',
    state: '02',
    DESCR: 'YANAC',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1043,
    provinceId: 155,
    description: 'Morcolla',
    state: '05',
    DESCR: 'MORCOLLA',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '11'
  },
  {
    id: 1044,
    provinceId: 156,
    description: 'San jose de lourdes',
    state: '06',
    DESCR: 'SAN JOSE DE LOURDES',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '06'
  },
  {
    id: 1045,
    provinceId: 157,
    description: 'Quellouno',
    state: '07',
    DESCR: 'QUELLOUNO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 1046,
    provinceId: 159,
    description: 'Chongos Bajo',
    state: '11',
    DESCR: 'CHONGOS BAJO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 1047,
    provinceId: 160,
    description: 'Sanagoran',
    state: '12',
    DESCR: 'SANAGORAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1048,
    provinceId: 161,
    description: 'Pachangara',
    state: '14',
    DESCR: 'PACHANGARA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 1049,
    provinceId: 163,
    description: 'El porvenir',
    state: '12',
    DESCR: 'EL PORVENIR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1050,
    provinceId: 164,
    description: 'Huacchis',
    state: '02',
    DESCR: 'HUACCHIS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1051,
    provinceId: 165,
    description: 'Cayara',
    state: '05',
    DESCR: 'CAYARA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1052,
    provinceId: 166,
    description: 'Jose manuel quiroz',
    state: '06',
    DESCR: 'JOSE MANUEL QUIROZ',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '04'
  },
  {
    id: 1053,
    provinceId: 167,
    description: 'Omacha',
    state: '07',
    DESCR: 'OMACHA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 1054,
    provinceId: 168,
    description: 'San francisco de asis',
    state: '09',
    DESCR: 'SAN FRANCISCO DE ASIS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 1055,
    provinceId: 169,
    description: 'Quiruvilca',
    state: '12',
    DESCR: 'QUIRUVILCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 1056,
    provinceId: 170,
    description: 'Cacra',
    state: '14',
    DESCR: 'CACRA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1057,
    provinceId: 174,
    description: 'Independencia',
    state: '05',
    DESCR: 'INDEPENDENCIA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 1058,
    provinceId: 175,
    description: 'La florida',
    state: '06',
    DESCR: 'LA FLORIDA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03'
  },
  {
    id: 1059,
    provinceId: 176,
    description: 'Kosñipata',
    state: '07',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05',
    DESCR: 'COSNIPATA'
  },
  {
    id: 1060,
    provinceId: 177,
    description: 'Obas',
    state: '09',
    DESCR: 'OBAS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '06'
  },
  {
    id: 1061,
    provinceId: 179,
    description: 'Ventanilla',
    state: '24',
    DESCR: 'VENTANILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1062,
    provinceId: 181,
    description: 'Pamparomas',
    state: '02',
    DESCR: 'PAMPAROMAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1063,
    provinceId: 183,
    description: 'Cusipata',
    state: '07',
    DESCR: 'CUSIPATA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '06'
  },
  {
    id: 1064,
    provinceId: 185,
    description: 'Quiaca',
    state: '20',
    DESCR: 'QUIACA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 1065,
    provinceId: 186,
    description: 'Llumpa',
    state: '02',
    DESCR: 'LLUMPA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '06'
  },
  {
    id: 1066,
    provinceId: 187,
    description: 'Ninabamba',
    state: '06',
    DESCR: 'NINABAMBA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 1067,
    provinceId: 188,
    description: 'Ollantaytambo',
    state: '07',
    DESCR: 'OLLANTAYTAMBO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '06'
  },
  {
    id: 1068,
    provinceId: 189,
    description: 'Tinicachi',
    state: '20',
    DESCR: 'TINICACHI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 1069,
    provinceId: 190,
    description: 'Congas',
    state: '02',
    DESCR: 'CONGAS',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '05'
  },
  {
    id: 1070,
    provinceId: 191,
    description: 'Lacabamba',
    state: '02',
    DESCR: 'LACABAMBA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 1071,
    provinceId: 193,
    description: 'Marca',
    state: '02',
    DESCR: 'MARCA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '04'
  },
  {
    id: 1072,
    provinceId: 194,
    description: 'Nepeña',
    state: '02',
    DESCR: 'NEPEÑA',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '05'
  },
  {
    id: 1073,
    provinceId: 195,
    description: 'Huayllabamba',
    state: '02',
    DESCR: 'HUAYLLABAMBA',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '04'
  },
  {
    id: 1074,
    provinceId: 196,
    description: 'Ranrahirca',
    state: '02',
    DESCR: 'RANRAHIRCA',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '06'
  },
  {
    id: 1075,
    provinceId: 1,
    description: 'Granada',
    state: '01',
    DESCR: 'GRANADA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1076,
    provinceId: 2,
    description: 'La libertad',
    state: '02',
    DESCR: 'LA LIBERTAD',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1077,
    provinceId: 3,
    description: 'Pichirhua',
    state: '03',
    DESCR: 'PICHIRHUA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1078,
    provinceId: 4,
    description: 'Jacobo hunter',
    state: '04',
    DESCR: 'JACOBO HUNTER',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '27'
  },
  {
    id: 1079,
    provinceId: 5,
    description: 'Pacaycasa',
    state: '05',
    DESCR: 'PACAYCASA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1080,
    provinceId: 6,
    description: 'Llacanora',
    state: '06',
    DESCR: 'LLACANORA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1081,
    provinceId: 8,
    description: 'Saylla',
    state: '07',
    DESCR: 'SAYLLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1082,
    provinceId: 9,
    description: 'Huayllahuara',
    state: '08',
    DESCR: 'HUAYLLAHUARA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1083,
    provinceId: 10,
    description: 'San francisco de cayran',
    state: '09',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06',
    DESCR: 'SAN FCO DE CAYRAN'
  },
  {
    id: 1084,
    provinceId: 11,
    description: 'Pueblo nuevo',
    state: '12',
    DESCR: 'PUEBLO NUEVO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 1085,
    provinceId: 12,
    description: 'Chilca',
    state: '11',
    DESCR: 'CHILCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1086,
    provinceId: 13,
    description: 'Moche',
    state: '12',
    DESCR: 'MOCHE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '04'
  },
  {
    id: 1087,
    provinceId: 14,
    description: 'Lagunas',
    state: '15',
    DESCR: 'LAGUNAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 1088,
    provinceId: 16,
    description: 'Napo',
    state: '15',
    DESCR: 'NAPO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1089,
    provinceId: 19,
    description: 'Paucartambo',
    state: '18',
    DESCR: 'PAUCARTAMBO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1090,
    provinceId: 20,
    description: 'Cura Mori',
    state: '19',
    DESCR: 'CURA MORI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1091,
    provinceId: 21,
    description: 'Coata',
    state: '20',
    DESCR: 'COATA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1092,
    provinceId: 23,
    description: 'Palca',
    state: '08',
    DESCR: 'PALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1093,
    provinceId: 28,
    description: 'Kishuara',
    state: '03',
    DESCR: 'KISHUARA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1094,
    provinceId: 29,
    description: 'Quilca',
    state: '04',
    DESCR: 'QUILCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1095,
    provinceId: 32,
    description: 'Sangarara',
    state: '07',
    DESCR: 'SANGARARA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 1096,
    provinceId: 33,
    description: 'Pomacocha',
    state: '03',
    DESCR: 'POMACOCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '14'
  },
  {
    id: 1097,
    provinceId: 34,
    description: 'San rafael',
    state: '09',
    DESCR: 'SAN RAFAEL',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1098,
    provinceId: 35,
    description: 'Pueblo nuevo',
    state: '12',
    DESCR: 'PUEBLO NUEVO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 1099,
    provinceId: 36,
    description: 'Heroinas toledo',
    state: '11',
    DESCR: 'HEROINAS TOLEDO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1100,
    provinceId: 37,
    description: 'Santiago de Cao',
    state: '12',
    DESCR: 'SANTIAGO DE CAO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '04'
  },
  {
    id: 1101,
    provinceId: 40,
    description: 'Manseriche',
    state: '15',
    DESCR: 'MANSERICHE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '04'
  },
  {
    id: 1102,
    provinceId: 42,
    description: 'Matalaque',
    state: '17',
    DESCR: 'MATALAQUE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1103,
    provinceId: 43,
    description: 'Tapuc',
    state: '18',
    DESCR: 'TAPUC',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1104,
    provinceId: 44,
    description: 'Paimas',
    state: '19',
    DESCR: 'PAIMAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1105,
    provinceId: 45,
    description: 'Jose domingo choquehuanca',
    state: '20',
    DESCR: 'JOSE DOMINGO CHOQUEHUANCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1106,
    provinceId: 50,
    description: 'Jazan',
    state: '01',
    DESCR: 'JAZAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1107,
    provinceId: 52,
    description: 'Sabaino',
    state: '03',
    DESCR: 'SABAINO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1108,
    provinceId: 53,
    description: 'Chala',
    state: '04',
    DESCR: 'CHALA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1109,
    provinceId: 55,
    description: 'Miguel iglesias',
    state: '06',
    DESCR: 'MIGUEL IGLESIAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1110,
    provinceId: 56,
    description: 'Mollepata',
    state: '07',
    DESCR: 'MOLLEPATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 1111,
    provinceId: 57,
    description: 'Huanca-huanca',
    state: '08',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07',
    DESCR: 'HUANCA HUANCA'
  },
  {
    id: 1112,
    provinceId: 58,
    description: 'Chuquis',
    state: '09',
    DESCR: 'CHUQUIS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1113,
    provinceId: 62,
    description: 'Motupe',
    state: '13',
    DESCR: 'MOTUPE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1114,
    provinceId: 67,
    description: 'Villa rica',
    state: '18',
    DESCR: 'VILLA RICA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 1115,
    provinceId: 68,
    description: 'Sóndor',
    state: '19',
    DESCR: 'SONDOR',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 1116,
    provinceId: 69,
    description: 'Ituata',
    state: '20',
    DESCR: 'ITUATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1117,
    provinceId: 76,
    description: 'Huayllo',
    state: '03',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07',
    DESCR: 'IHUAYLLO'
  },
  {
    id: 1118,
    provinceId: 77,
    description: 'Huancarqui',
    state: '04',
    DESCR: 'HUANCARQUI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1119,
    provinceId: 78,
    description: 'Sivia',
    state: '05',
    DESCR: 'SIVIA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1120,
    provinceId: 79,
    description: 'Cochabamba',
    state: '02',
    DESCR: 'COCHABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '03'
  },
  {
    id: 1121,
    provinceId: 80,
    description: 'Taray',
    state: '07',
    DESCR: 'TARAY',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1122,
    provinceId: 81,
    description: 'Huachos',
    state: '08',
    DESCR: 'HUACHOS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1123,
    provinceId: 84,
    description: 'El mantaro',
    state: '11',
    DESCR: 'EL MANTARO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1124,
    provinceId: 86,
    description: 'Santa rosa de quives',
    state: '14',
    DESCR: 'SANTA ROSA DE QUIVES',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1125,
    provinceId: 88,
    description: 'San Juan de Bigote',
    state: '19',
    DESCR: 'SAN JUAN DE BIGOTE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1126,
    provinceId: 89,
    description: 'Zepita',
    state: '20',
    DESCR: 'ZEPITA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1127,
    provinceId: 91,
    description: 'Tarucachi',
    state: '22',
    DESCR: 'TARUCACHI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '12'
  },
  {
    id: 1128,
    provinceId: 93,
    description: 'Longuita',
    state: '01',
    DESCR: 'LONGUITA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1129,
    provinceId: 94,
    description: 'Colquioc',
    state: '02',
    DESCR: 'COLQUIOC',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '23'
  },
  {
    id: 1130,
    provinceId: 96,
    description: 'Huambo',
    state: '01',
    DESCR: 'HUAMBO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 1131,
    provinceId: 97,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1132,
    provinceId: 98,
    description: 'Tantarica',
    state: '06',
    DESCR: 'TANTARICA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1133,
    provinceId: 99,
    description: 'Quehue',
    state: '07',
    DESCR: 'QUEHUE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1134,
    provinceId: 100,
    description: 'Paucarbamba',
    state: '08',
    DESCR: 'PAUCARBAMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1135,
    provinceId: 101,
    description: 'Monzon',
    state: '09',
    DESCR: 'MONZON',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1136,
    provinceId: 102,
    description: 'San clemente',
    state: '10',
    DESCR: 'SAN CLEMENTE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1137,
    provinceId: 105,
    description: 'Imperial',
    state: '14',
    DESCR: 'IMPERIAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 1138,
    provinceId: 106,
    description: 'Saquena',
    state: '15',
    DESCR: 'SAQUENA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1139,
    provinceId: 107,
    description: 'Vichayal',
    state: '19',
    DESCR: 'VICHAYAL',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1140,
    provinceId: 109,
    description: 'Rumisapa',
    state: '21',
    DESCR: 'RUMISAPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1141,
    provinceId: 110,
    description: 'Mariscal benavides',
    state: '01',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08',
    DESCR: 'MCAL BENAVIDES'
  },
  {
    id: 1142,
    provinceId: 111,
    description: 'Pariahuanca',
    state: '02',
    DESCR: 'PARIAHUANCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1143,
    provinceId: 112,
    description: 'Uranmarca',
    state: '03',
    DESCR: 'URANMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1144,
    provinceId: 113,
    description: 'Salamanca',
    state: '04',
    DESCR: 'SALAMANCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1145,
    provinceId: 114,
    description: 'Huac-huas',
    state: '05',
    DESCR: 'HUAC-HUAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '10'
  },
  {
    id: 1146,
    provinceId: 115,
    description: 'Querocotillo',
    state: '06',
    DESCR: 'QUEROCOTILLO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1147,
    provinceId: 116,
    description: 'San pedro',
    state: '02',
    DESCR: 'SAN PEDRO',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '09'
  },
  {
    id: 1148,
    provinceId: 117,
    description: 'Pilpichaca',
    state: '08',
    DESCR: 'PILPICHACA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1149,
    provinceId: 119,
    description: 'Pampa Hermoza',
    state: '15',
    DESCR: 'PAMPA HERMOZA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 1150,
    provinceId: 121,
    description: 'Lampian',
    state: '14',
    DESCR: 'LAMPIAN',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 1151,
    provinceId: 123,
    description: 'Querecotillo',
    state: '19',
    DESCR: 'QUERECOTILLO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '06'
  },
  {
    id: 1152,
    provinceId: 124,
    description: 'Taraco',
    state: '20',
    DESCR: 'TARACO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1153,
    provinceId: 126,
    description: 'Yamon',
    state: '01',
    DESCR: 'YAMON',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1154,
    provinceId: 128,
    description: 'Pataypampa',
    state: '03',
    DESCR: 'PATAYPAMPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1155,
    provinceId: 130,
    description: 'San francisco de ravacayc',
    state: '05',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '15',
    DESCR: 'SAN FCO DE RAVACAYCO'
  },
  {
    id: 1156,
    provinceId: 132,
    description: 'Quiñota',
    state: '07',
    DESCR: 'QUINOTA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1157,
    provinceId: 133,
    description: 'Huachocolpa',
    state: '08',
    DESCR: 'HUACHOCOLPA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1158,
    provinceId: 135,
    description: 'Palcamayo',
    state: '11',
    DESCR: 'PALCAMAYO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1159,
    provinceId: 137,
    description: 'Huachupampa',
    state: '14',
    DESCR: 'HUACHUPAMPA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '30'
  },
  {
    id: 1160,
    provinceId: 140,
    description: 'Paratia',
    state: '20',
    DESCR: 'PARATIA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1161,
    provinceId: 141,
    description: 'San hilarion',
    state: '21',
    DESCR: 'SAN HILARION',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '07'
  },
  {
    id: 1162,
    provinceId: 143,
    description: 'Quechualla',
    state: '04',
    DESCR: 'QUECHUALLA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 1163,
    provinceId: 144,
    description: 'Pararca',
    state: '05',
    DESCR: 'PARARCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 1164,
    provinceId: 145,
    description: 'Pomahuaca',
    state: '06',
    DESCR: 'POMAHUACA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 1165,
    provinceId: 146,
    description: 'Suyckutambo',
    state: '07',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07',
    DESCR: 'SUYKUTAMBO'
  },
  {
    id: 1166,
    provinceId: 148,
    description: 'Huay-Huay',
    state: '11',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '03',
    DESCR: 'HUAY HUAY'
  },
  {
    id: 1167,
    provinceId: 149,
    description: 'Ongon',
    state: '12',
    DESCR: 'ONGON',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1168,
    provinceId: 150,
    description: 'Leoncio prado',
    state: '14',
    DESCR: 'LEONCIO PRADO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1169,
    provinceId: 152,
    description: 'Orurillo',
    state: '20',
    DESCR: 'ORURILLO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1170,
    provinceId: 153,
    description: 'San fernando',
    state: '21',
    DESCR: 'SAN FERNANDO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1171,
    provinceId: 154,
    description: 'Yupan',
    state: '02',
    DESCR: 'YUPAN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1172,
    provinceId: 155,
    description: 'Paico',
    state: '05',
    DESCR: 'PAICO',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05'
  },
  {
    id: 1173,
    provinceId: 156,
    description: 'Tabaconas',
    state: '06',
    DESCR: 'TABACONAS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '07'
  },
  {
    id: 1174,
    provinceId: 157,
    description: 'Kimbiri',
    state: '07',
    DESCR: 'KIMBIRI',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '09'
  },
  {
    id: 1175,
    provinceId: 159,
    description: 'San Juan de Jarpa',
    state: '11',
    DESCR: 'SAN JUAN DE JARPA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '07'
  },
  {
    id: 1176,
    provinceId: 160,
    description: 'Sarin',
    state: '12',
    DESCR: 'SARIN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1177,
    provinceId: 163,
    description: 'Huimbayoc',
    state: '21',
    DESCR: 'HUIMBAYOC',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '09'
  },
  {
    id: 1178,
    provinceId: 164,
    description: 'Huachis',
    state: '02',
    DESCR: 'HUACHIS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 1179,
    provinceId: 165,
    description: 'Colca',
    state: '05',
    DESCR: 'COLCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1180,
    provinceId: 166,
    description: 'Jose sabogal',
    state: '06',
    DESCR: 'JOSE SABOGAL',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '06'
  },
  {
    id: 1181,
    provinceId: 167,
    description: 'Paccaritambo',
    state: '07',
    DESCR: 'PACCARITAMBO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '08'
  },
  {
    id: 1182,
    provinceId: 168,
    description: 'San migual de cauri',
    state: '09',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05',
    DESCR: 'SAN MIGUEL DE CAURI'
  },
  {
    id: 1183,
    provinceId: 169,
    description: 'Santa cruz de chuca',
    state: '12',
    DESCR: 'SANTA CRUZ DE CHUCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1184,
    provinceId: 170,
    description: 'Carania',
    state: '14',
    DESCR: 'CARANIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1185,
    provinceId: 174,
    description: 'Saurama',
    state: '05',
    DESCR: 'SAURAMA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '07'
  },
  {
    id: 1186,
    provinceId: 175,
    description: 'Llapa',
    state: '06',
    DESCR: 'LLAPA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '04'
  },
  {
    id: 1187,
    provinceId: 177,
    description: 'Pampamarca',
    state: '04',
    DESCR: 'PAMPAMARCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '05'
  },
  {
    id: 1188,
    provinceId: 181,
    description: 'Pueblo libre',
    state: '02',
    DESCR: 'PUEBLO LIBRE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1189,
    provinceId: 183,
    description: 'Huaro',
    state: '07',
    DESCR: 'HUARO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '07'
  },
  {
    id: 1190,
    provinceId: 185,
    description: 'San juan del oro',
    state: '20',
    DESCR: 'SAN JUAN DEL ORO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1191,
    provinceId: 186,
    description: 'Lucma',
    state: '02',
    DESCR: 'LUCMA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '03'
  },
  {
    id: 1192,
    provinceId: 187,
    description: 'Pulan',
    state: '06',
    DESCR: 'PULAN',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '06'
  },
  {
    id: 1193,
    provinceId: 188,
    description: 'Yucay',
    state: '07',
    DESCR: 'YUCAY',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '07'
  },
  {
    id: 1194,
    provinceId: 189,
    description: 'Unicachi',
    state: '20',
    DESCR: 'UNICACHI',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '02'
  },
  {
    id: 1195,
    provinceId: 190,
    description: 'Llipa',
    state: '02',
    DESCR: 'LLIPA',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '06'
  },
  {
    id: 1196,
    provinceId: 191,
    description: 'Llapo',
    state: '02',
    DESCR: 'LLAPO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 1197,
    provinceId: 193,
    description: 'Pampas chico',
    state: '02',
    DESCR: 'PAMPAS CHICO',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '05'
  },
  {
    id: 1198,
    provinceId: 194,
    description: 'Samanco',
    state: '02',
    DESCR: 'SAMANCO',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '06'
  },
  {
    id: 1199,
    provinceId: 195,
    description: 'Quiches',
    state: '02',
    DESCR: 'QUICHES',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '05'
  },
  {
    id: 1200,
    provinceId: 196,
    description: 'Shupluy',
    state: '02',
    DESCR: 'SHUPLUY',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '07'
  },
  {
    id: 1201,
    provinceId: 1,
    description: 'Huancas',
    state: '01',
    DESCR: 'HUANCAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1202,
    provinceId: 2,
    description: 'Olleros',
    state: '01',
    DESCR: 'OLLEROS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1203,
    provinceId: 3,
    description: 'San pedro de cachora',
    state: '03',
    DESCR: 'SAN PEDRO DE CACHORA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1204,
    provinceId: 4,
    description: 'La joya',
    state: '04',
    DESCR: 'LA JOYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1205,
    provinceId: 5,
    description: 'Quinua',
    state: '05',
    DESCR: 'QUINUA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1206,
    provinceId: 6,
    description: 'Los baños del inca',
    state: '06',
    DESCR: 'LOS BANOS DEL INCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1207,
    provinceId: 8,
    description: 'Wanchaq',
    state: '07',
    DESCR: 'WANCHAQ',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1208,
    provinceId: 9,
    description: 'Izcuchaca',
    state: '08',
    DESCR: 'IZCUCHACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1209,
    provinceId: 10,
    description: 'San pedro de chaulan',
    state: '09',
    DESCR: 'SAN PEDRO DE CHAULAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1210,
    provinceId: 11,
    description: 'Salas',
    state: '10',
    DESCR: 'SALAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1211,
    provinceId: 12,
    description: 'Chongos altos',
    state: '11',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09',
    DESCR: 'CHONGOS ALTO'
  },
  {
    id: 1212,
    provinceId: 13,
    description: 'Poroto',
    state: '12',
    DESCR: 'POROTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1213,
    provinceId: 14,
    description: 'Monsefu',
    state: '13',
    DESCR: 'MONSEFU',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1214,
    provinceId: 15,
    description: 'Chorrillos',
    state: '14',
    DESCR: 'CHORRILLOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1215,
    provinceId: 16,
    description: 'Punchana',
    state: '15',
    DESCR: 'PUNCHANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1216,
    provinceId: 19,
    description: 'San fco. de asis de yarus',
    state: '18',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09',
    DESCR: 'SAN FCO DE ASIS DE YARUSYACAN'
  },
  {
    id: 1217,
    provinceId: 20,
    description: 'El Tallán',
    state: '19',
    DESCR: 'EL TALLAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1218,
    provinceId: 21,
    description: 'Huata',
    state: '02',
    DESCR: 'HUATA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '03'
  },
  {
    id: 1219,
    provinceId: 23,
    description: 'Pocollay',
    state: '22',
    DESCR: 'POCOLLAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1220,
    provinceId: 28,
    description: 'Pacobamba',
    state: '03',
    DESCR: 'PACOBAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1221,
    provinceId: 29,
    description: 'Samuel pastor',
    state: '04',
    DESCR: 'SAMUEL PASTOR',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1222,
    provinceId: 33,
    description: 'Rosario',
    state: '08',
    DESCR: 'ROSARIO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1223,
    provinceId: 34,
    description: 'Tomay kichwa',
    state: '09',
    DESCR: 'TOMAY KICHWA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1224,
    provinceId: 35,
    description: 'San juan de yanac',
    state: '10',
    DESCR: 'SAN JUAN DE YANAC',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 1225,
    provinceId: 36,
    description: 'Manzanares',
    state: '11',
    DESCR: 'MANZANARES',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1226,
    provinceId: 37,
    description: 'Casa grande',
    state: '12',
    DESCR: 'CASA GRANDE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1227,
    provinceId: 40,
    description: 'Morona',
    state: '15',
    DESCR: 'MORONA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '05'
  },
  {
    id: 1228,
    provinceId: 42,
    description: 'Puquina',
    state: '17',
    DESCR: 'PUQUINA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1229,
    provinceId: 43,
    description: 'Vilcabamba',
    state: '03',
    DESCR: 'VILCABAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1230,
    provinceId: 44,
    description: 'Sapillica',
    state: '19',
    DESCR: 'SAPILLICA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 1231,
    provinceId: 45,
    description: 'Muñani',
    state: '20',
    DESCR: 'MUNANI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1232,
    provinceId: 50,
    description: 'Recta',
    state: '01',
    DESCR: 'RECTA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1233,
    provinceId: 53,
    description: 'Chaparra',
    state: '04',
    DESCR: 'CHAPARRA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1234,
    provinceId: 55,
    description: 'Oxamarca',
    state: '06',
    DESCR: 'OXAMARCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1235,
    provinceId: 56,
    description: 'Pucyura',
    state: '07',
    DESCR: 'PUCYURA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1236,
    provinceId: 57,
    description: 'Huayllay grande',
    state: '08',
    DESCR: 'HUAYLLAY GRANDE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '06'
  },
  {
    id: 1237,
    provinceId: 62,
    description: 'Olmos',
    state: '13',
    DESCR: 'OLMOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1238,
    provinceId: 68,
    description: 'Sondorillo',
    state: '19',
    DESCR: 'SONDORILLO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '05'
  },
  {
    id: 1239,
    provinceId: 69,
    description: 'Ollachea',
    state: '20',
    DESCR: 'OLLACHEA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1240,
    provinceId: 76,
    description: 'Justo apu sahuaraura',
    state: '03',
    DESCR: 'JUSTO APU SAHUARAURA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '17'
  },
  {
    id: 1241,
    provinceId: 77,
    description: 'Machaguay',
    state: '04',
    DESCR: 'MACHAGUAY',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1242,
    provinceId: 78,
    description: 'Llochegua',
    state: '05',
    DESCR: 'LLOCHEGUA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1243,
    provinceId: 79,
    description: 'Conchan',
    state: '06',
    DESCR: 'CONCHAN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04'
  },
  {
    id: 1244,
    provinceId: 80,
    description: 'Yanatile',
    state: '07',
    DESCR: 'YANATILE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1245,
    provinceId: 81,
    description: 'Huamatambo',
    state: '08',
    DESCR: 'HUAMATAMBO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1246,
    provinceId: 84,
    description: 'Huamali',
    state: '11',
    DESCR: 'HUAMALI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1247,
    provinceId: 88,
    description: 'Santa Catalina de Mossa',
    state: '19',
    DESCR: 'SANTA CATALINA DE MOSSA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '06'
  },
  {
    id: 1248,
    provinceId: 91,
    description: 'Ticaco',
    state: '22',
    DESCR: 'TICACO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '13'
  },
  {
    id: 1249,
    provinceId: 93,
    description: 'Lonya chico',
    state: '01',
    DESCR: 'LONYA CHICO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1250,
    provinceId: 94,
    description: 'Huallanca',
    state: '02',
    DESCR: 'HUALLANCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '25'
  },
  {
    id: 1251,
    provinceId: 96,
    description: 'Huanca',
    state: '04',
    DESCR: 'HUANCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1252,
    provinceId: 97,
    description: 'Tambo',
    state: '08',
    DESCR: 'TAMBO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '16'
  },
  {
    id: 1253,
    provinceId: 98,
    description: 'Yonan',
    state: '06',
    DESCR: 'YONAN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1254,
    provinceId: 99,
    description: 'Tupac amaru',
    state: '07',
    DESCR: 'TUPAC AMARU',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1255,
    provinceId: 100,
    description: 'San miguel de mayocc',
    state: '09',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05',
    DESCR: 'SAN MIGUEL DE CAURI'
  },
  {
    id: 1256,
    provinceId: 101,
    description: 'Punchao',
    state: '09',
    DESCR: 'PUNCHAO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1257,
    provinceId: 102,
    description: 'Tupac amaru inca',
    state: '10',
    DESCR: 'TUPAC AMARU INCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1258,
    provinceId: 105,
    description: 'Lunahuana',
    state: '14',
    DESCR: 'LUNAHUANA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1259,
    provinceId: 106,
    description: 'Soplin',
    state: '15',
    DESCR: 'SOPLIN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1260,
    provinceId: 109,
    description: 'San roque de cumbaza',
    state: '21',
    DESCR: 'SAN ROQUE DE CUMBAZA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '16'
  },
  {
    id: 1261,
    provinceId: 110,
    description: 'Milpuc',
    state: '01',
    DESCR: 'MILPUC',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '07'
  },
  {
    id: 1262,
    provinceId: 111,
    description: 'San miguel de aco',
    state: '02',
    DESCR: 'SAN MIGUEL DE ACO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1263,
    provinceId: 112,
    description: 'Ranracancha',
    state: '03',
    DESCR: 'RANRACANCHA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 1264,
    provinceId: 113,
    description: 'Yanaquihua',
    state: '04',
    DESCR: 'YANAQUIHUA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1265,
    provinceId: 114,
    description: 'Laramate',
    state: '05',
    DESCR: 'LARAMATE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '11'
  },
  {
    id: 1266,
    provinceId: 115,
    description: ' san andres de cutervo',
    state: '06',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08',
    DESCR: 'SAN ANDRES DE CUTERVO'
  },
  {
    id: 1267,
    provinceId: 116,
    description: 'Tinta',
    state: '07',
    DESCR: 'TINTA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1268,
    provinceId: 117,
    description: 'Querco',
    state: '08',
    DESCR: 'QUERCO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1269,
    provinceId: 119,
    description: 'Rio Tambo',
    state: '11',
    DESCR: 'RIO TAMBO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 1270,
    provinceId: 120,
    description: 'Mache',
    state: '12',
    DESCR: 'MACHE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '13'
  },
  {
    id: 1271,
    provinceId: 121,
    description: 'Pacaraos',
    state: '14',
    DESCR: 'PACARAOS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1272,
    provinceId: 123,
    description: 'Salitral',
    state: '19',
    DESCR: 'SALITRAL',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1273,
    provinceId: 124,
    description: 'Vilque chico',
    state: '20',
    DESCR: 'VILQUE CHICO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1274,
    provinceId: 128,
    description: 'Progreso',
    state: '03',
    DESCR: 'PROGRESO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07'
  },
  {
    id: 1275,
    provinceId: 130,
    description: 'Upahuacho',
    state: '05',
    DESCR: 'UPAHUACHO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '16'
  },
  {
    id: 1276,
    provinceId: 132,
    description: 'Velille',
    state: '07',
    DESCR: 'VELILLE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 1277,
    provinceId: 133,
    description: 'Huando',
    state: '08',
    DESCR: 'HUANDO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1278,
    provinceId: 135,
    description: 'San Pedro De Cajas',
    state: '11',
    DESCR: 'SAN PEDRO DE CAJAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1279,
    provinceId: 137,
    description: 'Huanza',
    state: '14',
    DESCR: 'HUANZA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1280,
    provinceId: 140,
    description: 'Pucara',
    state: '06',
    DESCR: 'PUCARA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1281,
    provinceId: 141,
    description: 'Shamboyacu',
    state: '21',
    DESCR: 'SHAMBOYACU',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '10'
  },
  {
    id: 1282,
    provinceId: 143,
    description: 'Sayla',
    state: '04',
    DESCR: 'SAYLA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1283,
    provinceId: 144,
    description: 'San javier de alpabamba',
    state: '05',
    DESCR: 'SAN JAVIER DE ALPABAMBA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '08'
  },
  {
    id: 1284,
    provinceId: 145,
    description: 'Pucara',
    state: '06',
    DESCR: 'PUCARA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1285,
    provinceId: 146,
    description: 'Alto pichigua',
    state: '07',
    DESCR: 'ALTO PICHIGUA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1286,
    provinceId: 148,
    description: 'Morococha',
    state: '11',
    DESCR: 'MOROCOCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05'
  },
  {
    id: 1287,
    provinceId: 149,
    description: 'Parcoy',
    state: '12',
    DESCR: 'PARCOY',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1288,
    provinceId: 150,
    description: 'Paccho',
    state: '14',
    DESCR: 'PACCHO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1289,
    provinceId: 152,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1290,
    provinceId: 153,
    description: 'Yorongos',
    state: '21',
    DESCR: 'YORONGOS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '03'
  },
  {
    id: 1291,
    provinceId: 155,
    description: 'San pedro de larcay',
    state: '05',
    DESCR: 'SAN PEDRO DE LARCAY',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '07'
  },
  {
    id: 1292,
    provinceId: 157,
    description: 'Santa teresa',
    state: '07',
    DESCR: 'SANTA TERESA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '06'
  },
  {
    id: 1293,
    provinceId: 159,
    description: 'Yanacancha',
    state: '11',
    DESCR: 'YANACANCHA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '09'
  },
  {
    id: 1294,
    provinceId: 160,
    description: 'Sartimbamba',
    state: '12',
    DESCR: 'SARTIMBAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1295,
    provinceId: 163,
    description: 'Juan guerra',
    state: '21',
    DESCR: 'JUAN GUERRA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1296,
    provinceId: 164,
    description: 'Huantar',
    state: '02',
    DESCR: 'HUANTAR',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 1297,
    provinceId: 165,
    description: 'Huamanquiquia',
    state: '05',
    DESCR: 'HUAMANQUIQUIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '09'
  },
  {
    id: 1298,
    provinceId: 167,
    description: 'Pillpinto',
    state: '07',
    DESCR: 'PILLPINTO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '09'
  },
  {
    id: 1299,
    provinceId: 169,
    description: 'Sitabamba',
    state: '12',
    DESCR: 'SITABAMBA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1300,
    provinceId: 170,
    description: 'Catahuasi',
    state: '14',
    DESCR: 'CATAHUASI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '33'
  },
  {
    id: 1301,
    provinceId: 174,
    description: 'Vischongo',
    state: '05',
    DESCR: 'VISCHONGO',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '02'
  },
  {
    id: 1302,
    provinceId: 175,
    description: 'Nanchoc',
    state: '06',
    DESCR: 'NANCHOC',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '05'
  },
  {
    id: 1303,
    provinceId: 177,
    description: 'Choras',
    state: '09',
    DESCR: 'CHORAS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '08'
  },
  {
    id: 1304,
    provinceId: 181,
    description: 'Santa cruz',
    state: '15',
    DESCR: 'SANTA CRUZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1305,
    provinceId: 183,
    description: 'Lucre',
    state: '03',
    DESCR: 'LUCRE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1306,
    provinceId: 185,
    description: 'Yanahuaya',
    state: '20',
    DESCR: 'YANAHUAYA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '10'
  },
  {
    id: 1307,
    provinceId: 186,
    description: 'Musga',
    state: '02',
    DESCR: 'MUSGA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '07'
  },
  {
    id: 1308,
    provinceId: 187,
    description: 'Saucepampa',
    state: '06',
    DESCR: 'SAUCEPAMPA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '11'
  },
  {
    id: 1309,
    provinceId: 190,
    description: 'San cristobal de rajan',
    state: '02',
    DESCR: 'SAN CRISTOBAL DE RAJAN',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '08'
  },
  {
    id: 1310,
    provinceId: 191,
    description: 'Pallasca',
    state: '02',
    DESCR: 'PALLASCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '08'
  },
  {
    id: 1311,
    provinceId: 193,
    description: 'Pararin',
    state: '02',
    DESCR: 'PARARIN',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '06'
  },
  {
    id: 1312,
    provinceId: 194,
    description: 'Santa',
    state: '02',
    DESCR: 'SANTA',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '07'
  },
  {
    id: 1313,
    provinceId: 195,
    description: 'Ragash',
    state: '02',
    DESCR: 'RAGASH',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '09'
  },
  {
    id: 1314,
    provinceId: 196,
    description: 'Yanama',
    state: '02',
    DESCR: 'YANAMA',
    MBO_PROVINCIA: '15',
    MBO_DISTRITO: '08'
  },
  {
    id: 1315,
    provinceId: 1,
    description: 'La jalca',
    state: '01',
    DESCR: 'LA JALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1316,
    provinceId: 2,
    description: 'Pampas',
    state: '02',
    DESCR: 'PAMPAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1317,
    provinceId: 3,
    description: 'Tamburco',
    state: '03',
    DESCR: 'TAMBURCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1318,
    provinceId: 4,
    description: 'Mariano melgar',
    state: '04',
    DESCR: 'MARIANO MELGAR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '26'
  },
  {
    id: 1319,
    provinceId: 5,
    description: 'San jose de ticllas',
    state: '05',
    DESCR: 'SAN JOSE DE TICLLAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1320,
    provinceId: 6,
    description: 'Magdalena',
    state: '06',
    DESCR: 'MAGDALENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1321,
    provinceId: 9,
    description: 'Laria',
    state: '08',
    DESCR: 'LARIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1322,
    provinceId: 10,
    description: 'Santa maria del valle',
    state: '09',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08',
    DESCR: 'STA MARIA DEL VALLE'
  },
  {
    id: 1323,
    provinceId: 11,
    description: 'San jose de los molinos',
    state: '10',
    DESCR: 'SAN JOSE DE LOS MOLINOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1324,
    provinceId: 13,
    description: 'Salaverry',
    state: '12',
    DESCR: 'SALAVERRY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1325,
    provinceId: 14,
    description: 'Nueva arica',
    state: '13',
    DESCR: 'NUEVA ARICA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1326,
    provinceId: 15,
    description: 'Cieneguilla',
    state: '14',
    DESCR: 'CIENEGUILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '39'
  },
  {
    id: 1327,
    provinceId: 16,
    description: 'Putumayo',
    state: '15',
    DESCR: 'PUTUMAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1328,
    provinceId: 19,
    description: 'Simon bolivar',
    state: '18',
    DESCR: 'SIMON BOLIVAR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1329,
    provinceId: 20,
    description: 'La Arena',
    state: '19',
    DESCR: 'LA ARENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1330,
    provinceId: 21,
    description: 'Mañazo',
    state: '20',
    DESCR: 'MANAZO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1331,
    provinceId: 23,
    description: 'Sama',
    state: '22',
    DESCR: 'SAMA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1332,
    provinceId: 28,
    description: 'Pacucha',
    state: '03',
    DESCR: 'PACUCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '13'
  },
  {
    id: 1333,
    provinceId: 35,
    description: 'San pedro de huacarpana',
    state: '10',
    DESCR: 'SAN PEDRO DE HUACARPANA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '06'
  },
  {
    id: 1334,
    provinceId: 36,
    description: 'Mariscal castilla',
    state: '01',
    DESCR: 'MARISCAL CASTILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1335,
    provinceId: 40,
    description: 'Pastaza',
    state: '15',
    DESCR: 'PASTAZA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '06'
  },
  {
    id: 1336,
    provinceId: 42,
    description: 'Quinistaquillas',
    state: '17',
    DESCR: 'QUINISTAQUILLAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '09'
  },
  {
    id: 1337,
    provinceId: 44,
    description: 'Sícchez',
    state: '19',
    DESCR: 'SICCHEZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1338,
    provinceId: 45,
    description: 'Potoni',
    state: '20',
    DESCR: 'POTONI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1339,
    provinceId: 50,
    description: 'San carlos',
    state: '01',
    DESCR: 'SAN CARLOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1340,
    provinceId: 53,
    description: 'Huanuhuanu',
    state: '04',
    DESCR: 'HUANUHUANU',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1341,
    provinceId: 55,
    description: 'Sorochuco',
    state: '06',
    DESCR: 'SOROCHUCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1342,
    provinceId: 56,
    description: 'Zurite',
    state: '07',
    DESCR: 'ZURITE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '07'
  },
  {
    id: 1343,
    provinceId: 57,
    description: 'Julcamarca',
    state: '08',
    DESCR: 'JULCAMARCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1344,
    provinceId: 62,
    description: 'Pacora',
    state: '13',
    DESCR: 'PACORA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1345,
    provinceId: 69,
    description: 'San gaban',
    state: '20',
    DESCR: 'SAN GABAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1346,
    provinceId: 76,
    description: 'Lucre',
    state: '03',
    DESCR: 'LUCRE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1347,
    provinceId: 77,
    description: 'Orcopampa',
    state: '04',
    DESCR: 'ORCOPAMPA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1348,
    provinceId: 79,
    description: 'Huambos',
    state: '06',
    DESCR: 'HUAMBOS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '08'
  },
  {
    id: 1349,
    provinceId: 81,
    description: 'Mollepampa',
    state: '08',
    DESCR: 'MOLLEPAMPA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '14'
  },
  {
    id: 1350,
    provinceId: 84,
    description: 'Huaripampa',
    state: '11',
    DESCR: 'HUARIPAMPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1351,
    provinceId: 88,
    description: 'Santo Domingo',
    state: '19',
    DESCR: 'SANTO DOMINGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1352,
    provinceId: 93,
    description: 'Luya',
    state: '01',
    DESCR: 'LUYA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1353,
    provinceId: 94,
    description: 'Huasta',
    state: '02',
    DESCR: 'HUASTA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1354,
    provinceId: 96,
    description: 'Ichupampa',
    state: '04',
    DESCR: 'ICHUPAMPA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '09'
  },
  {
    id: 1355,
    provinceId: 100,
    description: 'San pedro de coris',
    state: '08',
    DESCR: 'SAN PEDRO DE CORIS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '09'
  },
  {
    id: 1356,
    provinceId: 101,
    description: 'Puños',
    state: '09',
    DESCR: 'PUNOS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1357,
    provinceId: 105,
    description: 'Mala',
    state: '14',
    DESCR: 'MALA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1358,
    provinceId: 106,
    description: 'Tapiche',
    state: '15',
    DESCR: 'TAPICHE',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1359,
    provinceId: 109,
    description: 'Shanao',
    state: '21',
    DESCR: 'SHANAO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1360,
    provinceId: 110,
    description: 'Omia',
    state: '01',
    DESCR: 'OMIA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1361,
    provinceId: 111,
    description: 'Shilla',
    state: '02',
    DESCR: 'SHILLA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1362,
    provinceId: 114,
    description: 'Leoncio prado',
    state: '14',
    DESCR: 'LEONCIO PRADO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1363,
    provinceId: 115,
    description: 'San juan de cutervo',
    state: '06',
    DESCR: 'SAN JUAN DE CUTERVO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1364,
    provinceId: 117,
    description: 'Quito-arma',
    state: '08',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '09',
    DESCR: 'QUITO ARMA'
  },
  {
    id: 1365,
    provinceId: 121,
    description: 'San miguel de acos',
    state: '14',
    DESCR: 'SAN MIGUEL DE ACOS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '09'
  },
  {
    id: 1366,
    provinceId: 128,
    description: 'San antonio',
    state: '14',
    DESCR: 'SAN ANTONIO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1367,
    provinceId: 133,
    description: 'Huaribamba',
    state: '08',
    DESCR: 'HUARIBAMBA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '12'
  },
  {
    id: 1368,
    provinceId: 135,
    description: 'Tapo',
    state: '11',
    DESCR: 'TAPO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '09'
  },
  {
    id: 1369,
    provinceId: 137,
    description: 'Huarochiri',
    state: '14',
    DESCR: 'HUAROCHIRI',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '09'
  },
  {
    id: 1370,
    provinceId: 140,
    description: 'Santa lucia',
    state: '05',
    DESCR: 'SANTA LUCIA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '25'
  },
  {
    id: 1371,
    provinceId: 141,
    description: 'Tingo de ponasa',
    state: '21',
    DESCR: 'TINGO DE PONASA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 1372,
    provinceId: 143,
    description: 'Tauria',
    state: '04',
    DESCR: 'TAURIA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '09'
  },
  {
    id: 1373,
    provinceId: 144,
    description: 'San jose de ushua',
    state: '05',
    DESCR: 'SAN JOSE DE USHUA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '09'
  },
  {
    id: 1374,
    provinceId: 145,
    description: 'Sallique',
    state: '06',
    DESCR: 'SALLIQUE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '07'
  },
  {
    id: 1375,
    provinceId: 148,
    description: 'Marca Pomacocha',
    state: '11',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '04',
    DESCR: 'MARCAPOMACOCHA'
  },
  {
    id: 1376,
    provinceId: 149,
    description: 'Pataz',
    state: '12',
    DESCR: 'PATAZ',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '09'
  },
  {
    id: 1377,
    provinceId: 150,
    description: 'Santa leonor',
    state: '14',
    DESCR: 'SANTA LEONOR',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '11'
  },
  {
    id: 1378,
    provinceId: 152,
    description: 'Umachiri',
    state: '20',
    DESCR: 'UMACHIRI',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '09'
  },
  {
    id: 1379,
    provinceId: 153,
    description: 'Yuracyacu',
    state: '21',
    DESCR: 'YURACYACU',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '04'
  },
  {
    id: 1380,
    provinceId: 155,
    description: 'San salvador de quije',
    state: '05',
    DESCR: 'SAN SALVADOR DE QUIJE',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '04'
  },
  {
    id: 1381,
    provinceId: 157,
    description: 'Vilcabamba',
    state: '03',
    DESCR: 'VILCABAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1382,
    provinceId: 159,
    description: 'San Juan de Iscos',
    state: '11',
    DESCR: 'SAN JUAN DE ISCOS',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '06'
  },
  {
    id: 1383,
    provinceId: 163,
    description: 'La banda de shilcayo',
    state: '21',
    DESCR: 'LA BANDA DE SHILCAYO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '21'
  },
  {
    id: 1384,
    provinceId: 164,
    description: 'Masin',
    state: '02',
    DESCR: 'MASIN',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1385,
    provinceId: 165,
    description: 'Huancaraylla',
    state: '05',
    DESCR: 'HUANCARAYLLA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '10'
  },
  {
    id: 1386,
    provinceId: 167,
    description: 'Yaurisque',
    state: '07',
    DESCR: 'YAURISQUE',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 1387,
    provinceId: 170,
    description: 'Chocos',
    state: '14',
    DESCR: 'CHOCOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '10'
  },
  {
    id: 1388,
    provinceId: 175,
    description: 'Niepos',
    state: '06',
    DESCR: 'NIEPOS',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '06'
  },
  {
    id: 1389,
    provinceId: 181,
    description: 'Santo toribio',
    state: '02',
    DESCR: 'SANTO TORIBIO',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '10'
  },
  {
    id: 1390,
    provinceId: 183,
    description: 'Marcapata',
    state: '07',
    DESCR: 'MARCAPATA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '09'
  },
  {
    id: 1391,
    provinceId: 185,
    description: 'Alto inambari',
    state: '20',
    DESCR: 'ALTO INAMBARI',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '11'
  },
  {
    id: 1392,
    provinceId: 187,
    description: 'Sexi',
    state: '06',
    DESCR: 'SEXI',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '07'
  },
  {
    id: 1393,
    provinceId: 190,
    description: 'San pedro',
    state: '02',
    DESCR: 'SAN PEDRO',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '09'
  },
  {
    id: 1394,
    provinceId: 191,
    description: 'Pampas',
    state: '02',
    DESCR: 'PAMPAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1395,
    provinceId: 193,
    description: 'Tapacocha',
    state: '02',
    DESCR: 'TAPACOCHA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '07'
  },
  {
    id: 1396,
    provinceId: 194,
    description: 'Nuevo chimbote',
    state: '02',
    DESCR: 'NUEVO CHIMBOTE',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '09'
  },
  {
    id: 1397,
    provinceId: 195,
    description: 'San juan',
    state: '02',
    DESCR: 'SAN JUAN',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '10'
  },
  {
    id: 1398,
    provinceId: 1,
    description: 'Leimebamba',
    state: '01',
    DESCR: 'LEIMEBAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1399,
    provinceId: 2,
    description: 'Pariacoto',
    state: '02',
    DESCR: 'PARIACOTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1400,
    provinceId: 4,
    description: 'Miraflores',
    state: '04',
    DESCR: 'MIRAFLORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1401,
    provinceId: 5,
    description: 'San juan bautista',
    state: '05',
    DESCR: 'SAN JUAN BAUTISTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1402,
    provinceId: 6,
    description: 'Matara',
    state: '06',
    DESCR: 'MATARA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1403,
    provinceId: 9,
    description: 'Manta',
    state: '08',
    DESCR: 'MANTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1404,
    provinceId: 10,
    description: 'Yarumayo',
    state: '09',
    DESCR: 'YARUMAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1405,
    provinceId: 11,
    description: 'San juan bautista',
    state: '05',
    DESCR: 'SAN JUAN BAUTISTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1406,
    provinceId: 13,
    description: 'Simbal',
    state: '12',
    DESCR: 'SIMBAL',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1407,
    provinceId: 14,
    description: 'Oyotun',
    state: '13',
    DESCR: 'OYOTUN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1408,
    provinceId: 15,
    description: 'Comas',
    state: '11',
    DESCR: 'COMAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '04'
  },
  {
    id: 1409,
    provinceId: 16,
    description: 'Torres causana',
    state: '15',
    DESCR: 'TORRES CAUSANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1410,
    provinceId: 19,
    description: 'Ticlacayan',
    state: '18',
    DESCR: 'TICLACAYAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1411,
    provinceId: 20,
    description: 'La Unión',
    state: '09',
    DESCR: 'LA UNION',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '01'
  },
  {
    id: 1412,
    provinceId: 21,
    description: 'Paucarcolla',
    state: '20',
    DESCR: 'PAUCARCOLLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1413,
    provinceId: 23,
    description: 'Coronel Gregorio Albarrac',
    state: '22',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13',
    DESCR: 'COR GREG ALBARR L.ALF UGARTE'
  },
  {
    id: 1414,
    provinceId: 28,
    description: 'Pampachiri',
    state: '03',
    DESCR: 'PAMPACHIRI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '08'
  },
  {
    id: 1415,
    provinceId: 35,
    description: 'Sunampe',
    state: '10',
    DESCR: 'SUNAMPE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '07'
  },
  {
    id: 1416,
    provinceId: 36,
    description: 'Matahuasi',
    state: '11',
    DESCR: 'MATAHUASI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1417,
    provinceId: 40,
    description: 'Santa cruz',
    state: '15',
    DESCR: 'SANTA CRUZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1418,
    provinceId: 42,
    description: 'Ubinas',
    state: '17',
    DESCR: 'UBINAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1419,
    provinceId: 44,
    description: 'Suyo',
    state: '19',
    DESCR: 'SUYO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1420,
    provinceId: 45,
    description: 'Saman',
    state: '20',
    DESCR: 'SAMAN',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '12'
  },
  {
    id: 1421,
    provinceId: 50,
    description: 'Shipasbamba',
    state: '01',
    DESCR: 'SHIPASBAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1422,
    provinceId: 53,
    description: 'Jaqui',
    state: '04',
    DESCR: 'JAQUI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1423,
    provinceId: 55,
    description: 'Sucre',
    state: '06',
    DESCR: 'SUCRE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10'
  },
  {
    id: 1424,
    provinceId: 57,
    description: 'San antonio de antaparco',
    state: '08',
    DESCR: 'SAN ANTONIO DE ANTAPARCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1425,
    provinceId: 62,
    description: 'Salas',
    state: '10',
    DESCR: 'SALAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1426,
    provinceId: 69,
    description: 'Usicayos',
    state: '20',
    DESCR: 'USICAYOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10'
  },
  {
    id: 1427,
    provinceId: 76,
    description: 'Pocohuanca',
    state: '03',
    DESCR: 'POCOHUANCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '09'
  },
  {
    id: 1428,
    provinceId: 77,
    description: 'Pampacolca',
    state: '04',
    DESCR: 'PAMPACOLCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '10'
  },
  {
    id: 1429,
    provinceId: 79,
    description: 'Lajas',
    state: '06',
    DESCR: 'LAJAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '09'
  },
  {
    id: 1430,
    provinceId: 81,
    description: 'San juan',
    state: '02',
    DESCR: 'SAN JUAN',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '10'
  },
  {
    id: 1431,
    provinceId: 84,
    description: 'Huertas',
    state: '11',
    DESCR: 'HUERTAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1432,
    provinceId: 88,
    description: 'Yamango',
    state: '19',
    DESCR: 'YAMANGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1433,
    provinceId: 93,
    description: 'Luya viejo',
    state: '01',
    DESCR: 'LUYA VIEJO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1434,
    provinceId: 94,
    description: 'Huayllacayan',
    state: '02',
    DESCR: 'HUAYLLACAYAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10'
  },
  {
    id: 1435,
    provinceId: 96,
    description: 'Lari',
    state: '04',
    DESCR: 'LARI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1436,
    provinceId: 100,
    description: 'Pachamarca',
    state: '08',
    DESCR: 'PACHAMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '10'
  },
  {
    id: 1437,
    provinceId: 101,
    description: 'Singa',
    state: '09',
    DESCR: 'SINGA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1438,
    provinceId: 105,
    description: 'Nuevo imperial',
    state: '14',
    DESCR: 'NUEVO IMPERIAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1439,
    provinceId: 106,
    description: 'Jenaro herrera',
    state: '15',
    DESCR: 'JENARO HERRERA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1440,
    provinceId: 109,
    description: 'Tabalosos',
    state: '21',
    DESCR: 'TABALOSOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '13'
  },
  {
    id: 1441,
    provinceId: 110,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1442,
    provinceId: 111,
    description: 'Tinco',
    state: '02',
    DESCR: 'TINCO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1443,
    provinceId: 114,
    description: 'Llauta',
    state: '05',
    DESCR: 'LLAUTA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '14'
  },
  {
    id: 1444,
    provinceId: 115,
    description: 'San luis de lucma',
    state: '06',
    DESCR: 'SAN LUIS DE LUCMA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '10'
  },
  {
    id: 1445,
    provinceId: 117,
    description: 'San antonio de cusicancha',
    state: '08',
    DESCR: 'SAN ANTONIO DE CUSICANCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1446,
    provinceId: 120,
    description: 'Paranday',
    state: '12',
    DESCR: 'PARANDAY',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '08'
  },
  {
    id: 1447,
    provinceId: 121,
    description: 'Santa cruz de andamarca',
    state: '14',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '11',
    DESCR: 'STA CRUZ DE ANDAMARCA'
  },
  {
    id: 1448,
    provinceId: 128,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1449,
    provinceId: 133,
    description: 'Ñahuimpuquio',
    state: '08',
    DESCR: 'NAHUIMPUQUIO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '15'
  },
  {
    id: 1450,
    provinceId: 137,
    description: 'Lahuaytambo',
    state: '14',
    DESCR: 'LAHUAYTAMBO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1451,
    provinceId: 140,
    description: 'Vilavila',
    state: '20',
    DESCR: 'VILAVILA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1452,
    provinceId: 141,
    description: 'Tres unidos',
    state: '21',
    DESCR: 'TRES UNIDOS',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '09'
  },
  {
    id: 1453,
    provinceId: 143,
    description: 'Tomepampa',
    state: '04',
    DESCR: 'TOMEPAMPA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '10'
  },
  {
    id: 1454,
    provinceId: 144,
    description: 'Sara sara',
    state: '05',
    DESCR: 'SARA SARA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '10'
  },
  {
    id: 1455,
    provinceId: 145,
    description: 'San felipe',
    state: '06',
    DESCR: 'SAN FELIPE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '08'
  },
  {
    id: 1456,
    provinceId: 148,
    description: 'Santa Bárbara de Carhuaca',
    state: '11',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '07',
    DESCR: 'STA BARBARA DE CARHUACAYAN'
  },
  {
    id: 1457,
    provinceId: 149,
    description: 'Pias',
    state: '12',
    DESCR: 'PIAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1458,
    provinceId: 150,
    description: 'Santa maria',
    state: '14',
    DESCR: 'SANTA MARIA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '12'
  },
  {
    id: 1459,
    provinceId: 155,
    description: 'Santiago de paucaray',
    state: '05',
    DESCR: 'SANTIAGO DE PAUCARAY',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '06'
  },
  {
    id: 1460,
    provinceId: 157,
    description: 'Pichari',
    state: '07',
    DESCR: 'PICHARI',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '10'
  },
  {
    id: 1461,
    provinceId: 163,
    description: 'Morales',
    state: '21',
    DESCR: 'MORALES',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1462,
    provinceId: 164,
    description: 'Paucas',
    state: '02',
    DESCR: 'PAUCAS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '09'
  },
  {
    id: 1463,
    provinceId: 165,
    description: 'Huaya',
    state: '05',
    DESCR: 'HUAYA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 1464,
    provinceId: 170,
    description: 'Cochas',
    state: '14',
    DESCR: 'COCHAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '08'
  },
  {
    id: 1465,
    provinceId: 175,
    description: 'San gregorio',
    state: '06',
    DESCR: 'SAN GREGORIO',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '07'
  },
  {
    id: 1466,
    provinceId: 181,
    description: 'Yuracmarca',
    state: '02',
    DESCR: 'YURACMARCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '09'
  },
  {
    id: 1467,
    provinceId: 183,
    description: 'Ocongate',
    state: '07',
    DESCR: 'OCONGATE',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '10'
  },
  {
    id: 1468,
    provinceId: 185,
    description: 'San Pedro de Putina Punco',
    state: '20',
    DESCR: 'SAN PEDRO DE PUTINA PUNCO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '12'
  },
  {
    id: 1469,
    provinceId: 187,
    description: 'Uticyacu',
    state: '06',
    DESCR: 'UTICYACU',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 1470,
    provinceId: 190,
    description: 'Santiago de chilcas',
    state: '02',
    DESCR: 'SANTIAGO DE CHILCAS',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '10'
  },
  {
    id: 1471,
    provinceId: 191,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1472,
    provinceId: 193,
    description: 'Ticapampa',
    state: '02',
    DESCR: 'TICAPAMPA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '08'
  },
  {
    id: 1473,
    provinceId: 195,
    description: 'Sicsibamba',
    state: '02',
    DESCR: 'SICSIBAMBA',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '06'
  },
  {
    id: 1474,
    provinceId: 1,
    description: 'Levanto',
    state: '01',
    DESCR: 'LEVANTO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1475,
    provinceId: 2,
    description: 'Pira',
    state: '02',
    DESCR: 'PIRA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1476,
    provinceId: 4,
    description: 'Mollebaya',
    state: '04',
    DESCR: 'MOLLEBAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1477,
    provinceId: 5,
    description: 'Santiago de pischa',
    state: '05',
    DESCR: 'SANTIAGO DE PISCHA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '08'
  },
  {
    id: 1478,
    provinceId: 6,
    description: 'Namora',
    state: '06',
    DESCR: 'NAMORA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1479,
    provinceId: 9,
    description: 'Mariscal caceres',
    state: '04',
    DESCR: 'MARISCAL CACERES',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '04'
  },
  {
    id: 1480,
    provinceId: 10,
    description: 'PILLCO MARCA',
    state: '09',
    DESCR: 'PILLCO MARCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1481,
    provinceId: 11,
    description: 'Santiago',
    state: '07',
    DESCR: 'SANTIAGO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '06'
  },
  {
    id: 1482,
    provinceId: 12,
    description: 'Chupuro',
    state: '11',
    DESCR: 'CHUPURO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1483,
    provinceId: 13,
    description: 'Victor Larco Herrera',
    state: '12',
    DESCR: 'VICTOR LARCO HERRERA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1484,
    provinceId: 14,
    description: 'Picsi',
    state: '13',
    DESCR: 'PICSI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1485,
    provinceId: 15,
    description: 'El Agustino',
    state: '14',
    DESCR: 'EL AGUSTINO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '35'
  },
  {
    id: 1486,
    provinceId: 16,
    description: 'Yaquerana',
    state: '15',
    DESCR: 'YAQUERANA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1487,
    provinceId: 19,
    description: 'Tinyahuarco',
    state: '18',
    DESCR: 'TINYAHUARCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1488,
    provinceId: 20,
    description: 'Las Lomas',
    state: '19',
    DESCR: 'LAS LOMAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1489,
    provinceId: 21,
    description: 'Pichacani',
    state: '20',
    DESCR: 'PICHACANI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1490,
    provinceId: 28,
    description: 'Pomacocha',
    state: '03',
    DESCR: 'POMACOCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '14'
  },
  {
    id: 1491,
    provinceId: 35,
    description: 'Tambo de mora',
    state: '10',
    DESCR: 'TAMBO DE MORA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '08'
  },
  {
    id: 1492,
    provinceId: 36,
    description: 'Mito',
    state: '11',
    DESCR: 'MITO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 1493,
    provinceId: 40,
    description: 'Teniente cesar lopez roja',
    state: '15',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11',
    DESCR: 'TNTE CESAR LOPEZ ROJAS'
  },
  {
    id: 1494,
    provinceId: 42,
    description: 'Yunga',
    state: '17',
    DESCR: 'YUNGA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 1495,
    provinceId: 45,
    description: 'San anton',
    state: '20',
    DESCR: 'SAN ANTON',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '13'
  },
  {
    id: 1496,
    provinceId: 50,
    description: 'Valera',
    state: '01',
    DESCR: 'VALERA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10'
  },
  {
    id: 1497,
    provinceId: 53,
    description: 'Lomas',
    state: '04',
    DESCR: 'LOMAS',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1498,
    provinceId: 55,
    description: 'Utco',
    state: '06',
    DESCR: 'UTCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1499,
    provinceId: 57,
    description: 'Santo tomas de pata',
    state: '08',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10',
    DESCR: 'STO TOMAS DE PATA'
  },
  {
    id: 1500,
    provinceId: 58,
    description: 'Marias',
    state: '09',
    DESCR: 'MARIAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1501,
    provinceId: 62,
    description: 'San jose',
    state: '12',
    DESCR: 'SAN JOSE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1502,
    provinceId: 76,
    description: 'San juan de chacña',
    state: '03',
    DESCR: 'SAN JUAN DE CHACNA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '16'
  },
  {
    id: 1503,
    provinceId: 77,
    description: 'Tipan',
    state: '04',
    DESCR: 'TIPAN',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '11'
  },
  {
    id: 1504,
    provinceId: 79,
    description: 'Llama',
    state: '02',
    DESCR: 'LLAMA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '05'
  },
  {
    id: 1505,
    provinceId: 81,
    description: 'Santa ana',
    state: '07',
    DESCR: 'SANTA ANA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '01'
  },
  {
    id: 1506,
    provinceId: 84,
    description: 'Janjaillo',
    state: '11',
    DESCR: 'JANJAILLO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '10'
  },
  {
    id: 1507,
    provinceId: 93,
    description: 'Maria',
    state: '01',
    DESCR: 'MARIA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1508,
    provinceId: 94,
    description: 'La primavera',
    state: '02',
    DESCR: 'LA PRIMAVERA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '24'
  },
  {
    id: 1509,
    provinceId: 96,
    description: 'Lluta',
    state: '04',
    DESCR: 'LLUTA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 1510,
    provinceId: 101,
    description: 'Tantamayo',
    state: '09',
    DESCR: 'TANTAMAYO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1511,
    provinceId: 105,
    description: 'Pacaran',
    state: '14',
    DESCR: 'PACARAN',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1512,
    provinceId: 106,
    description: 'Yaquerana',
    state: '15',
    DESCR: 'YAQUERANA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1513,
    provinceId: 109,
    description: 'Zapatero',
    state: '21',
    DESCR: 'ZAPATERO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '14'
  },
  {
    id: 1514,
    provinceId: 110,
    description: 'Totora',
    state: '01',
    DESCR: 'TOTORA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '11'
  },
  {
    id: 1515,
    provinceId: 111,
    description: 'Yungar',
    state: '02',
    DESCR: 'YUNGAR',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1516,
    provinceId: 114,
    description: 'Lucanas',
    state: '05',
    DESCR: 'LUCANAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '13'
  },
  {
    id: 1517,
    provinceId: 115,
    description: 'Santa cruz',
    state: '15',
    DESCR: 'SANTA CRUZ',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10'
  },
  {
    id: 1518,
    provinceId: 117,
    description: 'San francisco de sangayai',
    state: '08',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11',
    DESCR: 'SAN FRANCISCO DE SANGAYAICO'
  },
  {
    id: 1519,
    provinceId: 120,
    description: 'Salpo',
    state: '12',
    DESCR: 'SALPO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09'
  },
  {
    id: 1520,
    provinceId: 121,
    description: 'Sumbilca',
    state: '14',
    DESCR: 'SUMBILCA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '12'
  },
  {
    id: 1521,
    provinceId: 128,
    description: 'Turpay',
    state: '03',
    DESCR: 'TURPAY',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '10'
  },
  {
    id: 1522,
    provinceId: 133,
    description: 'Pazos',
    state: '08',
    DESCR: 'PAZOS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '17'
  },
  {
    id: 1523,
    provinceId: 137,
    description: 'Langa',
    state: '14',
    DESCR: 'LANGA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1524,
    provinceId: 143,
    description: 'Toro',
    state: '04',
    DESCR: 'TORO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '11'
  },
  {
    id: 1525,
    provinceId: 145,
    description: 'San jose del alto',
    state: '06',
    DESCR: 'SAN JOSE DEL ALTO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '09'
  },
  {
    id: 1526,
    provinceId: 149,
    description: 'Santiago de Challas',
    state: '12',
    DESCR: 'SANTIAGO DE CHALLAS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '13'
  },
  {
    id: 1527,
    provinceId: 150,
    description: 'Sayan',
    state: '14',
    DESCR: 'SAYAN',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '13'
  },
  {
    id: 1528,
    provinceId: 155,
    description: 'Soras',
    state: '05',
    DESCR: 'SORAS',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '08'
  },
  {
    id: 1529,
    provinceId: 163,
    description: 'Papaplaya',
    state: '21',
    DESCR: 'PAPAPLAYA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1530,
    provinceId: 164,
    description: 'Ponto',
    state: '02',
    DESCR: 'PONTO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '10'
  },
  {
    id: 1531,
    provinceId: 165,
    description: 'Sarhua',
    state: '05',
    DESCR: 'SARHUA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '13'
  },
  {
    id: 1532,
    provinceId: 170,
    description: 'Colonia',
    state: '14',
    DESCR: 'COLONIA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '09'
  },
  {
    id: 1533,
    provinceId: 175,
    description: 'San silvestre de cochan',
    state: '06',
    DESCR: 'SAN SILVESTRE DE COCHAN',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '08'
  },
  {
    id: 1534,
    provinceId: 183,
    description: 'Oropesa',
    state: '03',
    DESCR: 'OROPESA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '05'
  },
  {
    id: 1535,
    provinceId: 187,
    description: 'Yauyucan',
    state: '06',
    DESCR: 'YAUYUCAN',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '09'
  },
  {
    id: 1536,
    provinceId: 191,
    description: 'Tauca',
    state: '02',
    DESCR: 'TAUCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '11'
  },
  {
    id: 1537,
    provinceId: 1,
    description: 'Magdalena',
    state: '06',
    DESCR: 'MAGDALENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1538,
    provinceId: 2,
    description: 'Tarica',
    state: '02',
    DESCR: 'TARICA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1539,
    provinceId: 4,
    description: 'Paucarpata',
    state: '04',
    DESCR: 'PAUCARPATA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1540,
    provinceId: 5,
    description: 'Socos',
    state: '05',
    DESCR: 'SOCOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1541,
    provinceId: 6,
    description: 'San juan',
    state: '02',
    DESCR: 'SAN JUAN',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '10'
  },
  {
    id: 1542,
    provinceId: 9,
    description: 'Moya',
    state: '08',
    DESCR: 'MOYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1543,
    provinceId: 11,
    description: 'Subtanjalla',
    state: '10',
    DESCR: 'SUBTANJALLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1544,
    provinceId: 12,
    description: 'Colca',
    state: '05',
    DESCR: 'COLCA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1545,
    provinceId: 14,
    description: 'Pimentel',
    state: '13',
    DESCR: 'PIMENTEL',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1546,
    provinceId: 15,
    description: 'Independencia',
    state: '05',
    DESCR: 'INDEPENDENCIA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '08'
  },
  {
    id: 1547,
    provinceId: 16,
    description: 'Belen',
    state: '05',
    DESCR: 'BELEN',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02'
  },
  {
    id: 1548,
    provinceId: 19,
    description: 'Vicco',
    state: '18',
    DESCR: 'VICCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1549,
    provinceId: 21,
    description: 'Plateria',
    state: '20',
    DESCR: 'PLATERIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1550,
    provinceId: 28,
    description: 'San antonio de cachi',
    state: '03',
    DESCR: 'SAN ANTONIO DE CACHI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '09'
  },
  {
    id: 1551,
    provinceId: 36,
    description: 'Nueve de julio',
    state: '11',
    DESCR: 'NUEVE DE JULIO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '12'
  },
  {
    id: 1552,
    provinceId: 45,
    description: 'San jose',
    state: '12',
    DESCR: 'SAN JOSE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '08'
  },
  {
    id: 1553,
    provinceId: 50,
    description: 'Yambrasbamba',
    state: '01',
    DESCR: 'YAMBRASBAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1554,
    provinceId: 53,
    description: 'Quicacha',
    state: '04',
    DESCR: 'QUICACHA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1555,
    provinceId: 55,
    description: 'La libertad de pallan',
    state: '06',
    DESCR: 'LA LIBERTAD DE PALLAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1556,
    provinceId: 57,
    description: 'Secclla',
    state: '08',
    DESCR: 'SECCLLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1557,
    provinceId: 62,
    description: 'Tucume',
    state: '13',
    DESCR: 'TUCUME',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1558,
    provinceId: 76,
    description: 'Sañayca',
    state: '03',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '10',
    DESCR: 'SANAICA'
  },
  {
    id: 1559,
    provinceId: 77,
    description: 'Uñon',
    state: '04',
    DESCR: 'UNON',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '13'
  },
  {
    id: 1560,
    provinceId: 79,
    description: 'Miracosta',
    state: '06',
    DESCR: 'MIRACOSTA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1561,
    provinceId: 81,
    description: 'Tantara',
    state: '08',
    DESCR: 'TANTARA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '27'
  },
  {
    id: 1562,
    provinceId: 84,
    description: 'Julcan',
    state: '11',
    DESCR: 'JULCAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1563,
    provinceId: 93,
    description: 'Ocalli',
    state: '01',
    DESCR: 'OCALLI',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1564,
    provinceId: 94,
    description: 'Mangas',
    state: '02',
    DESCR: 'MANGAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '13'
  },
  {
    id: 1565,
    provinceId: 96,
    description: 'Maca',
    state: '04',
    DESCR: 'MACA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '12'
  },
  {
    id: 1566,
    provinceId: 105,
    description: 'Quilmana',
    state: '14',
    DESCR: 'QUILMANA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1567,
    provinceId: 110,
    description: 'Vista alegre',
    state: '01',
    DESCR: 'VISTA ALEGRE',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '12'
  },
  {
    id: 1568,
    provinceId: 114,
    description: 'Ocaña',
    state: '05',
    DESCR: 'OCANA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '16'
  },
  {
    id: 1569,
    provinceId: 115,
    description: 'Santo domingo de la capil',
    state: '08',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '15',
    DESCR: 'SANTO DOMINGO DE CAPILLA'
  },
  {
    id: 1570,
    provinceId: 117,
    description: 'San isidro',
    state: '08',
    DESCR: 'SAN ISIDRO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1571,
    provinceId: 121,
    description: 'Veintisiete de noviembre',
    state: '14',
    DESCR: 'VEINTISIETE DE NOVIEMBRE',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '10'
  },
  {
    id: 1572,
    provinceId: 128,
    description: 'Vilcabamba',
    state: '03',
    DESCR: 'VILCABAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1573,
    provinceId: 137,
    description: 'Laraos',
    state: '14',
    DESCR: 'LARAOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '16'
  },
  {
    id: 1574,
    provinceId: 145,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1575,
    provinceId: 149,
    description: 'Taurija',
    state: '12',
    DESCR: 'TAURIJA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '11'
  },
  {
    id: 1576,
    provinceId: 150,
    description: 'Vegueta',
    state: '14',
    DESCR: 'VEGUETA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '16'
  },
  {
    id: 1577,
    provinceId: 163,
    description: 'San antonio',
    state: '14',
    DESCR: 'SAN ANTONIO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1578,
    provinceId: 164,
    description: 'Rahuapampa',
    state: '02',
    DESCR: 'RAHUAPAMPA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '11'
  },
  {
    id: 1579,
    provinceId: 165,
    description: 'Vilcanchos',
    state: '05',
    DESCR: 'VILCANCHOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '14'
  },
  {
    id: 1580,
    provinceId: 170,
    description: 'Hongos',
    state: '14',
    DESCR: 'HONGOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '30'
  },
  {
    id: 1581,
    provinceId: 175,
    description: 'Tongod',
    state: '06',
    DESCR: 'TONGOD',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '11'
  },
  {
    id: 1582,
    provinceId: 183,
    description: 'Quiquijana',
    state: '07',
    DESCR: 'QUIQUIJANA',
    MBO_PROVINCIA: '12',
    MBO_DISTRITO: '12'
  },
  {
    id: 1583,
    provinceId: 1,
    description: 'Mariscal castilla',
    state: '01',
    DESCR: 'MARISCAL CASTILLA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1584,
    provinceId: 4,
    description: 'Pocsi',
    state: '04',
    DESCR: 'POCSI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1585,
    provinceId: 5,
    description: 'Tambillo',
    state: '05',
    DESCR: 'TAMBILLO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1586,
    provinceId: 9,
    description: 'Nuevo occoro',
    state: '08',
    DESCR: 'NUEVO OCCORO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1587,
    provinceId: 11,
    description: 'Tate',
    state: '10',
    DESCR: 'TATE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1588,
    provinceId: 12,
    description: 'Cullhuas',
    state: '11',
    DESCR: 'CULLHUAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '05'
  },
  {
    id: 1589,
    provinceId: 14,
    description: 'Reque',
    state: '13',
    DESCR: 'REQUE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1590,
    provinceId: 15,
    description: 'Jesus Maria',
    state: '14',
    DESCR: 'JESUS MARIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '33'
  },
  {
    id: 1591,
    provinceId: 16,
    description: 'San Juan Bautista',
    state: '05',
    DESCR: 'SAN JUAN BAUTISTA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1592,
    provinceId: 19,
    description: 'Yanacancha',
    state: '11',
    DESCR: 'YANACANCHA',
    MBO_PROVINCIA: '09',
    MBO_DISTRITO: '09'
  },
  {
    id: 1593,
    provinceId: 21,
    description: 'San antonio',
    state: '14',
    DESCR: 'SAN ANTONIO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1594,
    provinceId: 28,
    description: 'San jeronimo',
    state: '01',
    DESCR: 'SAN JERONIMO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '17'
  },
  {
    id: 1595,
    provinceId: 36,
    description: 'Orcotuna',
    state: '11',
    DESCR: 'ORCOTUNA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '13'
  },
  {
    id: 1596,
    provinceId: 45,
    description: 'San juan de salinas',
    state: '20',
    DESCR: 'SAN JUAN DE SALINAS',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '15'
  },
  {
    id: 1597,
    provinceId: 53,
    description: 'Yauca',
    state: '04',
    DESCR: 'YAUCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '13'
  },
  {
    id: 1598,
    provinceId: 58,
    description: 'Pachas',
    state: '09',
    DESCR: 'PACHAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '14'
  },
  {
    id: 1599,
    provinceId: 76,
    description: 'Soraya',
    state: '03',
    DESCR: 'SORAYA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '11'
  },
  {
    id: 1600,
    provinceId: 77,
    description: 'Uraca',
    state: '04',
    DESCR: 'URACA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '12'
  },
  {
    id: 1601,
    provinceId: 79,
    description: 'Paccha',
    state: '06',
    DESCR: 'PACCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1602,
    provinceId: 81,
    description: 'Ticrapo',
    state: '08',
    DESCR: 'TICRAPO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '28'
  },
  {
    id: 1603,
    provinceId: 84,
    description: 'Leonor ordoñez',
    state: '11',
    DESCR: 'LEONOR ORDONEZ',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1604,
    provinceId: 93,
    description: 'Ocumal',
    state: '01',
    DESCR: 'OCUMAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '13'
  },
  {
    id: 1605,
    provinceId: 94,
    description: 'Pacllon',
    state: '02',
    DESCR: 'PACLLON',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '15'
  },
  {
    id: 1606,
    provinceId: 96,
    description: 'Madrigal',
    state: '04',
    DESCR: 'MADRIGAL',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '13'
  },
  {
    id: 1607,
    provinceId: 105,
    description: 'San antonio',
    state: '14',
    DESCR: 'SAN ANTONIO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1608,
    provinceId: 114,
    description: 'Otoca',
    state: '05',
    DESCR: 'OTOCA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '17'
  },
  {
    id: 1609,
    provinceId: 115,
    description: 'Santo tomas',
    state: '06',
    DESCR: 'SANTO TOMAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '13'
  },
  {
    id: 1610,
    provinceId: 117,
    description: 'Santiago de chocorvos',
    state: '08',
    DESCR: 'SANTIAGO DE CHOCORVOS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '13'
  },
  {
    id: 1611,
    provinceId: 120,
    description: 'Sinsicap',
    state: '12',
    DESCR: 'SINSICAP',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '10'
  },
  {
    id: 1612,
    provinceId: 128,
    description: 'Virundo',
    state: '03',
    DESCR: 'VIRUNDO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1613,
    provinceId: 133,
    description: 'Quishuar',
    state: '08',
    DESCR: 'QUISHUAR',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '18'
  },
  {
    id: 1614,
    provinceId: 137,
    description: 'Mariatana',
    state: '14',
    DESCR: 'MARIATANA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1615,
    provinceId: 149,
    description: 'Urpay',
    state: '12',
    DESCR: 'URPAY',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1616,
    provinceId: 163,
    description: 'Sauce',
    state: '21',
    DESCR: 'SAUCE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '19'
  },
  {
    id: 1617,
    provinceId: 164,
    description: 'Rapayan',
    state: '02',
    DESCR: 'RAPAYAN',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '12'
  },
  {
    id: 1618,
    provinceId: 170,
    description: 'Huampara',
    state: '14',
    DESCR: 'HUAMPARA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '11'
  },
  {
    id: 1619,
    provinceId: 175,
    description: 'Union agua blanca',
    state: '06',
    DESCR: 'UNION AGUA BLANCA',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '10'
  },
  {
    id: 1620,
    provinceId: 191,
    description: 'Inaco',
    state: '02',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '12',
    DESCR: 'INACO'
  },
  {
    id: 1621,
    provinceId: 1,
    description: 'Molinopampa',
    state: '01',
    DESCR: 'MOLINOPAMPA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1622,
    provinceId: 4,
    description: 'Polobaya',
    state: '04',
    DESCR: 'POLOBAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1623,
    provinceId: 5,
    description: 'Vinchos',
    state: '05',
    DESCR: 'VINCHOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09'
  },
  {
    id: 1624,
    provinceId: 9,
    description: 'Palca',
    state: '08',
    DESCR: 'PALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1625,
    provinceId: 11,
    description: 'Yauca del rosario',
    state: '10',
    DESCR: 'YAUCA DEL ROSARIO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1626,
    provinceId: 12,
    description: 'El tambo',
    state: '11',
    DESCR: 'EL TAMBO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1627,
    provinceId: 14,
    description: 'Santa rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1628,
    provinceId: 15,
    description: 'La Molina',
    state: '14',
    DESCR: 'LA MOLINA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '10'
  },
  {
    id: 1629,
    provinceId: 16,
    description: 'Teniente Manuel Clavero',
    state: '15',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14',
    DESCR: 'TNTE MANUEL CLAVERO'
  },
  {
    id: 1630,
    provinceId: 20,
    description: 'Tambogrande',
    state: '19',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '09',
    DESCR: 'TAMBO GRANDE'
  },
  {
    id: 1631,
    provinceId: 21,
    description: 'Tiquillaca',
    state: '20',
    DESCR: 'TIQUILLACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1632,
    provinceId: 28,
    description: 'San miguel de chaccrampa',
    state: '03',
    DESCR: 'SAN MIGUEL DE CHACCRAMPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '18'
  },
  {
    id: 1633,
    provinceId: 36,
    description: 'San jose de quero',
    state: '11',
    DESCR: 'SAN JOSE DE QUERO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '15'
  },
  {
    id: 1634,
    provinceId: 45,
    description: 'Santiago de pupuja',
    state: '20',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '16',
    DESCR: 'STGO DE PUPUJA'
  },
  {
    id: 1635,
    provinceId: 76,
    description: 'Tapairihua',
    state: '03',
    DESCR: 'TAPAIRIHUA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '12'
  },
  {
    id: 1636,
    provinceId: 77,
    description: 'Viraco',
    state: '04',
    DESCR: 'VIRACO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '14'
  },
  {
    id: 1637,
    provinceId: 79,
    description: 'Pion',
    state: '06',
    DESCR: 'PION',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '13'
  },
  {
    id: 1638,
    provinceId: 84,
    description: 'Llocllapampa',
    state: '11',
    DESCR: 'LLOCLLAPAMPA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '13'
  },
  {
    id: 1639,
    provinceId: 93,
    description: 'Pisuquia',
    state: '01',
    DESCR: 'PISUQUIA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '14'
  },
  {
    id: 1640,
    provinceId: 94,
    description: 'San miguel de corpanqui',
    state: '02',
    DESCR: 'SAN MIGUEL DE CORPANQUI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '17'
  },
  {
    id: 1641,
    provinceId: 96,
    description: 'San antonio de chuca',
    state: '04',
    DESCR: 'SAN ANTONIO DE CHUCA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '14'
  },
  {
    id: 1642,
    provinceId: 105,
    description: 'San luis',
    state: '02',
    DESCR: 'SAN LUIS',
    MBO_PROVINCIA: '17',
    MBO_DISTRITO: '01'
  },
  {
    id: 1643,
    provinceId: 114,
    description: 'Saisa',
    state: '05',
    DESCR: 'SAISA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '29'
  },
  {
    id: 1644,
    provinceId: 115,
    description: 'Socota',
    state: '06',
    DESCR: 'SOCOTA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '14'
  },
  {
    id: 1645,
    provinceId: 117,
    description: 'Santiago de quirahuara',
    state: '08',
    DESCR: 'SANTIAGO DE QUIRAHUARA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '14'
  },
  {
    id: 1646,
    provinceId: 120,
    description: 'Usquil',
    state: '12',
    DESCR: 'USQUIL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '11'
  },
  {
    id: 1647,
    provinceId: 128,
    description: 'Curasco',
    state: '03',
    DESCR: 'CURASCO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '14'
  },
  {
    id: 1648,
    provinceId: 133,
    description: 'Salcabamba',
    state: '08',
    DESCR: 'SALCABAMBA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '19'
  },
  {
    id: 1649,
    provinceId: 137,
    description: 'Ricardo palma',
    state: '14',
    DESCR: 'RICARDO PALMA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '13'
  },
  {
    id: 1650,
    provinceId: 163,
    description: 'Shapaja',
    state: '21',
    DESCR: 'SHAPAJA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '20'
  },
  {
    id: 1651,
    provinceId: 164,
    description: 'San marcos',
    state: '02',
    DESCR: 'SAN MARCOS',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '13'
  },
  {
    id: 1652,
    provinceId: 170,
    description: 'Huancaya',
    state: '14',
    DESCR: 'HUANCAYA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '12'
  },
  {
    id: 1653,
    provinceId: 191,
    description: 'Cochaconchucos',
    state: '02',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '03',
    DESCR: 'CONCHUCOS'
  },
  {
    id: 1654,
    provinceId: 1,
    description: 'Montevideo',
    state: '01',
    DESCR: 'MONTEVIDEO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1655,
    provinceId: 4,
    description: 'Quequeña',
    state: '04',
    DESCR: 'QUEQUENA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1656,
    provinceId: 5,
    description: 'Jesus Nazareno',
    state: '05',
    DESCR: 'JESUS NAZARENO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1657,
    provinceId: 9,
    description: 'Pilchaca',
    state: '08',
    DESCR: 'PILCHACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1658,
    provinceId: 14,
    description: 'Saña',
    state: '13',
    DESCR: 'SANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1659,
    provinceId: 15,
    description: 'La Victoria',
    state: '13',
    DESCR: 'LA VICTORIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1660,
    provinceId: 21,
    description: 'Vilque',
    state: '20',
    DESCR: 'VILQUE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1661,
    provinceId: 28,
    description: 'Santa maria de chicmo',
    state: '03',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '15',
    DESCR: 'STA MARIA DE CHICMO'
  },
  {
    id: 1662,
    provinceId: 36,
    description: 'Santa rosa de ocopa',
    state: '11',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '14',
    DESCR: 'STA ROSA DE OCOPA'
  },
  {
    id: 1663,
    provinceId: 45,
    description: 'Tirapata',
    state: '20',
    DESCR: 'TIRAPATA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '17'
  },
  {
    id: 1664,
    provinceId: 76,
    description: 'Tintay',
    state: '03',
    DESCR: 'TINTAY',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '13'
  },
  {
    id: 1665,
    provinceId: 79,
    description: 'Querocoto',
    state: '06',
    DESCR: 'QUEROCOTO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '14'
  },
  {
    id: 1666,
    provinceId: 84,
    description: 'Marco',
    state: '11',
    DESCR: 'MARCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '14'
  },
  {
    id: 1667,
    provinceId: 93,
    description: 'Providencia',
    state: '01',
    DESCR: 'PROVIDENCIA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '23'
  },
  {
    id: 1668,
    provinceId: 94,
    description: 'Ticllos',
    state: '02',
    DESCR: 'TICLLOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '20'
  },
  {
    id: 1669,
    provinceId: 96,
    description: 'Sibayo',
    state: '04',
    DESCR: 'SIBAYO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '15'
  },
  {
    id: 1670,
    provinceId: 105,
    description: 'Santa cruz de flores',
    state: '14',
    DESCR: 'SANTA CRUZ DE FLORES',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '14'
  },
  {
    id: 1671,
    provinceId: 114,
    description: 'San cristobal',
    state: '01',
    DESCR: 'SAN CRISTOBAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '15'
  },
  {
    id: 1672,
    provinceId: 115,
    description: 'Toribio casanova',
    state: '06',
    DESCR: 'TORIBIO CASANOVA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '15'
  },
  {
    id: 1673,
    provinceId: 117,
    description: 'Santo domingo de capillas',
    state: '08',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '15',
    DESCR: 'SANTO DOMINGO DE CAPILLA'
  },
  {
    id: 1674,
    provinceId: 133,
    description: 'Salcahuasi',
    state: '08',
    DESCR: 'SALCAHUASI',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '26'
  },
  {
    id: 1675,
    provinceId: 137,
    description: 'San andres de tupicocha',
    state: '14',
    DESCR: 'SAN ANDRES DE TUPICOCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '14'
  },
  {
    id: 1676,
    provinceId: 164,
    description: 'San pedro de chana',
    state: '02',
    DESCR: 'SAN PEDRO DE CHANA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '14'
  },
  {
    id: 1677,
    provinceId: 170,
    description: 'Huangascar',
    state: '14',
    DESCR: 'HUANGASCAR',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '13'
  },
  {
    id: 1678,
    provinceId: 191,
    description: 'Tilaco',
    state: '02',
    MBO_PROVINCIA: '10',
    MBO_DISTRITO: '12',
    DESCR: 'TILACO'
  },
  {
    id: 1679,
    provinceId: 1,
    description: 'Olleros',
    state: '01',
    DESCR: 'OLLEROS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1680,
    provinceId: 4,
    description: 'Sabandia',
    state: '04',
    DESCR: 'SABANDIA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1681,
    provinceId: 9,
    description: 'Vilca',
    state: '08',
    DESCR: 'VILCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '17'
  },
  {
    id: 1682,
    provinceId: 12,
    description: 'Huacrapuquio',
    state: '11',
    DESCR: 'HUACRAPUQUIO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1683,
    provinceId: 14,
    description: 'Cayalti',
    state: '13',
    DESCR: 'CAYALTI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1684,
    provinceId: 15,
    description: 'Lince',
    state: '14',
    DESCR: 'LINCE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '11'
  },
  {
    id: 1685,
    provinceId: 28,
    description: 'Talavera',
    state: '03',
    DESCR: 'TALAVERA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '11'
  },
  {
    id: 1686,
    provinceId: 58,
    description: 'Quivilla',
    state: '09',
    DESCR: 'QUIVILLA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '16'
  },
  {
    id: 1687,
    provinceId: 76,
    description: 'Toraya',
    state: '03',
    DESCR: 'TORAYA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '14'
  },
  {
    id: 1688,
    provinceId: 79,
    description: 'SAN JUAN  DE LICUPIS',
    state: '06',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '19',
    DESCR: 'CHALAMARCA'
  },
  {
    id: 1689,
    provinceId: 84,
    description: 'Masma',
    state: '11',
    DESCR: 'MASMA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '15'
  },
  {
    id: 1690,
    provinceId: 93,
    description: 'San cristobal',
    state: '01',
    DESCR: 'SAN CRISTOBAL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '15'
  },
  {
    id: 1691,
    provinceId: 96,
    description: 'Tapay',
    state: '04',
    DESCR: 'TAPAY',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '16'
  },
  {
    id: 1692,
    provinceId: 105,
    description: 'Zuñiga',
    state: '14',
    DESCR: 'ZUNIGA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '15'
  },
  {
    id: 1693,
    provinceId: 114,
    description: 'San juan',
    state: '02',
    DESCR: 'SAN JUAN',
    MBO_PROVINCIA: '14',
    MBO_DISTRITO: '10'
  },
  {
    id: 1694,
    provinceId: 117,
    description: 'Tambo',
    state: '08',
    DESCR: 'TAMBO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '16'
  },
  {
    id: 1695,
    provinceId: 133,
    description: 'San marcos de rocchac',
    state: '08',
    DESCR: 'SAN MARCOS DE ROCCHAC',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '20'
  },
  {
    id: 1696,
    provinceId: 137,
    description: 'San antonio',
    state: '14',
    DESCR: 'SAN ANTONIO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '12'
  },
  {
    id: 1697,
    provinceId: 164,
    description: 'Uco',
    state: '02',
    DESCR: 'UCO',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '15'
  },
  {
    id: 1698,
    provinceId: 170,
    description: 'Huantan',
    state: '14',
    DESCR: 'HUANTAN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '14'
  },
  {
    id: 1699,
    provinceId: 1,
    description: 'Quinjalca',
    state: '01',
    DESCR: 'QUINJALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '17'
  },
  {
    id: 1700,
    provinceId: 4,
    description: 'Sachaca',
    state: '04',
    DESCR: 'SACHACA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1701,
    provinceId: 9,
    description: 'Yauli',
    state: '08',
    DESCR: 'YAULI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1702,
    provinceId: 12,
    description: 'Hualhuas',
    state: '11',
    DESCR: 'HUALHUAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1703,
    provinceId: 14,
    description: 'Patapo',
    state: '13',
    DESCR: 'PATAPO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '17'
  },
  {
    id: 1704,
    provinceId: 15,
    description: 'Los Olivos',
    state: '14',
    DESCR: 'LOS OLIVOS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '42'
  },
  {
    id: 1705,
    provinceId: 28,
    description: 'Tumay huaraca',
    state: '03',
    DESCR: 'TUMAY HUARACA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '16'
  },
  {
    id: 1706,
    provinceId: 58,
    description: 'Ripan',
    state: '09',
    DESCR: 'RIPAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '17'
  },
  {
    id: 1707,
    provinceId: 76,
    description: 'Yanaca',
    state: '03',
    DESCR: 'YANACA',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '15'
  },
  {
    id: 1708,
    provinceId: 79,
    description: 'Tacabamba',
    state: '06',
    DESCR: 'TACABAMBA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '15'
  },
  {
    id: 1709,
    provinceId: 84,
    description: 'Masma chicche',
    state: '11',
    DESCR: 'MASMA CHICCHE',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '32'
  },
  {
    id: 1710,
    provinceId: 93,
    description: 'San francisco del yeso',
    state: '01',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '16',
    DESCR: 'SAN FRANCISCO DE YESO'
  },
  {
    id: 1711,
    provinceId: 96,
    description: 'Tisco',
    state: '04',
    DESCR: 'TISCO',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '17'
  },
  {
    id: 1712,
    provinceId: 114,
    description: 'San pedro',
    state: '02',
    DESCR: 'SAN PEDRO',
    MBO_PROVINCIA: '20',
    MBO_DISTRITO: '09'
  },
  {
    id: 1713,
    provinceId: 133,
    description: 'Surcubamba',
    state: '08',
    DESCR: 'SURCUBAMBA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '23'
  },
  {
    id: 1714,
    provinceId: 137,
    description: 'San bartolome',
    state: '14',
    DESCR: 'SAN BARTOLOME',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '16'
  },
  {
    id: 1715,
    provinceId: 170,
    description: 'Huañec',
    state: '14',
    DESCR: 'HUANEC',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '15'
  },
  {
    id: 1716,
    provinceId: 1,
    description: 'San francisco de daguas',
    state: '01',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18',
    DESCR: 'SAN FCO DE DAGUAS'
  },
  {
    id: 1717,
    provinceId: 4,
    description: 'San juan de siguas',
    state: '04',
    DESCR: 'SAN JUAN DE SIGUAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '15'
  },
  {
    id: 1718,
    provinceId: 9,
    description: 'Ascensión',
    state: '08',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19',
    DESCR: 'ASCENCION'
  },
  {
    id: 1719,
    provinceId: 14,
    description: 'Pomalca',
    state: '13',
    DESCR: 'POMALCA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1720,
    provinceId: 15,
    description: 'Lurigancho',
    state: '14',
    DESCR: 'LURIGANCHO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '12'
  },
  {
    id: 1721,
    provinceId: 28,
    description: 'Turpo',
    state: '03',
    DESCR: 'TURPO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '12'
  },
  {
    id: 1722,
    provinceId: 79,
    description: 'Tocmoche',
    state: '06',
    DESCR: 'TOCMOCHE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '16'
  },
  {
    id: 1723,
    provinceId: 84,
    description: 'Molinos',
    state: '11',
    DESCR: 'MOLINOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '16'
  },
  {
    id: 1724,
    provinceId: 93,
    description: 'San jeronimo',
    state: '01',
    DESCR: 'SAN JERONIMO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '17'
  },
  {
    id: 1725,
    provinceId: 96,
    description: 'Tuti',
    state: '04',
    DESCR: 'TUTI',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '18'
  },
  {
    id: 1726,
    provinceId: 114,
    description: 'San pedro de palco',
    state: '05',
    DESCR: 'SAN PEDRO DE PALCO',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '31'
  },
  {
    id: 1727,
    provinceId: 133,
    description: 'Tintay puncu',
    state: '08',
    DESCR: 'TINTAY PUNCU',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '25'
  },
  {
    id: 1728,
    provinceId: 137,
    description: 'San damian',
    state: '14',
    DESCR: 'SAN DAMIAN',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '17'
  },
  {
    id: 1729,
    provinceId: 170,
    description: 'Laraos',
    state: '14',
    DESCR: 'LARAOS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '16'
  },
  {
    id: 1730,
    provinceId: 1,
    description: 'San isidro de maino',
    state: '01',
    DESCR: 'SAN ISIDRO DE MAINO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19'
  },
  {
    id: 1731,
    provinceId: 4,
    description: 'San juan de tarucani',
    state: '04',
    DESCR: 'SAN JUAN DE TARUCANI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1732,
    provinceId: 9,
    description: 'Huando',
    state: '08',
    DESCR: 'HUANDO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1733,
    provinceId: 12,
    description: 'Huancan',
    state: '11',
    DESCR: 'HUANCAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1734,
    provinceId: 14,
    description: 'Pucala',
    state: '13',
    DESCR: 'PUCALA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19'
  },
  {
    id: 1735,
    provinceId: 15,
    description: 'Lurin',
    state: '14',
    DESCR: 'LURIN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '13'
  },
  {
    id: 1736,
    provinceId: 28,
    description: 'Kaquiabamba',
    state: '03',
    DESCR: 'KAQUIABAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '19'
  },
  {
    id: 1737,
    provinceId: 79,
    description: 'Chalamarca',
    state: '06',
    DESCR: 'CHALAMARCA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '19'
  },
  {
    id: 1738,
    provinceId: 84,
    description: 'Monobamba',
    state: '11',
    DESCR: 'MONOBAMBA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '17'
  },
  {
    id: 1739,
    provinceId: 93,
    description: 'San juan de lopecancha',
    state: '01',
    DESCR: 'SAN JUAN DE LOPECANCHA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '18'
  },
  {
    id: 1740,
    provinceId: 96,
    description: 'Yanque',
    state: '04',
    DESCR: 'YANQUE',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '19'
  },
  {
    id: 1741,
    provinceId: 114,
    description: 'Sancos',
    state: '05',
    DESCR: 'SANCOS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '20'
  },
  {
    id: 1742,
    provinceId: 137,
    description: 'San juan de iris',
    state: '14',
    DESCR: 'SAN JUAN DE IRIS',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '32'
  },
  {
    id: 1743,
    provinceId: 170,
    description: 'Lincha',
    state: '14',
    DESCR: 'LINCHA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '17'
  },
  {
    id: 1744,
    provinceId: 1,
    description: 'Soloco',
    state: '01',
    DESCR: 'SOLOCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1745,
    provinceId: 4,
    description: 'Santa isabel de siguas',
    state: '04',
    DESCR: 'SANTA ISABEL DE SIGUAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '17'
  },
  {
    id: 1746,
    provinceId: 12,
    description: 'Huasicancha',
    state: '11',
    DESCR: 'HUASICANCHA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19'
  },
  {
    id: 1747,
    provinceId: 14,
    description: 'Tuman',
    state: '13',
    DESCR: 'TUMAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1748,
    provinceId: 15,
    description: 'Magdalena del Mar',
    state: '14',
    DESCR: 'MAGDALENA DEL MAR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '14'
  },
  {
    id: 1749,
    provinceId: 79,
    description: 'Yamaluc',
    state: '06',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '20',
    DESCR: 'YAMALUC'
  },
  {
    id: 1750,
    provinceId: 84,
    description: 'Muqui',
    state: '11',
    DESCR: 'MUQUI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '18'
  },
  {
    id: 1751,
    provinceId: 93,
    description: 'Santa catalina',
    state: '01',
    DESCR: 'SANTA CATALINA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '19'
  },
  {
    id: 1752,
    provinceId: 96,
    description: 'Majes',
    state: '04',
    DESCR: 'MAJES',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '20'
  },
  {
    id: 1753,
    provinceId: 114,
    description: 'Santa ana de huaycahuacho',
    state: '05',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '24',
    DESCR: 'STA ANA DE HUAYCAHUACHO'
  },
  {
    id: 1754,
    provinceId: 137,
    description: 'San juan de tantaranche',
    state: '14',
    DESCR: 'SAN JUAN DE TANTARANCHE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '19'
  },
  {
    id: 1755,
    provinceId: 170,
    description: 'Madean',
    state: '14',
    DESCR: 'MADEAN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '31'
  },
  {
    id: 1756,
    provinceId: 1,
    description: 'Sonche',
    state: '01',
    DESCR: 'SONCHE',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '21'
  },
  {
    id: 1757,
    provinceId: 4,
    description: 'Santa  rita de siguas',
    state: '04',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18',
    DESCR: 'STA RITA DE SIGUAS'
  },
  {
    id: 1758,
    provinceId: 12,
    description: 'Huayucachi',
    state: '11',
    DESCR: 'HUAYUCACHI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1759,
    provinceId: 15,
    description: 'Magdalena Vieja',
    state: '14',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '44',
    DESCR: 'MAGDALENA VIEJA'
  },
  {
    id: 1760,
    provinceId: 58,
    description: 'Shunqui',
    state: '09',
    DESCR: 'SHUNQUI',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '21'
  },
  {
    id: 1761,
    provinceId: 84,
    description: 'Muquiyauyo',
    state: '11',
    DESCR: 'MUQUIYAUYO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '19'
  },
  {
    id: 1762,
    provinceId: 93,
    description: 'Santo tomas',
    state: '06',
    DESCR: 'SANTO TOMAS',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '13'
  },
  {
    id: 1763,
    provinceId: 114,
    description: 'Santa lucia',
    state: '05',
    DESCR: 'SANTA LUCIA',
    MBO_PROVINCIA: '05',
    MBO_DISTRITO: '25'
  },
  {
    id: 1764,
    provinceId: 137,
    description: ' san lorenzo de quinti',
    state: '14',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '20',
    DESCR: 'SAN LORENZO DE QUINTI'
  },
  {
    id: 1765,
    provinceId: 170,
    description: 'Miraflores',
    state: '04',
    DESCR: 'MIRAFLORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1766,
    provinceId: 4,
    description: 'Socabaya',
    state: '04',
    DESCR: 'SOCABAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19'
  },
  {
    id: 1767,
    provinceId: 12,
    description: 'Ingenio',
    state: '11',
    DESCR: 'INGENIO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '21'
  },
  {
    id: 1768,
    provinceId: 15,
    description: 'Miraflores',
    state: '04',
    DESCR: 'MIRAFLORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1769,
    provinceId: 58,
    description: 'Sillapata',
    state: '09',
    DESCR: 'SILLAPATA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '22'
  },
  {
    id: 1770,
    provinceId: 84,
    description: 'Paca',
    state: '11',
    DESCR: 'PACA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '20'
  },
  {
    id: 1771,
    provinceId: 93,
    description: 'Tingo',
    state: '01',
    DESCR: 'TINGO',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '21'
  },
  {
    id: 1772,
    provinceId: 137,
    description: 'San mateo',
    state: '14',
    DESCR: 'SAN MATEO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '21'
  },
  {
    id: 1773,
    provinceId: 170,
    description: 'Omas',
    state: '14',
    DESCR: 'OMAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '19'
  },
  {
    id: 1774,
    provinceId: 4,
    description: 'Tiabaya',
    state: '04',
    DESCR: 'TIABAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1775,
    provinceId: 15,
    description: 'Pachacamac',
    state: '14',
    DESCR: 'PACHACAMAC',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16'
  },
  {
    id: 1776,
    provinceId: 58,
    description: 'Yanas',
    state: '09',
    DESCR: 'YANAS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '23'
  },
  {
    id: 1777,
    provinceId: 84,
    description: 'Paccha',
    state: '06',
    DESCR: 'PACCHA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1778,
    provinceId: 93,
    description: 'Trita',
    state: '01',
    DESCR: 'TRITA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '22'
  },
  {
    id: 1779,
    provinceId: 137,
    description: 'San mateo de otao',
    state: '14',
    DESCR: 'SAN MATEO DE OTAO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '22'
  },
  {
    id: 1780,
    provinceId: 170,
    description: 'Putinza',
    state: '14',
    DESCR: 'PUTINZA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '32'
  },
  {
    id: 1781,
    provinceId: 4,
    description: 'Uchumayo',
    state: '04',
    DESCR: 'UCHUMAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '21'
  },
  {
    id: 1782,
    provinceId: 12,
    description: 'PARIAHUANCA',
    state: '02',
    DESCR: 'PARIAHUANCA',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '07'
  },
  {
    id: 1783,
    provinceId: 15,
    description: 'Pucusana',
    state: '14',
    DESCR: 'PUCUSANA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1784,
    provinceId: 84,
    description: 'Pancán',
    state: '11',
    DESCR: 'PANCAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '22'
  },
  {
    id: 1785,
    provinceId: 137,
    description: 'San pedro de casta',
    state: '14',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '05',
    DESCR: 'CASTA'
  },
  {
    id: 1786,
    provinceId: 170,
    description: 'Quinches',
    state: '14',
    DESCR: 'QUINCHES',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '20'
  },
  {
    id: 1787,
    provinceId: 4,
    description: 'Vitor',
    state: '04',
    DESCR: 'VITOR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '22'
  },
  {
    id: 1788,
    provinceId: 12,
    description: 'Pilcomayo',
    state: '11',
    DESCR: 'PILCOMAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '23'
  },
  {
    id: 1789,
    provinceId: 15,
    description: 'Puente Piedra',
    state: '14',
    DESCR: 'PUENTE PIEDRA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '19'
  },
  {
    id: 1790,
    provinceId: 84,
    description: 'Parco',
    state: '11',
    DESCR: 'PARCO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '23'
  },
  {
    id: 1791,
    provinceId: 137,
    description: 'San pedro de huancayre',
    state: '14',
    DESCR: 'SAN PEDRO DE HUANCAYRE',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '23'
  },
  {
    id: 1792,
    provinceId: 170,
    description: 'Quinocay',
    state: '14',
    DESCR: 'QUINOCAY',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '21'
  },
  {
    id: 1793,
    provinceId: 4,
    description: 'Yanahuara',
    state: '04',
    DESCR: 'YANAHUARA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '23'
  },
  {
    id: 1794,
    provinceId: 12,
    description: 'Pucara',
    state: '06',
    DESCR: 'PUCARA',
    MBO_PROVINCIA: '08',
    MBO_DISTRITO: '06'
  },
  {
    id: 1795,
    provinceId: 15,
    description: 'Punta Hermosa',
    state: '14',
    DESCR: 'PUNTA HERMOSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '20'
  },
  {
    id: 1796,
    provinceId: 84,
    description: 'Pomacancha',
    state: '11',
    DESCR: 'POMACANCHA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '24'
  },
  {
    id: 1797,
    provinceId: 137,
    description: 'Sangallaya',
    state: '14',
    DESCR: 'SANGALLAYA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '18'
  },
  {
    id: 1798,
    provinceId: 170,
    description: 'San joaquin',
    state: '14',
    DESCR: 'SAN JOAQUIN',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '22'
  },
  {
    id: 1799,
    provinceId: 4,
    description: 'Yarabamba',
    state: '04',
    DESCR: 'YARABAMBA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '24'
  },
  {
    id: 1800,
    provinceId: 12,
    description: 'Quichuay',
    state: '11',
    DESCR: 'QUICHUAY',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '25'
  },
  {
    id: 1801,
    provinceId: 15,
    description: 'Punta Negra',
    state: '14',
    DESCR: 'PUNTA NEGRA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '21'
  },
  {
    id: 1802,
    provinceId: 84,
    description: 'Ricrán',
    state: '11',
    DESCR: 'RICRAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '25'
  },
  {
    id: 1803,
    provinceId: 137,
    description: 'Santa cruz de cocachacra',
    state: '14',
    DESCR: 'SANTA CRUZ DE COCACHACRA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '24'
  },
  {
    id: 1804,
    provinceId: 170,
    description: 'San pedro de pilas',
    state: '14',
    DESCR: 'SAN PEDRO DE PILAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '23'
  },
  {
    id: 1805,
    provinceId: 4,
    description: 'Yura',
    state: '04',
    DESCR: 'YURA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '25'
  },
  {
    id: 1806,
    provinceId: 12,
    description: 'Quilcas',
    state: '11',
    DESCR: 'QUILCAS',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '26'
  },
  {
    id: 1807,
    provinceId: 15,
    description: 'Rimac',
    state: '14',
    DESCR: 'RIMAC',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '22'
  },
  {
    id: 1808,
    provinceId: 84,
    description: 'San Lorenzo',
    state: '11',
    DESCR: 'SAN LORENZO',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '26'
  },
  {
    id: 1809,
    provinceId: 137,
    description: 'Santa eulalia',
    state: '14',
    DESCR: 'SANTA EULALIA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '25'
  },
  {
    id: 1810,
    provinceId: 170,
    description: 'Tanta',
    state: '14',
    DESCR: 'TANTA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '24'
  },
  {
    id: 1811,
    provinceId: 4,
    description: 'Jose luis bustamante y ri',
    state: '04',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29',
    DESCR: 'JOSE LUIS BUSTAMANTE Y RIVERO'
  },
  {
    id: 1812,
    provinceId: 12,
    description: 'San agustin',
    state: '11',
    DESCR: 'SAN AGUSTIN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '27'
  },
  {
    id: 1813,
    provinceId: 15,
    description: 'San Bartolo',
    state: '14',
    DESCR: 'SAN BARTOLO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '23'
  },
  {
    id: 1814,
    provinceId: 84,
    description: 'San Pedro de Chunán',
    state: '11',
    DESCR: 'SAN PEDRO DE CHUNAN',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '27'
  },
  {
    id: 1815,
    provinceId: 137,
    description: 'Santiago de anchucaya',
    state: '14',
    DESCR: 'SANTIAGO DE ANCHUCAYA',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '26'
  },
  {
    id: 1816,
    provinceId: 170,
    description: 'Tauripampa',
    state: '14',
    DESCR: 'TAURIPAMPA',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '25'
  },
  {
    id: 1817,
    provinceId: 12,
    description: 'San jeronimo de tunan',
    state: '11',
    DESCR: 'SAN JERONIMO DE TUNAN',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '28'
  },
  {
    id: 1818,
    provinceId: 15,
    description: 'San Borja',
    state: '14',
    DESCR: 'SAN BORJA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '40'
  },
  {
    id: 1819,
    provinceId: 84,
    description: 'Sausa',
    state: '11',
    DESCR: 'SAUSA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '33'
  },
  {
    id: 1820,
    provinceId: 137,
    description: ' santiago de tuna',
    state: '14',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '27',
    DESCR: 'SANTIAGO DE TUNA'
  },
  {
    id: 1821,
    provinceId: 170,
    description: 'Tomas',
    state: '14',
    DESCR: 'TOMAS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '27'
  },
  {
    id: 1822,
    provinceId: 15,
    description: 'San Isidro',
    state: '08',
    DESCR: 'SAN ISIDRO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '12'
  },
  {
    id: 1823,
    provinceId: 84,
    description: 'Sincos',
    state: '11',
    DESCR: 'SINCOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '28'
  },
  {
    id: 1824,
    provinceId: 137,
    description: 'Santo domingo de los olle',
    state: '14',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '28',
    DESCR: 'SANTO DOMINGO DE LOS OLLEROS'
  },
  {
    id: 1825,
    provinceId: 170,
    description: 'Tupe',
    state: '14',
    DESCR: 'TUPE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '26'
  },
  {
    id: 1826,
    provinceId: 12,
    description: 'Saño',
    state: '11',
    DESCR: 'SANO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '32'
  },
  {
    id: 1827,
    provinceId: 15,
    description: 'San Juan de Lurigancho',
    state: '14',
    DESCR: 'SAN JUAN DE LURIGANCHO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '37'
  },
  {
    id: 1828,
    provinceId: 84,
    description: 'Tunan Marca',
    state: '11',
    DESCR: 'TUNAN MARCA',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '29'
  },
  {
    id: 1829,
    provinceId: 137,
    description: 'Surco',
    state: '14',
    DESCR: 'SURCO',
    MBO_PROVINCIA: '06',
    MBO_DISTRITO: '29'
  },
  {
    id: 1830,
    provinceId: 170,
    description: 'Viñac',
    state: '14',
    DESCR: 'VINAC',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '28'
  },
  {
    id: 1831,
    provinceId: 12,
    description: 'Sapallanga',
    state: '11',
    DESCR: 'SAPALLANGA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '33'
  },
  {
    id: 1832,
    provinceId: 15,
    description: 'San Juan de Miraflores',
    state: '14',
    DESCR: 'SAN JUAN DE MIRAFLORES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '36'
  },
  {
    id: 1833,
    provinceId: 84,
    description: 'Yauli',
    state: '08',
    DESCR: 'YAULI',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '18'
  },
  {
    id: 1834,
    provinceId: 170,
    description: 'Vitis',
    state: '14',
    DESCR: 'VITIS',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '29'
  },
  {
    id: 1835,
    provinceId: 12,
    description: 'Sicaya',
    state: '11',
    DESCR: 'SICAYA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '34'
  },
  {
    id: 1836,
    provinceId: 15,
    description: 'San Luis',
    state: '02',
    DESCR: 'SAN LUIS',
    MBO_PROVINCIA: '17',
    MBO_DISTRITO: '01'
  },
  {
    id: 1837,
    provinceId: 84,
    description: 'Yauyos',
    state: '11',
    DESCR: 'YAUYOS',
    MBO_PROVINCIA: '03',
    MBO_DISTRITO: '34'
  },
  {
    id: 1838,
    provinceId: 12,
    description: 'Santo domingo de acobamba',
    state: '11',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '31',
    DESCR: 'STO DOMINGO DE ACOBAMBA'
  },
  {
    id: 1839,
    provinceId: 15,
    description: 'San Martin de Porres',
    state: '14',
    DESCR: 'SAN MARTIN DE PORRES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '26'
  },
  {
    id: 1840,
    provinceId: 12,
    description: 'Viques',
    state: '11',
    DESCR: 'VIQUES',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '36'
  },
  {
    id: 1841,
    provinceId: 15,
    description: 'San Miguel',
    state: '05',
    DESCR: 'SAN MIGUEL',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '01'
  },
  {
    id: 1842,
    provinceId: 15,
    description: 'Santa Anita',
    state: '14',
    DESCR: 'SANTA ANITA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '43'
  },
  {
    id: 1843,
    provinceId: 15,
    description: 'Santa Maria del Mar',
    state: '14',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '28',
    DESCR: 'STA MARIA DEL MAR'
  },
  {
    id: 1844,
    provinceId: 15,
    description: 'Santa Rosa',
    state: '14',
    DESCR: 'SANTA ROSA',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '29'
  },
  {
    id: 1845,
    provinceId: 15,
    description: 'Santiago de Surco',
    state: '14',
    DESCR: 'SANTIAGO DE SURCO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '30'
  },
  {
    id: 1846,
    provinceId: 15,
    description: 'Surquillo',
    state: '14',
    DESCR: 'SURQUILLO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '31'
  },
  {
    id: 1847,
    provinceId: 15,
    description: 'Villa el Salvador',
    state: '14',
    DESCR: 'VILLA EL SALVADOR',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '41'
  },
  {
    id: 1848,
    provinceId: 15,
    description: 'Villa Maria del Triunfo',
    state: '14',
    DESCR: 'VILLA MARIA DEL TRIUNFO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '32'
  },
  {
    id: 1849,
    provinceId: 15,
    description: 'Pueblo Libre',
    state: '02',
    DESCR: 'PUEBLO LIBRE',
    MBO_PROVINCIA: '07',
    MBO_DISTRITO: '07'
  },
  {
    id: 1850,
    provinceId: 11,
    description: 'Aparicio Pomares',
    state: '09',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '02',
    DESCR: 'APARICIO POMARES (CHUPAN)'
  },
  {
    id: 1851,
    provinceId: 178,
    description: 'Compin',
    state: '12',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '05',
    DESCR: 'COMPIN'
  },
  {
    id: 1852,
    provinceId: 15,
    description: 'Chaclacayo',
    state: '14',
    DESCR: 'CHACLACAYO',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '07'
  },
  {
    id: 1853,
    provinceId: 91,
    description: 'Heroes Albarracin',
    state: '22',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '14',
    DESCR: 'HEROES ALBARRACIN'
  },
  {
    id: 1854,
    provinceId: 48,
    description: 'Canoas de Punta Sal',
    state: '23',
    DESCR: 'CANOAS DE PUNTA SAL',
    MBO_PROVINCIA: '02',
    MBO_DISTRITO: '03'
  },
  {
    id: 1855,
    provinceId: 15,
    description: 'Santa Beatriz',
    state: '02',
    MBO_PROVINCIA: '13',
    MBO_DISTRITO: '07',
    DESCR: 'SANTA'
  },
  {
    id: 1856,
    provinceId: 191,
    description: 'Chora',
    state: '09',
    MBO_PROVINCIA: '11',
    MBO_DISTRITO: '08',
    DESCR: 'CHORAS'
  },
  {
    id: 1857,
    provinceId: 100,
    description: 'Cosme',
    state: '05',
    MBO_PROVINCIA: '01',
    MBO_DISTRITO: '16',
    DESCR: 'COSME'
  },
  {
    id: 1858,
    provinceId: 97,
    description: 'Samugari',
    state: '05',
    MBO_PROVINCIA: '04',
    MBO_DISTRITO: '09',
    DESCR: 'SAMUGARI'
  }
];

export { DEPARTMENTS, PROVINCES, DISTRICTS, country };
